import { decimal, timespan, bool, tuple2, int, fromString, datetimeOffset, float, fail, succeed, andThen, oneOf, guid, object, map, string, list as list_4, dict } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { add, ofSeq, map as map_1 } from "./fable_modules/fable-library-js.4.24.0/Map.js";
import { ofList } from "./fable_modules/fable-library-js.4.24.0/Set.js";
import { compare, uncurry3, uncurry2, comparePrimitives } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { decimal as decimal_1, timespan as timespan_1, tuple2 as tuple2_1, toString, list as list_5, datetimeOffset as datetimeOffset_1, guid as guid_1, option, object as object_1, seq, dict as dict_1 } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { choose, map as map_2 } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { FSharpRef, Union, Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { float64_type, decimal_type, bool_type, int32_type, list_type, union_type, class_type, record_type, option_type, string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Activity_DocumentEvidence_$reflection, Activity_FulfillmentEvidence_$reflection, Activity_AttachmentDetails, Activity_DocumentEvidence, Action_ActionDependenciesSet_$reflection, Action_Target_$reflection, Action_Category_$reflection, Action_Fulfillment_$reflection, Action_Fulfillment, Action_ActionDependenciesSet, Action_Scope, Action_ActivityLimits, Action_TargetLimits, Action_Target, Action_TargetingMethod, Action_TargetBy, Action_Category, DomainEntities_$reflection, Document_DirectUploadRevision_$reflection, Document_DirectUploadRevision, Condition_$reflection, Criticality_$reflection, Status_$reflection, Maturity_$reflection, By_$reflection, DomainEntities, Attribute_$reflection, Attribute, Condition as Condition_1, Criticality as Criticality_1, Maturity as Maturity_1, Status as Status_1, By } from "./DomainEvents.fs.js";
import { head, tail, isEmpty, map as map_3, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { tryParse, newGuid } from "./fable_modules/fable-library-js.4.24.0/Guid.js";
import { empty } from "./fable_modules/Thoth.Json.10.4.1/Extra.fs.js";
import { CaseStrategy, ExtraCoders } from "./fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "./fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { split as split_1 } from "./fable_modules/fable-library-js.4.24.0/String.js";

export const labelDecoder = (() => {
    const d = dict((path_1, value_1) => list_4(string, path_1, value_1));
    return (path_2) => ((value_2) => map((table) => map_1((_arg, v) => ofList(v, {
        Compare: comparePrimitives,
    }), table), uncurry2(d), path_2, value_2));
})();

export function labelEncoder(labels) {
    return dict_1(map_1((_arg, v) => seq(map_2((value) => value, v)), labels));
}

export class ProblemDetails extends Record {
    constructor(Type, Title, Detail, Instance) {
        super();
        this.Type = Type;
        this.Title = Title;
        this.Detail = Detail;
        this.Instance = Instance;
    }
}

export function ProblemDetails_$reflection() {
    return record_type("Types.ProblemDetails", [], ProblemDetails, () => [["Type", option_type(string_type)], ["Title", string_type], ["Detail", option_type(string_type)], ["Instance", option_type(string_type)]]);
}

export function ProblemDetails_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg_3;
        let Type;
        const objectArg = get$.Optional;
        Type = objectArg.Field("type", string);
        let Title;
        const objectArg_1 = get$.Required;
        Title = objectArg_1.Field("title", string);
        let Instance;
        const objectArg_2 = get$.Optional;
        Instance = objectArg_2.Field("instance", string);
        return new ProblemDetails(Type, Title, (objectArg_3 = get$.Optional, objectArg_3.Field("detail", string)), Instance);
    }, path_4, v));
}

export function ProblemDetails_Encoder_Z624F5E77(project) {
    return object_1([["type", option((value) => value)(project.Type)], ["title", project.Title], ["detail", option((value_3) => value_3)(project.Detail)], ["instance", option((value_5) => value_5)(project.Instance)]]);
}

export class Project extends Record {
    constructor(ProjectId, Name) {
        super();
        this.ProjectId = ProjectId;
        this.Name = Name;
    }
}

export function Project_$reflection() {
    return record_type("Types.Project", [], Project, () => [["ProjectId", class_type("System.Guid")], ["Name", string_type]]);
}

export function Project_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Project((objectArg = get$.Required, objectArg.Field("projectId", guid)), (objectArg_1 = get$.Required, objectArg_1.Field("name", string)));
    }, path_2, v));
}

export function Project_Encoder_Z7068B00B(project) {
    return object_1([["projectId", guid_1(project.ProjectId)], ["name", project.Name]]);
}

export function EPM_Domain_Events_By__By_get_Decoder_Static() {
    return (path_5) => ((value_3) => oneOf(ofArray([(path_1) => ((v) => object((get$) => {
        let objectArg;
        return new By(0, [(objectArg = get$.Required, objectArg.Field("userId", guid))]);
    }, path_1, v)), (path_4) => ((value_2) => andThen(uncurry3((s) => {
        if (s === "system") {
            return (arg10$0040) => ((arg20$0040) => succeed(new By(1, []), arg10$0040, arg20$0040));
        }
        else {
            return (path_3) => ((arg20$0040_1) => fail("Unrecognised By", path_3, arg20$0040_1));
        }
    }), string, path_4, value_2))]), path_5, value_3));
}

export function EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x) {
    if (x.tag === 0) {
        return object_1([["userId", guid_1(x.fields[0])]]);
    }
    else {
        return "system";
    }
}

export class Scope extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Operator", "AssignUserToActivity", "CanSignOffAnyActivity", "CanUnSignAnyActivity", "CanRevertActivityStep", "UserManagement", "SetSystemOwner"];
    }
}

export function Scope_$reflection() {
    return union_type("Types.Scope", [], Scope, () => [[], [], [], [], [], [], []]);
}

export function Scope_get_Decoder() {
    return (path_2) => ((value_1) => andThen(uncurry3((s) => {
        switch (s) {
            case "Operator":
                return (arg10$0040) => ((arg20$0040) => succeed(new Scope(0, []), arg10$0040, arg20$0040));
            case "AssignUserToActivity":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Scope(1, []), arg10$0040_1, arg20$0040_1));
            case "CanSignOffAnyActivity":
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Scope(2, []), arg10$0040_2, arg20$0040_2));
            case "CanUnSignAnyActivity":
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Scope(3, []), arg10$0040_3, arg20$0040_3));
            case "CanRevertActivityStep":
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Scope(4, []), arg10$0040_4, arg20$0040_4));
            case "UserManagement":
                return (arg10$0040_5) => ((arg20$0040_5) => succeed(new Scope(5, []), arg10$0040_5, arg20$0040_5));
            case "SetSystemOwner":
                return (arg10$0040_6) => ((arg20$0040_6) => succeed(new Scope(6, []), arg10$0040_6, arg20$0040_6));
            default:
                return (path_1) => ((arg20$0040_7) => fail("Unrecognised Scope", path_1, arg20$0040_7));
        }
    }), string, path_2, value_1));
}

export function Scope_Encoder_Z5895E356(x) {
    switch (x.tag) {
        case 1:
            return "AssignUserToActivity";
        case 2:
            return "CanSignOffAnyActivity";
        case 3:
            return "CanUnSignAnyActivity";
        case 4:
            return "CanRevertActivityStep";
        case 5:
            return "UserManagement";
        case 6:
            return "SetSystemOwner";
        default:
            return "Operator";
    }
}

export function EPM_Domain_Events_Status__Status_get_Decoder_Static() {
    return (path_2) => ((value_1) => andThen(uncurry3((s) => {
        switch (s) {
            case "Decommissioned":
                return (arg10$0040) => ((arg20$0040) => succeed(new Status_1(5, []), arg10$0040, arg20$0040));
            case "Operational":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Status_1(0, []), arg10$0040_1, arg20$0040_1));
            case "Passive":
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Status_1(3, []), arg10$0040_2, arg20$0040_2));
            case "Redundant":
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Status_1(2, []), arg10$0040_3, arg20$0040_3));
            case "Removed":
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Status_1(1, []), arg10$0040_4, arg20$0040_4));
            case "Shutdown":
                return (arg10$0040_5) => ((arg20$0040_5) => succeed(new Status_1(4, []), arg10$0040_5, arg20$0040_5));
            default:
                return (path_1) => ((arg20$0040_6) => fail("Unrecognised Status", path_1, arg20$0040_6));
        }
    }), string, path_2, value_1));
}

export function EPM_Domain_Events_Status__Status_Encoder_Static_Z1C716168(x) {
    switch (x.tag) {
        case 1:
            return "Removed";
        case 2:
            return "Redundant";
        case 3:
            return "Passive";
        case 4:
            return "Shutdown";
        case 5:
            return "Decommissioned";
        default:
            return "Operational";
    }
}

export function EPM_Domain_Events_Maturity__Maturity_get_Decoder_Static() {
    return (path_2) => ((value_1) => andThen(uncurry3((s) => {
        switch (s) {
            case "Unknown":
                return (arg10$0040) => ((arg20$0040) => succeed(new Maturity_1(0, []), arg10$0040, arg20$0040));
            case "PreCommissioning":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Maturity_1(1, []), arg10$0040_1, arg20$0040_1));
            case "MechanicalCompletion":
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Maturity_1(2, []), arg10$0040_2, arg20$0040_2));
            case "Construction":
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Maturity_1(3, []), arg10$0040_3, arg20$0040_3));
            case "FunctionTest":
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Maturity_1(4, []), arg10$0040_4, arg20$0040_4));
            case "Commission":
                return (arg10$0040_5) => ((arg20$0040_5) => succeed(new Maturity_1(5, []), arg10$0040_5, arg20$0040_5));
            case "Handover":
                return (arg10$0040_6) => ((arg20$0040_6) => succeed(new Maturity_1(6, []), arg10$0040_6, arg20$0040_6));
            default:
                return (path_1) => ((arg20$0040_7) => fail("Unrecognised Maturity", path_1, arg20$0040_7));
        }
    }), string, path_2, value_1));
}

export function EPM_Domain_Events_Maturity__Maturity_Encoder_Static_4DC9A197(x) {
    switch (x.tag) {
        case 1:
            return "PreCommissioning";
        case 2:
            return "MechanicalCompletion";
        case 3:
            return "Construction";
        case 4:
            return "FunctionTest";
        case 5:
            return "Commission";
        case 6:
            return "Handover";
        default:
            return "Unknown";
    }
}

export function EPM_Domain_Events_Criticality__Criticality_get_Decoder_Static() {
    return (path_2) => ((value_1) => andThen(uncurry3((s) => {
        switch (s) {
            case "Class":
                return (arg10$0040) => ((arg20$0040) => succeed(new Criticality_1(0, []), arg10$0040, arg20$0040));
            case "Safety":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Criticality_1(1, []), arg10$0040_1, arg20$0040_1));
            case "Production":
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Criticality_1(2, []), arg10$0040_2, arg20$0040_2));
            case "Structural":
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Criticality_1(3, []), arg10$0040_3, arg20$0040_3));
            case "None":
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Criticality_1(4, []), arg10$0040_4, arg20$0040_4));
            default:
                return (path_1) => ((arg20$0040_5) => fail("Unrecognised Criticality", path_1, arg20$0040_5));
        }
    }), string, path_2, value_1));
}

export function EPM_Domain_Events_Criticality__Criticality_Encoder_Static_Z13E6B6DD(x) {
    switch (x.tag) {
        case 1:
            return "Safety";
        case 2:
            return "Production";
        case 3:
            return "Structural";
        case 4:
            return "None";
        default:
            return "Class";
    }
}

export function EPM_Domain_Events_Condition__Condition_get_Decoder_Static() {
    return (path_2) => ((value_1) => andThen(uncurry3((s) => {
        switch (s) {
            case "VeryGood":
                return (arg10$0040) => ((arg20$0040) => succeed(new Condition_1(0, []), arg10$0040, arg20$0040));
            case "Good":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Condition_1(1, []), arg10$0040_1, arg20$0040_1));
            case "Moderate":
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Condition_1(2, []), arg10$0040_2, arg20$0040_2));
            case "Poor":
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Condition_1(3, []), arg10$0040_3, arg20$0040_3));
            case "VeryPoor":
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Condition_1(4, []), arg10$0040_4, arg20$0040_4));
            default:
                return (path_1) => ((arg20$0040_5) => fail("Unrecognised Condition", path_1, arg20$0040_5));
        }
    }), string, path_2, value_1));
}

export function EPM_Domain_Events_Condition__Condition_Encoder_Static_3780F71F(x) {
    switch (x.tag) {
        case 1:
            return "Good";
        case 2:
            return "Moderate";
        case 3:
            return "Poor";
        case 4:
            return "VeryPoor";
        default:
            return "VeryGood";
    }
}

export function EPM_Domain_Events_Attribute__Attribute_get_Decoder_Static() {
    return (path_4) => ((value_4) => oneOf(ofArray([(path_1) => ((value_1) => andThen((arg, arg10$0040, arg20$0040) => succeed(new Attribute(0, [arg]), arg10$0040, arg20$0040), string, path_1, value_1)), (path_3) => ((value_3) => andThen((arg_1, arg10$0040_1, arg20$0040_1) => succeed(new Attribute(1, [arg_1]), arg10$0040_1, arg20$0040_1), float, path_3, value_3))]), path_4, value_4));
}

export function EPM_Domain_Events_Attribute__Attribute_Encoder_Static_Z3D61170(x) {
    if (x.tag === 1) {
        return x.fields[0];
    }
    else {
        return x.fields[0];
    }
}

export function attributeEncoder(attributes) {
    return dict_1(map_1((_arg, v) => EPM_Domain_Events_Attribute__Attribute_Encoder_Static_Z3D61170(v), attributes));
}

export class DeleteEntity extends Record {
    constructor(Reason) {
        super();
        this.Reason = Reason;
    }
}

export function DeleteEntity_$reflection() {
    return record_type("Types.DeleteEntity", [], DeleteEntity, () => [["Reason", option_type(string_type)]]);
}

export function DeleteEntity_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new DeleteEntity((objectArg = get$.Optional, objectArg.Field("reason", string)));
    }, path_1, v));
}

export function DeleteEntity_Encoder_Z66C2339E(x) {
    return object_1([["reason", option((value) => value)(x.Reason)]]);
}

export class ChangeLabels extends Record {
    constructor(Labels) {
        super();
        this.Labels = Labels;
    }
}

export function ChangeLabels_$reflection() {
    return record_type("Types.ChangeLabels", [], ChangeLabels, () => [["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])]]);
}

export function ChangeLabels_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let objectArg;
        return new ChangeLabels((objectArg = get$.Required, objectArg.Field("labels", uncurry2(labelDecoder))));
    }, path, v));
}

export function ChangeLabels_Encoder_19803C73(x) {
    return object_1([["labels", labelEncoder(x.Labels)]]);
}

export class ChangeAttributes extends Record {
    constructor(Attributes) {
        super();
        this.Attributes = Attributes;
    }
}

export function ChangeAttributes_$reflection() {
    return record_type("Types.ChangeAttributes", [], ChangeAttributes, () => [["Attributes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Attribute_$reflection()])]]);
}

export function ChangeAttributes_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg;
        return new ChangeAttributes((arg_1 = dict(uncurry2(EPM_Domain_Events_Attribute__Attribute_get_Decoder_Static())), (objectArg = get$.Required, objectArg.Field("attributes", uncurry2(arg_1)))));
    }, path, v));
}

export function ChangeAttributes_Encoder_69034AA9(x) {
    return object_1([["attributes", attributeEncoder(x.Attributes)]]);
}

export function EPM_Domain_Events_DomainEntities__DomainEntities_get_Decoder_Static() {
    return (path_2) => ((value_1) => andThen(uncurry3((s) => {
        switch (s) {
            case "Tag":
                return (arg10$0040) => ((arg20$0040) => succeed(new DomainEntities(0, []), arg10$0040, arg20$0040));
            case "System":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new DomainEntities(1, []), arg10$0040_1, arg20$0040_1));
            case "Subsystem":
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new DomainEntities(2, []), arg10$0040_2, arg20$0040_2));
            case "Facility":
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new DomainEntities(3, []), arg10$0040_3, arg20$0040_3));
            case "Discipline":
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new DomainEntities(4, []), arg10$0040_4, arg20$0040_4));
            case "Activity":
                return (arg10$0040_5) => ((arg20$0040_5) => succeed(new DomainEntities(5, []), arg10$0040_5, arg20$0040_5));
            case "Module":
                return (arg10$0040_6) => ((arg20$0040_6) => succeed(new DomainEntities(6, []), arg10$0040_6, arg20$0040_6));
            case "Area":
                return (arg10$0040_7) => ((arg20$0040_7) => succeed(new DomainEntities(7, []), arg10$0040_7, arg20$0040_7));
            case "Location":
                return (arg10$0040_8) => ((arg20$0040_8) => succeed(new DomainEntities(8, []), arg10$0040_8, arg20$0040_8));
            case "Document":
                return (arg10$0040_9) => ((arg20$0040_9) => succeed(new DomainEntities(9, []), arg10$0040_9, arg20$0040_9));
            case "EquipmentType":
                return (arg10$0040_10) => ((arg20$0040_10) => succeed(new DomainEntities(10, []), arg10$0040_10, arg20$0040_10));
            case "Action":
                return (arg10$0040_11) => ((arg20$0040_11) => succeed(new DomainEntities(11, []), arg10$0040_11, arg20$0040_11));
            case "ActionType":
                return (arg10$0040_12) => ((arg20$0040_12) => succeed(new DomainEntities(12, []), arg10$0040_12, arg20$0040_12));
            case "ProductionUnit":
                return (arg10$0040_13) => ((arg20$0040_13) => succeed(new DomainEntities(13, []), arg10$0040_13, arg20$0040_13));
            case "ProductionUnitType":
                return (arg10$0040_14) => ((arg20$0040_14) => succeed(new DomainEntities(14, []), arg10$0040_14, arg20$0040_14));
            default:
                return (path_1) => ((arg20$0040_15) => fail("Unrecognised DomainEntities", path_1, arg20$0040_15));
        }
    }), string, path_2, value_1));
}

export function EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(x) {
    switch (x.tag) {
        case 1:
            return "System";
        case 2:
            return "Subsystem";
        case 3:
            return "Facility";
        case 4:
            return "Discipline";
        case 5:
            return "Activity";
        case 6:
            return "Module";
        case 7:
            return "Area";
        case 8:
            return "Location";
        case 9:
            return "Document";
        case 10:
            return "EquipmentType";
        case 11:
            return "Action";
        case 12:
            return "ActionType";
        case 13:
            return "ProductionUnit";
        case 14:
            return "ProductionUnitType";
        default:
            return "Tag";
    }
}

export class ProductionUnitTypes_ProductionUnitType extends Record {
    constructor(Id, Name, DeletedOn, LastModified, LastModifiedBy, LastEventId) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.DeletedOn = DeletedOn;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
    }
}

export function ProductionUnitTypes_ProductionUnitType_$reflection() {
    return record_type("Types.ProductionUnitTypes.ProductionUnitType", [], ProductionUnitTypes_ProductionUnitType, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")]]);
}

export function ProductionUnitTypes_ProductionUnitType_get_Decoder() {
    return (path_5) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, arg_9, objectArg_4, objectArg_5;
        return new ProductionUnitTypes_ProductionUnitType((objectArg = get$.Required, objectArg.Field("id", guid)), (objectArg_1 = get$.Required, objectArg_1.Field("name", string)), (objectArg_2 = get$.Optional, objectArg_2.Field("deletedOn", datetimeOffset)), (objectArg_3 = get$.Required, objectArg_3.Field("lastModified", datetimeOffset)), (arg_9 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_4 = get$.Required, objectArg_4.Field("lastModifiedBy", uncurry2(arg_9)))), (objectArg_5 = get$.Required, objectArg_5.Field("lastEventId", guid)));
    }, path_5, v));
}

export function ProductionUnitTypes_ProductionUnitType_Encoder_516DF57D(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(14, []))]]);
}

export class ProductionUnitTypes_CreateProductionUnitType extends Record {
    constructor(Name) {
        super();
        this.Name = Name;
    }
}

export function ProductionUnitTypes_CreateProductionUnitType_$reflection() {
    return record_type("Types.ProductionUnitTypes.CreateProductionUnitType", [], ProductionUnitTypes_CreateProductionUnitType, () => [["Name", string_type]]);
}

export function ProductionUnitTypes_CreateProductionUnitType_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new ProductionUnitTypes_CreateProductionUnitType((objectArg = get$.Required, objectArg.Field("name", string)));
    }, path_1, v));
}

export function ProductionUnitTypes_CreateProductionUnitType_Encoder_Z27C128A7(x) {
    return object_1([["name", x.Name]]);
}

export class ProductionUnits_ProductionUnit extends Record {
    constructor(Id, Name, Detail, ProductionUnitTypeId, DeletedOn, LastModified, LastModifiedBy, LastEventId, Labels, Attributes) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Detail = Detail;
        this.ProductionUnitTypeId = ProductionUnitTypeId;
        this.DeletedOn = DeletedOn;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
        this.Labels = Labels;
        this.Attributes = Attributes;
    }
}

export function ProductionUnits_ProductionUnit_$reflection() {
    return record_type("Types.ProductionUnits.ProductionUnit", [], ProductionUnits_ProductionUnit, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Detail", string_type], ["ProductionUnitTypeId", class_type("System.Guid")], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["Attributes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Attribute_$reflection()])]]);
}

export function ProductionUnits_ProductionUnit_get_Decoder() {
    return (path_7) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, objectArg_4, objectArg_5, arg_13, objectArg_6, objectArg_7, objectArg_8, arg_19, objectArg_9;
        return new ProductionUnits_ProductionUnit((objectArg = get$.Required, objectArg.Field("id", guid)), (objectArg_1 = get$.Required, objectArg_1.Field("name", string)), (objectArg_2 = get$.Required, objectArg_2.Field("detail", string)), (objectArg_3 = get$.Required, objectArg_3.Field("productionUnitTypeId", guid)), (objectArg_4 = get$.Optional, objectArg_4.Field("deletedOn", datetimeOffset)), (objectArg_5 = get$.Required, objectArg_5.Field("lastModified", datetimeOffset)), (arg_13 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_6 = get$.Required, objectArg_6.Field("lastModifiedBy", uncurry2(arg_13)))), (objectArg_7 = get$.Required, objectArg_7.Field("lastEventId", guid)), (objectArg_8 = get$.Required, objectArg_8.Field("labels", uncurry2(labelDecoder))), (arg_19 = dict(uncurry2(EPM_Domain_Events_Attribute__Attribute_get_Decoder_Static())), (objectArg_9 = get$.Required, objectArg_9.Field("attributes", uncurry2(arg_19)))));
    }, path_7, v));
}

export function ProductionUnits_ProductionUnit_Encoder_26A817D(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["detail", x.Detail], ["productionUnitTypeId", guid_1(x.ProductionUnitTypeId)], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(13, []))], ["labels", labelEncoder(x.Labels)], ["attributes", attributeEncoder(x.Attributes)]]);
}

export class ProductionUnits_MoveToProductionType extends Record {
    constructor(ProductionUnitTypeId) {
        super();
        this.ProductionUnitTypeId = ProductionUnitTypeId;
    }
}

export function ProductionUnits_MoveToProductionType_$reflection() {
    return record_type("Types.ProductionUnits.MoveToProductionType", [], ProductionUnits_MoveToProductionType, () => [["ProductionUnitTypeId", class_type("System.Guid")]]);
}

export function ProductionUnits_MoveToProductionType_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new ProductionUnits_MoveToProductionType((objectArg = get$.Required, objectArg.Field("productionUnitTypeId", guid)));
    }, path_1, v));
}

export function ProductionUnits_MoveToProductionType_Encoder_Z1CF1D3F7(x) {
    return object_1([["productionUnitTypeId", guid_1(x.ProductionUnitTypeId)]]);
}

export class ProductionUnits_CreateProductionUnit extends Record {
    constructor(Name, Detail, ProductionUnitTypeId) {
        super();
        this.Name = Name;
        this.Detail = Detail;
        this.ProductionUnitTypeId = ProductionUnitTypeId;
    }
}

export function ProductionUnits_CreateProductionUnit_$reflection() {
    return record_type("Types.ProductionUnits.CreateProductionUnit", [], ProductionUnits_CreateProductionUnit, () => [["Name", string_type], ["Detail", string_type], ["ProductionUnitTypeId", class_type("System.Guid")]]);
}

export function ProductionUnits_CreateProductionUnit_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new ProductionUnits_CreateProductionUnit((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)), (objectArg_2 = get$.Required, objectArg_2.Field("productionUnitTypeId", guid)));
    }, path_3, v));
}

export function ProductionUnits_CreateProductionUnit_Encoder_Z623E35A7(x) {
    return object_1([["name", x.Name], ["detail", x.Detail], ["productionUnitTypeId", guid_1(x.ProductionUnitTypeId)]]);
}

export class Systems_SystemOwnerData extends Record {
    constructor(UserId, Maturity, DisciplineId) {
        super();
        this.UserId = UserId;
        this.Maturity = Maturity;
        this.DisciplineId = DisciplineId;
    }
}

export function Systems_SystemOwnerData_$reflection() {
    return record_type("Types.Systems.SystemOwnerData", [], Systems_SystemOwnerData, () => [["UserId", class_type("System.Guid")], ["Maturity", option_type(Maturity_$reflection())], ["DisciplineId", option_type(class_type("System.Guid"))]]);
}

export function Systems_SystemOwnerData_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, arg_3, objectArg_1, objectArg_2;
        return new Systems_SystemOwnerData((objectArg = get$.Required, objectArg.Field("userId", guid)), (arg_3 = EPM_Domain_Events_Maturity__Maturity_get_Decoder_Static(), (objectArg_1 = get$.Optional, objectArg_1.Field("maturity", uncurry2(arg_3)))), (objectArg_2 = get$.Optional, objectArg_2.Field("disciplineId", guid)));
    }, path_2, v));
}

export function Systems_SystemOwnerData_Encoder_97448AC(x) {
    return object_1([["userId", guid_1(x.UserId)], ["maturity", option(EPM_Domain_Events_Maturity__Maturity_Encoder_Static_4DC9A197)(x.Maturity)], ["disciplineId", option(guid_1)(x.DisciplineId)]]);
}

export class Systems_Sys extends Record {
    constructor(Id, Name, Detail, ProductionUnitId, DeletedOn, Status, LastModified, LastModifiedBy, LastEventId, SystemOwners, Labels, Attributes) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Detail = Detail;
        this.ProductionUnitId = ProductionUnitId;
        this.DeletedOn = DeletedOn;
        this.Status = Status;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
        this.SystemOwners = SystemOwners;
        this.Labels = Labels;
        this.Attributes = Attributes;
    }
}

export function Systems_Sys_$reflection() {
    return record_type("Types.Systems.Sys", [], Systems_Sys, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Detail", string_type], ["ProductionUnitId", option_type(class_type("System.Guid"))], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["Status", option_type(Status_$reflection())], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")], ["SystemOwners", list_type(Systems_SystemOwnerData_$reflection())], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["Attributes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Attribute_$reflection()])]]);
}

export function Systems_Sys_get_Decoder() {
    return (path_8) => ((v) => object((get$) => {
        let objectArg_5, objectArg_6, arg_15, objectArg_7, objectArg_8, arg_19, decoder, objectArg_9, objectArg_10, arg_23, objectArg_11;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let Detail;
        const objectArg_2 = get$.Required;
        Detail = objectArg_2.Field("detail", string);
        let ProductionUnitId;
        const objectArg_3 = get$.Optional;
        ProductionUnitId = objectArg_3.Field("productionUnitId", guid);
        let Status;
        const arg_9 = EPM_Domain_Events_Status__Status_get_Decoder_Static();
        const objectArg_4 = get$.Optional;
        Status = objectArg_4.Field("status", uncurry2(arg_9));
        return new Systems_Sys(Id, Name, Detail, ProductionUnitId, (objectArg_5 = get$.Optional, objectArg_5.Field("deletedOn", datetimeOffset)), Status, (objectArg_6 = get$.Required, objectArg_6.Field("lastModified", datetimeOffset)), (arg_15 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_7 = get$.Required, objectArg_7.Field("lastModifiedBy", uncurry2(arg_15)))), (objectArg_8 = get$.Required, objectArg_8.Field("lastEventId", guid)), (arg_19 = ((decoder = Systems_SystemOwnerData_get_Decoder(), (path_7) => ((value_7) => list_4(uncurry2(decoder), path_7, value_7)))), (objectArg_9 = get$.Required, objectArg_9.Field("systemOwners", uncurry2(arg_19)))), (objectArg_10 = get$.Required, objectArg_10.Field("labels", uncurry2(labelDecoder))), (arg_23 = dict(uncurry2(EPM_Domain_Events_Attribute__Attribute_get_Decoder_Static())), (objectArg_11 = get$.Required, objectArg_11.Field("attributes", uncurry2(arg_23)))));
    }, path_8, v));
}

export function Systems_Sys_Encoder_Z38A497F(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["detail", x.Detail], ["productionUnitId", option(guid_1)(x.ProductionUnitId)], ["status", option(EPM_Domain_Events_Status__Status_Encoder_Static_Z1C716168)(x.Status)], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["systemOwners", list_5(map_3(Systems_SystemOwnerData_Encoder_97448AC, x.SystemOwners))], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(1, []))], ["labels", labelEncoder(x.Labels)], ["attributes", attributeEncoder(x.Attributes)]]);
}

export class Systems_AssignStatus extends Record {
    constructor(Status) {
        super();
        this.Status = Status;
    }
}

export function Systems_AssignStatus_$reflection() {
    return record_type("Types.Systems.AssignStatus", [], Systems_AssignStatus, () => [["Status", Status_$reflection()]]);
}

export function Systems_AssignStatus_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg;
        return new Systems_AssignStatus((arg_1 = EPM_Domain_Events_Status__Status_get_Decoder_Static(), (objectArg = get$.Required, objectArg.Field("status", uncurry2(arg_1)))));
    }, path, v));
}

export function Systems_AssignStatus_Encoder_51AAE3AD(x) {
    return object_1([["status", EPM_Domain_Events_Status__Status_Encoder_Static_Z1C716168(x.Status)]]);
}

export class Systems_AssignProductionUnit extends Record {
    constructor(ProductionUnitId) {
        super();
        this.ProductionUnitId = ProductionUnitId;
    }
}

export function Systems_AssignProductionUnit_$reflection() {
    return record_type("Types.Systems.AssignProductionUnit", [], Systems_AssignProductionUnit, () => [["ProductionUnitId", class_type("System.Guid")]]);
}

export function Systems_AssignProductionUnit_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Systems_AssignProductionUnit((objectArg = get$.Required, objectArg.Field("productionUnitId", guid)));
    }, path_1, v));
}

export function Systems_AssignProductionUnit_Encoder_1F556B5C(x) {
    return object_1([["productionUnitId", guid_1(x.ProductionUnitId)]]);
}

export class Systems_UpdateSystem extends Record {
    constructor(Name, Detail) {
        super();
        this.Name = Name;
        this.Detail = Detail;
    }
}

export function Systems_UpdateSystem_$reflection() {
    return record_type("Types.Systems.UpdateSystem", [], Systems_UpdateSystem, () => [["Name", string_type], ["Detail", string_type]]);
}

export function Systems_UpdateSystem_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Systems_UpdateSystem((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)));
    }, path_2, v));
}

export function Systems_UpdateSystem_Encoder_Z5F0F86D4(x) {
    return object_1([["name", x.Name], ["detail", x.Detail]]);
}

export class Systems_CreateSystem extends Record {
    constructor(Name, Detail, Status) {
        super();
        this.Name = Name;
        this.Detail = Detail;
        this.Status = Status;
    }
}

export function Systems_CreateSystem_$reflection() {
    return record_type("Types.Systems.CreateSystem", [], Systems_CreateSystem, () => [["Name", string_type], ["Detail", string_type], ["Status", option_type(Status_$reflection())]]);
}

export function Systems_CreateSystem_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1, arg_5, objectArg_2;
        return new Systems_CreateSystem((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)), (arg_5 = EPM_Domain_Events_Status__Status_get_Decoder_Static(), (objectArg_2 = get$.Optional, objectArg_2.Field("status", uncurry2(arg_5)))));
    }, path_2, v));
}

export function Systems_CreateSystem_Encoder_3D96A59(x) {
    return object_1([["name", x.Name], ["detail", x.Detail], ["status", option(EPM_Domain_Events_Status__Status_Encoder_Static_Z1C716168)(x.Status)]]);
}

export class Subsystems_Subsystem extends Record {
    constructor(Id, SystemId, Name, Detail, LastModified, LastModifiedBy, LastEventId, DeletedOn, Labels, Attributes) {
        super();
        this.Id = Id;
        this.SystemId = SystemId;
        this.Name = Name;
        this.Detail = Detail;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
        this.DeletedOn = DeletedOn;
        this.Labels = Labels;
        this.Attributes = Attributes;
    }
}

export function Subsystems_Subsystem_$reflection() {
    return record_type("Types.Subsystems.Subsystem", [], Subsystems_Subsystem, () => [["Id", class_type("System.Guid")], ["SystemId", class_type("System.Guid")], ["Name", string_type], ["Detail", string_type], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["Attributes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Attribute_$reflection()])]]);
}

export function Subsystems_Subsystem_get_Decoder() {
    return (path_7) => ((v) => object((get$) => {
        let objectArg_5, arg_13, objectArg_6, objectArg_7, objectArg_8, arg_19, objectArg_9;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let Detail;
        const objectArg_2 = get$.Required;
        Detail = objectArg_2.Field("detail", string);
        let SystemId;
        const objectArg_3 = get$.Required;
        SystemId = objectArg_3.Field("systemId", guid);
        let DeletedOn;
        const objectArg_4 = get$.Optional;
        DeletedOn = objectArg_4.Field("deletedOn", datetimeOffset);
        return new Subsystems_Subsystem(Id, SystemId, Name, Detail, (objectArg_5 = get$.Required, objectArg_5.Field("lastModified", datetimeOffset)), (arg_13 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_6 = get$.Required, objectArg_6.Field("lastModifiedBy", uncurry2(arg_13)))), (objectArg_7 = get$.Required, objectArg_7.Field("lastEventId", guid)), DeletedOn, (objectArg_8 = get$.Required, objectArg_8.Field("labels", uncurry2(labelDecoder))), (arg_19 = dict(uncurry2(EPM_Domain_Events_Attribute__Attribute_get_Decoder_Static())), (objectArg_9 = get$.Required, objectArg_9.Field("attributes", uncurry2(arg_19)))));
    }, path_7, v));
}

export function Subsystems_Subsystem_Encoder_68352ABD(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["detail", x.Detail], ["systemId", guid_1(x.SystemId)], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(2, []))], ["labels", labelEncoder(x.Labels)], ["attributes", attributeEncoder(x.Attributes)]]);
}

export class Subsystems_CreateSubsystem extends Record {
    constructor(Name, SystemId, Detail) {
        super();
        this.Name = Name;
        this.SystemId = SystemId;
        this.Detail = Detail;
    }
}

export function Subsystems_CreateSubsystem_$reflection() {
    return record_type("Types.Subsystems.CreateSubsystem", [], Subsystems_CreateSubsystem, () => [["Name", string_type], ["SystemId", class_type("System.Guid")], ["Detail", string_type]]);
}

export function Subsystems_CreateSubsystem_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg_2;
        let Name;
        const objectArg = get$.Required;
        Name = objectArg.Field("name", string);
        let Detail;
        const objectArg_1 = get$.Required;
        Detail = objectArg_1.Field("detail", string);
        return new Subsystems_CreateSubsystem(Name, (objectArg_2 = get$.Required, objectArg_2.Field("systemId", guid)), Detail);
    }, path_3, v));
}

export function Subsystems_CreateSubsystem_Encoder_366BCE59(x) {
    return object_1([["name", x.Name], ["detail", x.Detail], ["systemId", guid_1(x.SystemId)]]);
}

export class Subsystems_UpdateSubsystem extends Record {
    constructor(Name, Detail) {
        super();
        this.Name = Name;
        this.Detail = Detail;
    }
}

export function Subsystems_UpdateSubsystem_$reflection() {
    return record_type("Types.Subsystems.UpdateSubsystem", [], Subsystems_UpdateSubsystem, () => [["Name", string_type], ["Detail", string_type]]);
}

export function Subsystems_UpdateSubsystem_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Subsystems_UpdateSubsystem((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)));
    }, path_2, v));
}

export function Subsystems_UpdateSubsystem_Encoder_A23C00C(x) {
    return object_1([["name", x.Name], ["detail", x.Detail]]);
}

export class Subsystems_MoveToSystem extends Record {
    constructor(SystemId) {
        super();
        this.SystemId = SystemId;
    }
}

export function Subsystems_MoveToSystem_$reflection() {
    return record_type("Types.Subsystems.MoveToSystem", [], Subsystems_MoveToSystem, () => [["SystemId", class_type("System.Guid")]]);
}

export function Subsystems_MoveToSystem_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Subsystems_MoveToSystem((objectArg = get$.Required, objectArg.Field("systemId", guid)));
    }, path_1, v));
}

export function Subsystems_MoveToSystem_Encoder_2A8A8493(x) {
    return object_1([["systemId", guid_1(x.SystemId)]]);
}

export class Facilities_Facility extends Record {
    constructor(Id, Name, LastModified, LastModifiedBy, LastEventId, DeletedOn, Labels, Attributes) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
        this.DeletedOn = DeletedOn;
        this.Labels = Labels;
        this.Attributes = Attributes;
    }
}

export function Facilities_Facility_$reflection() {
    return record_type("Types.Facilities.Facility", [], Facilities_Facility, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["Attributes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Attribute_$reflection()])]]);
}

export function Facilities_Facility_get_Decoder() {
    return (path_5) => ((v) => object((get$) => {
        let objectArg_3, arg_9, objectArg_4, objectArg_5, objectArg_6, arg_15, objectArg_7;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let DeletedOn;
        const objectArg_2 = get$.Optional;
        DeletedOn = objectArg_2.Field("deletedOn", datetimeOffset);
        return new Facilities_Facility(Id, Name, (objectArg_3 = get$.Required, objectArg_3.Field("lastModified", datetimeOffset)), (arg_9 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_4 = get$.Required, objectArg_4.Field("lastModifiedBy", uncurry2(arg_9)))), (objectArg_5 = get$.Required, objectArg_5.Field("lastEventId", guid)), DeletedOn, (objectArg_6 = get$.Required, objectArg_6.Field("labels", uncurry2(labelDecoder))), (arg_15 = dict(uncurry2(EPM_Domain_Events_Attribute__Attribute_get_Decoder_Static())), (objectArg_7 = get$.Required, objectArg_7.Field("attributes", uncurry2(arg_15)))));
    }, path_5, v));
}

export function Facilities_Facility_Encoder_Z4CE6E898(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(3, []))], ["labels", labelEncoder(x.Labels)], ["attributes", attributeEncoder(x.Attributes)]]);
}

export class Facilities_CreateFacility extends Record {
    constructor(Name) {
        super();
        this.Name = Name;
    }
}

export function Facilities_CreateFacility_$reflection() {
    return record_type("Types.Facilities.CreateFacility", [], Facilities_CreateFacility, () => [["Name", string_type]]);
}

export function Facilities_CreateFacility_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Facilities_CreateFacility((objectArg = get$.Required, objectArg.Field("name", string)));
    }, path_1, v));
}

export function Facilities_CreateFacility_Encoder_590E490C(x) {
    return object_1([["name", x.Name]]);
}

export class Facilities_UpdateFacility extends Record {
    constructor(Name) {
        super();
        this.Name = Name;
    }
}

export function Facilities_UpdateFacility_$reflection() {
    return record_type("Types.Facilities.UpdateFacility", [], Facilities_UpdateFacility, () => [["Name", string_type]]);
}

export function Facilities_UpdateFacility_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Facilities_UpdateFacility((objectArg = get$.Required, objectArg.Field("name", string)));
    }, path_1, v));
}

export function Facilities_UpdateFacility_Encoder_47974D39(x) {
    return object_1([["name", x.Name]]);
}

export class Modules_Module extends Record {
    constructor(Id, Name, Detail, DeletedOn, LastModified, LastModifiedBy, LastEventId, FacilityId, Labels, Attributes) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Detail = Detail;
        this.DeletedOn = DeletedOn;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
        this.FacilityId = FacilityId;
        this.Labels = Labels;
        this.Attributes = Attributes;
    }
}

export function Modules_Module_$reflection() {
    return record_type("Types.Modules.Module", [], Modules_Module, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Detail", string_type], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")], ["FacilityId", option_type(class_type("System.Guid"))], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["Attributes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Attribute_$reflection()])]]);
}

export function Modules_Module_get_Decoder() {
    return (path_7) => ((v) => object((get$) => {
        let objectArg_4, objectArg_5, arg_13, objectArg_6, objectArg_7, objectArg_8, arg_19, objectArg_9;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let Detail;
        const objectArg_2 = get$.Required;
        Detail = objectArg_2.Field("detail", string);
        let FacilityId;
        const objectArg_3 = get$.Optional;
        FacilityId = objectArg_3.Field("facilityId", guid);
        return new Modules_Module(Id, Name, Detail, (objectArg_4 = get$.Optional, objectArg_4.Field("deletedOn", datetimeOffset)), (objectArg_5 = get$.Required, objectArg_5.Field("lastModified", datetimeOffset)), (arg_13 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_6 = get$.Required, objectArg_6.Field("lastModifiedBy", uncurry2(arg_13)))), (objectArg_7 = get$.Required, objectArg_7.Field("lastEventId", guid)), FacilityId, (objectArg_8 = get$.Required, objectArg_8.Field("labels", uncurry2(labelDecoder))), (arg_19 = dict(uncurry2(EPM_Domain_Events_Attribute__Attribute_get_Decoder_Static())), (objectArg_9 = get$.Required, objectArg_9.Field("attributes", uncurry2(arg_19)))));
    }, path_7, v));
}

export function Modules_Module_Encoder_6BC725BD(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["detail", x.Detail], ["facilityId", option(guid_1)(x.FacilityId)], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(6, []))], ["labels", labelEncoder(x.Labels)], ["attributes", attributeEncoder(x.Attributes)]]);
}

export class Modules_CreateModule extends Record {
    constructor(Name, Detail, FacilityId) {
        super();
        this.Name = Name;
        this.Detail = Detail;
        this.FacilityId = FacilityId;
    }
}

export function Modules_CreateModule_$reflection() {
    return record_type("Types.Modules.CreateModule", [], Modules_CreateModule, () => [["Name", string_type], ["Detail", string_type], ["FacilityId", option_type(class_type("System.Guid"))]]);
}

export function Modules_CreateModule_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Modules_CreateModule((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)), (objectArg_2 = get$.Optional, objectArg_2.Field("facilityId", guid)));
    }, path_3, v));
}

export function Modules_CreateModule_Encoder_47C8ECD9(x) {
    return object_1([["name", x.Name], ["detail", x.Detail], ["facilityId", option(guid_1)(x.FacilityId)]]);
}

export class Modules_MoveToFacility extends Record {
    constructor(FacilityId) {
        super();
        this.FacilityId = FacilityId;
    }
}

export function Modules_MoveToFacility_$reflection() {
    return record_type("Types.Modules.MoveToFacility", [], Modules_MoveToFacility, () => [["FacilityId", class_type("System.Guid")]]);
}

export function Modules_MoveToFacility_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Modules_MoveToFacility((objectArg = get$.Required, objectArg.Field("facilityId", guid)));
    }, path_1, v));
}

export function Modules_MoveToFacility_Encoder_Z13FC1078(x) {
    return object_1([["facilityId", guid_1(x.FacilityId)]]);
}

export class Modules_UpdateModule extends Record {
    constructor(Name, Detail) {
        super();
        this.Name = Name;
        this.Detail = Detail;
    }
}

export function Modules_UpdateModule_$reflection() {
    return record_type("Types.Modules.UpdateModule", [], Modules_UpdateModule, () => [["Name", string_type], ["Detail", string_type]]);
}

export function Modules_UpdateModule_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Modules_UpdateModule((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)));
    }, path_2, v));
}

export function Modules_UpdateModule_Encoder_ZCDEA214(x) {
    return object_1([["name", x.Name], ["detail", x.Detail]]);
}

export class Areas_Area extends Record {
    constructor(Id, Name, Detail, DeletedOn, LastModified, LastModifiedBy, LastEventId, ModuleId, Labels, Attributes) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Detail = Detail;
        this.DeletedOn = DeletedOn;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
        this.ModuleId = ModuleId;
        this.Labels = Labels;
        this.Attributes = Attributes;
    }
}

export function Areas_Area_$reflection() {
    return record_type("Types.Areas.Area", [], Areas_Area, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Detail", string_type], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")], ["ModuleId", option_type(class_type("System.Guid"))], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["Attributes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Attribute_$reflection()])]]);
}

export function Areas_Area_get_Decoder() {
    return (path_7) => ((v) => object((get$) => {
        let objectArg_4, objectArg_5, arg_13, objectArg_6, objectArg_7, objectArg_8, arg_19, objectArg_9;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let Detail;
        const objectArg_2 = get$.Required;
        Detail = objectArg_2.Field("detail", string);
        let ModuleId;
        const objectArg_3 = get$.Optional;
        ModuleId = objectArg_3.Field("moduleId", guid);
        return new Areas_Area(Id, Name, Detail, (objectArg_4 = get$.Optional, objectArg_4.Field("deletedOn", datetimeOffset)), (objectArg_5 = get$.Required, objectArg_5.Field("lastModified", datetimeOffset)), (arg_13 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_6 = get$.Required, objectArg_6.Field("lastModifiedBy", uncurry2(arg_13)))), (objectArg_7 = get$.Required, objectArg_7.Field("lastEventId", guid)), ModuleId, (objectArg_8 = get$.Required, objectArg_8.Field("labels", uncurry2(labelDecoder))), (arg_19 = dict(uncurry2(EPM_Domain_Events_Attribute__Attribute_get_Decoder_Static())), (objectArg_9 = get$.Required, objectArg_9.Field("attributes", uncurry2(arg_19)))));
    }, path_7, v));
}

export function Areas_Area_Encoder_421593FD(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["detail", x.Detail], ["moduleId", option(guid_1)(x.ModuleId)], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(7, []))], ["labels", labelEncoder(x.Labels)], ["attributes", attributeEncoder(x.Attributes)]]);
}

export class Areas_CreateArea extends Record {
    constructor(Name, Detail, ModuleId) {
        super();
        this.Name = Name;
        this.Detail = Detail;
        this.ModuleId = ModuleId;
    }
}

export function Areas_CreateArea_$reflection() {
    return record_type("Types.Areas.CreateArea", [], Areas_CreateArea, () => [["Name", string_type], ["Detail", string_type], ["ModuleId", option_type(class_type("System.Guid"))]]);
}

export function Areas_CreateArea_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Areas_CreateArea((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)), (objectArg_2 = get$.Optional, objectArg_2.Field("moduleId", guid)));
    }, path_3, v));
}

export function Areas_CreateArea_Encoder_3FA63B19(x) {
    return object_1([["name", x.Name], ["detail", x.Detail], ["moduleId", option(guid_1)(x.ModuleId)]]);
}

export class Areas_UpdateArea extends Record {
    constructor(Name, Detail) {
        super();
        this.Name = Name;
        this.Detail = Detail;
    }
}

export function Areas_UpdateArea_$reflection() {
    return record_type("Types.Areas.UpdateArea", [], Areas_UpdateArea, () => [["Name", string_type], ["Detail", string_type]]);
}

export function Areas_UpdateArea_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Areas_UpdateArea((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)));
    }, path_2, v));
}

export function Areas_UpdateArea_Encoder_FA3DE2C(x) {
    return object_1([["name", x.Name], ["detail", x.Detail]]);
}

export class Areas_MoveToModule extends Record {
    constructor(ModuleId) {
        super();
        this.ModuleId = ModuleId;
    }
}

export function Areas_MoveToModule_$reflection() {
    return record_type("Types.Areas.MoveToModule", [], Areas_MoveToModule, () => [["ModuleId", class_type("System.Guid")]]);
}

export function Areas_MoveToModule_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Areas_MoveToModule((objectArg = get$.Required, objectArg.Field("moduleId", guid)));
    }, path_1, v));
}

export function Areas_MoveToModule_Encoder_6F063ABA(x) {
    return object_1([["moduleId", guid_1(x.ModuleId)]]);
}

export class Locations_Location extends Record {
    constructor(Id, Name, DeletedOn, LastModified, LastModifiedBy, LastEventId, AreaId, Labels, Attributes) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.DeletedOn = DeletedOn;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
        this.AreaId = AreaId;
        this.Labels = Labels;
        this.Attributes = Attributes;
    }
}

export function Locations_Location_$reflection() {
    return record_type("Types.Locations.Location", [], Locations_Location, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")], ["AreaId", option_type(class_type("System.Guid"))], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["Attributes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Attribute_$reflection()])]]);
}

export function Locations_Location_get_Decoder() {
    return (path_6) => ((v) => object((get$) => {
        let objectArg_3, objectArg_4, arg_11, objectArg_5, objectArg_6, objectArg_7, arg_17, objectArg_8;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let AreaId;
        const objectArg_2 = get$.Optional;
        AreaId = objectArg_2.Field("areaId", guid);
        return new Locations_Location(Id, Name, (objectArg_3 = get$.Optional, objectArg_3.Field("deletedOn", datetimeOffset)), (objectArg_4 = get$.Required, objectArg_4.Field("lastModified", datetimeOffset)), (arg_11 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_5 = get$.Required, objectArg_5.Field("lastModifiedBy", uncurry2(arg_11)))), (objectArg_6 = get$.Required, objectArg_6.Field("lastEventId", guid)), AreaId, (objectArg_7 = get$.Required, objectArg_7.Field("labels", uncurry2(labelDecoder))), (arg_17 = dict(uncurry2(EPM_Domain_Events_Attribute__Attribute_get_Decoder_Static())), (objectArg_8 = get$.Required, objectArg_8.Field("attributes", uncurry2(arg_17)))));
    }, path_6, v));
}

export function Locations_Location_Encoder_Z68A1B383(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["areaId", option(guid_1)(x.AreaId)], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(8, []))], ["labels", labelEncoder(x.Labels)], ["attributes", attributeEncoder(x.Attributes)]]);
}

export class Locations_CreateLocation extends Record {
    constructor(Name, AreaId) {
        super();
        this.Name = Name;
        this.AreaId = AreaId;
    }
}

export function Locations_CreateLocation_$reflection() {
    return record_type("Types.Locations.CreateLocation", [], Locations_CreateLocation, () => [["Name", string_type], ["AreaId", option_type(class_type("System.Guid"))]]);
}

export function Locations_CreateLocation_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Locations_CreateLocation((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Optional, objectArg_1.Field("areaId", guid)));
    }, path_2, v));
}

export function Locations_CreateLocation_Encoder_Z4BD79BE7(x) {
    return object_1([["name", x.Name], ["areaId", option(guid_1)(x.AreaId)]]);
}

export class Locations_UpdateLocation extends Record {
    constructor(Name) {
        super();
        this.Name = Name;
    }
}

export function Locations_UpdateLocation_$reflection() {
    return record_type("Types.Locations.UpdateLocation", [], Locations_UpdateLocation, () => [["Name", string_type]]);
}

export function Locations_UpdateLocation_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Locations_UpdateLocation((objectArg = get$.Required, objectArg.Field("name", string)));
    }, path_1, v));
}

export function Locations_UpdateLocation_Encoder_409CA8AC(x) {
    return object_1([["name", x.Name]]);
}

export class Locations_MoveToArea extends Record {
    constructor(AreaId) {
        super();
        this.AreaId = AreaId;
    }
}

export function Locations_MoveToArea_$reflection() {
    return record_type("Types.Locations.MoveToArea", [], Locations_MoveToArea, () => [["AreaId", class_type("System.Guid")]]);
}

export function Locations_MoveToArea_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Locations_MoveToArea((objectArg = get$.Required, objectArg.Field("areaId", guid)));
    }, path_1, v));
}

export function Locations_MoveToArea_Encoder_Z1B6F5123(x) {
    return object_1([["areaId", guid_1(x.AreaId)]]);
}

export class Disciplines_Discipline extends Record {
    constructor(Id, Name, LastModified, LastModifiedBy, LastEventId, DeletedOn) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
        this.DeletedOn = DeletedOn;
    }
}

export function Disciplines_Discipline_$reflection() {
    return record_type("Types.Disciplines.Discipline", [], Disciplines_Discipline, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))]]);
}

export function Disciplines_Discipline_get_Decoder() {
    return (path_5) => ((v) => object((get$) => {
        let objectArg_3, arg_9, objectArg_4, objectArg_5;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let DeletedOn;
        const objectArg_2 = get$.Optional;
        DeletedOn = objectArg_2.Field("deletedOn", datetimeOffset);
        return new Disciplines_Discipline(Id, Name, (objectArg_3 = get$.Required, objectArg_3.Field("lastModified", datetimeOffset)), (arg_9 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_4 = get$.Required, objectArg_4.Field("lastModifiedBy", uncurry2(arg_9)))), (objectArg_5 = get$.Required, objectArg_5.Field("lastEventId", guid)), DeletedOn);
    }, path_5, v));
}

export function Disciplines_Discipline_Encoder_Z3B8BC283(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(4, []))]]);
}

export class Disciplines_CreateDiscipline extends Record {
    constructor(Name) {
        super();
        this.Name = Name;
    }
}

export function Disciplines_CreateDiscipline_$reflection() {
    return record_type("Types.Disciplines.CreateDiscipline", [], Disciplines_CreateDiscipline, () => [["Name", string_type]]);
}

export function Disciplines_CreateDiscipline_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Disciplines_CreateDiscipline((objectArg = get$.Required, objectArg.Field("name", string)));
    }, path_1, v));
}

export function Disciplines_CreateDiscipline_Encoder_Z4A5AA527(x) {
    return object_1([["name", x.Name]]);
}

export class EquipmentTypes_EquipmentType extends Record {
    constructor(Id, Name, Detail, DeletedOn, DisciplineId, LastModified, LastModifiedBy, LastEventId) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Detail = Detail;
        this.DeletedOn = DeletedOn;
        this.DisciplineId = DisciplineId;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
    }
}

export function EquipmentTypes_EquipmentType_$reflection() {
    return record_type("Types.EquipmentTypes.EquipmentType", [], EquipmentTypes_EquipmentType, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Detail", option_type(string_type)], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["DisciplineId", option_type(class_type("System.Guid"))], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")]]);
}

export function EquipmentTypes_EquipmentType_get_Decoder() {
    return (path_7) => ((v) => object((get$) => {
        let objectArg_4, objectArg_5, arg_13, objectArg_6, objectArg_7;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let Detail;
        const objectArg_2 = get$.Optional;
        Detail = objectArg_2.Field("detail", string);
        let DisciplineId;
        const objectArg_3 = get$.Optional;
        DisciplineId = objectArg_3.Field("disciplineId", guid);
        return new EquipmentTypes_EquipmentType(Id, Name, Detail, (objectArg_4 = get$.Optional, objectArg_4.Field("deletedOn", datetimeOffset)), DisciplineId, (objectArg_5 = get$.Required, objectArg_5.Field("lastModified", datetimeOffset)), (arg_13 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_6 = get$.Required, objectArg_6.Field("lastModifiedBy", uncurry2(arg_13)))), (objectArg_7 = get$.Required, objectArg_7.Field("lastEventId", guid)));
    }, path_7, v));
}

export function EquipmentTypes_EquipmentType_Encoder_Z6C4DBFA3(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["detail", option((value_1) => value_1)(x.Detail)], ["disciplineId", option(guid_1)(x.DisciplineId)], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(10, []))]]);
}

export class EquipmentTypes_CreateEquipmentType extends Record {
    constructor(Name, Detail, DisciplineId) {
        super();
        this.Name = Name;
        this.Detail = Detail;
        this.DisciplineId = DisciplineId;
    }
}

export function EquipmentTypes_CreateEquipmentType_$reflection() {
    return record_type("Types.EquipmentTypes.CreateEquipmentType", [], EquipmentTypes_CreateEquipmentType, () => [["Name", string_type], ["Detail", option_type(string_type)], ["DisciplineId", option_type(class_type("System.Guid"))]]);
}

export function EquipmentTypes_CreateEquipmentType_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new EquipmentTypes_CreateEquipmentType((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Optional, objectArg_1.Field("detail", string)), (objectArg_2 = get$.Optional, objectArg_2.Field("disciplineId", guid)));
    }, path_3, v));
}

export function EquipmentTypes_CreateEquipmentType_Encoder_Z1A1C7587(x) {
    return object_1([["name", x.Name], ["detail", option((value_1) => value_1)(x.Detail)], ["disciplineId", option(guid_1)(x.DisciplineId)]]);
}

export class EquipmentTypes_AssignDiscipline extends Record {
    constructor(DisciplineId) {
        super();
        this.DisciplineId = DisciplineId;
    }
}

export function EquipmentTypes_AssignDiscipline_$reflection() {
    return record_type("Types.EquipmentTypes.AssignDiscipline", [], EquipmentTypes_AssignDiscipline, () => [["DisciplineId", class_type("System.Guid")]]);
}

export function EquipmentTypes_AssignDiscipline_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new EquipmentTypes_AssignDiscipline((objectArg = get$.Required, objectArg.Field("disciplineId", guid)));
    }, path_1, v));
}

export function EquipmentTypes_AssignDiscipline_Encoder_3BAD2904(x) {
    return object_1([["disciplineId", guid_1(x.DisciplineId)]]);
}

export class EquipmentTypes_UpdateEquipmentType extends Record {
    constructor(Name, Detail) {
        super();
        this.Name = Name;
        this.Detail = Detail;
    }
}

export function EquipmentTypes_UpdateEquipmentType_$reflection() {
    return record_type("Types.EquipmentTypes.UpdateEquipmentType", [], EquipmentTypes_UpdateEquipmentType, () => [["Name", string_type], ["Detail", option_type(string_type)]]);
}

export function EquipmentTypes_UpdateEquipmentType_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new EquipmentTypes_UpdateEquipmentType((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Optional, objectArg_1.Field("detail", string)));
    }, path_2, v));
}

export function EquipmentTypes_UpdateEquipmentType_Encoder_Z24BB1CD4(x) {
    return object_1([["name", x.Name], ["detail", option((value_1) => value_1)(x.Detail)]]);
}

export class Tags_Tag extends Record {
    constructor(Id, Name, Detail, FacilityId, ModuleId, AreaId, LocationId, ProductionUnitId, SystemId, SubsystemId, EquipmentTypeId, DeletedOn, CreatedDate, LastModified, LastModifiedBy, LastEventId, Criticality, Condition, Status, SourceDocumentId, Labels, Attributes) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Detail = Detail;
        this.FacilityId = FacilityId;
        this.ModuleId = ModuleId;
        this.AreaId = AreaId;
        this.LocationId = LocationId;
        this.ProductionUnitId = ProductionUnitId;
        this.SystemId = SystemId;
        this.SubsystemId = SubsystemId;
        this.EquipmentTypeId = EquipmentTypeId;
        this.DeletedOn = DeletedOn;
        this.CreatedDate = CreatedDate;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
        this.Criticality = Criticality;
        this.Condition = Condition;
        this.Status = Status;
        this.SourceDocumentId = SourceDocumentId;
        this.Labels = Labels;
        this.Attributes = Attributes;
    }
}

export function Tags_Tag_$reflection() {
    return record_type("Types.Tags.Tag", [], Tags_Tag, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Detail", string_type], ["FacilityId", option_type(class_type("System.Guid"))], ["ModuleId", option_type(class_type("System.Guid"))], ["AreaId", option_type(class_type("System.Guid"))], ["LocationId", option_type(class_type("System.Guid"))], ["ProductionUnitId", option_type(class_type("System.Guid"))], ["SystemId", option_type(class_type("System.Guid"))], ["SubsystemId", option_type(class_type("System.Guid"))], ["EquipmentTypeId", option_type(class_type("System.Guid"))], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["CreatedDate", option_type(class_type("System.DateTimeOffset"))], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")], ["Criticality", option_type(Criticality_$reflection())], ["Condition", option_type(Condition_$reflection())], ["Status", option_type(Status_$reflection())], ["SourceDocumentId", option_type(class_type("System.Guid"))], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["Attributes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Attribute_$reflection()])]]);
}

export function Tags_Tag_get_Decoder() {
    return (path_16) => ((v) => object((get$) => {
        let objectArg_17, objectArg_18, objectArg_19, arg_41, objectArg_20, objectArg_21;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let Detail;
        const objectArg_2 = get$.Required;
        Detail = objectArg_2.Field("detail", string);
        let FacilityId;
        const objectArg_3 = get$.Optional;
        FacilityId = objectArg_3.Field("facilityId", guid);
        let ModuleId;
        const objectArg_4 = get$.Optional;
        ModuleId = objectArg_4.Field("moduleId", guid);
        let AreaId;
        const objectArg_5 = get$.Optional;
        AreaId = objectArg_5.Field("areaId", guid);
        let LocationId;
        const objectArg_6 = get$.Optional;
        LocationId = objectArg_6.Field("locationId", guid);
        let ProductionUnitId;
        const objectArg_7 = get$.Optional;
        ProductionUnitId = objectArg_7.Field("productionUnitId", guid);
        let SystemId;
        const objectArg_8 = get$.Optional;
        SystemId = objectArg_8.Field("systemId", guid);
        let SubsystemId;
        const objectArg_9 = get$.Optional;
        SubsystemId = objectArg_9.Field("subsystemId", guid);
        let EquipmentTypeId;
        const objectArg_10 = get$.Optional;
        EquipmentTypeId = objectArg_10.Field("equipmentTypeId", guid);
        let SourceDocumentId;
        const objectArg_11 = get$.Optional;
        SourceDocumentId = objectArg_11.Field("sourceDocumentId", guid);
        let Criticality;
        const arg_25 = EPM_Domain_Events_Criticality__Criticality_get_Decoder_Static();
        const objectArg_12 = get$.Optional;
        Criticality = objectArg_12.Field("criticality", uncurry2(arg_25));
        let Condition;
        const arg_27 = EPM_Domain_Events_Condition__Condition_get_Decoder_Static();
        const objectArg_13 = get$.Optional;
        Condition = objectArg_13.Field("condition", uncurry2(arg_27));
        let Status;
        const arg_29 = EPM_Domain_Events_Status__Status_get_Decoder_Static();
        const objectArg_14 = get$.Optional;
        Status = objectArg_14.Field("status", uncurry2(arg_29));
        let Labels;
        const objectArg_15 = get$.Required;
        Labels = objectArg_15.Field("labels", uncurry2(labelDecoder));
        let Attributes;
        const arg_33 = dict(uncurry2(EPM_Domain_Events_Attribute__Attribute_get_Decoder_Static()));
        const objectArg_16 = get$.Required;
        Attributes = objectArg_16.Field("attributes", uncurry2(arg_33));
        return new Tags_Tag(Id, Name, Detail, FacilityId, ModuleId, AreaId, LocationId, ProductionUnitId, SystemId, SubsystemId, EquipmentTypeId, (objectArg_17 = get$.Optional, objectArg_17.Field("deletedOn", datetimeOffset)), (objectArg_18 = get$.Optional, objectArg_18.Field("createdDate", datetimeOffset)), (objectArg_19 = get$.Required, objectArg_19.Field("lastModified", datetimeOffset)), (arg_41 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_20 = get$.Required, objectArg_20.Field("lastModifiedBy", uncurry2(arg_41)))), (objectArg_21 = get$.Required, objectArg_21.Field("lastEventId", guid)), Criticality, Condition, Status, SourceDocumentId, Labels, Attributes);
    }, path_16, v));
}

export function Tags_Tag_Encoder_20E5B1DD(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["detail", x.Detail], ["facilityId", option(guid_1)(x.FacilityId)], ["moduleId", option(guid_1)(x.ModuleId)], ["areaId", option(guid_1)(x.AreaId)], ["locationId", option(guid_1)(x.LocationId)], ["productionUnitId", option(guid_1)(x.ProductionUnitId)], ["systemId", option(guid_1)(x.SystemId)], ["subsystemId", option(guid_1)(x.SubsystemId)], ["equipmentTypeId", option(guid_1)(x.EquipmentTypeId)], ["sourceDocumentId", option(guid_1)(x.SourceDocumentId)], ["criticality", option(EPM_Domain_Events_Criticality__Criticality_Encoder_Static_Z13E6B6DD)(x.Criticality)], ["condition", option(EPM_Domain_Events_Condition__Condition_Encoder_Static_3780F71F)(x.Condition)], ["status", option(EPM_Domain_Events_Status__Status_Encoder_Static_Z1C716168)(x.Status)], ["labels", labelEncoder(x.Labels)], ["attributes", attributeEncoder(x.Attributes)], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["createdDate", option(datetimeOffset_1)(x.CreatedDate)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(0, []))]]);
}

export class Tags_AssignEquipmentType extends Record {
    constructor(EquipmentTypeId) {
        super();
        this.EquipmentTypeId = EquipmentTypeId;
    }
}

export function Tags_AssignEquipmentType_$reflection() {
    return record_type("Types.Tags.AssignEquipmentType", [], Tags_AssignEquipmentType, () => [["EquipmentTypeId", class_type("System.Guid")]]);
}

export function Tags_AssignEquipmentType_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Tags_AssignEquipmentType((objectArg = get$.Required, objectArg.Field("equipmentTypeId", guid)));
    }, path_1, v));
}

export function Tags_AssignEquipmentType_Encoder_Z20DA3D64(x) {
    return object_1([["equipmentTypeId", guid_1(x.EquipmentTypeId)]]);
}

export class Tags_MoveToLogicalLocation extends Record {
    constructor(SubsystemId, SystemId, ProductionUnitId) {
        super();
        this.SubsystemId = SubsystemId;
        this.SystemId = SystemId;
        this.ProductionUnitId = ProductionUnitId;
    }
}

export function Tags_MoveToLogicalLocation_$reflection() {
    return record_type("Types.Tags.MoveToLogicalLocation", [], Tags_MoveToLogicalLocation, () => [["SubsystemId", option_type(class_type("System.Guid"))], ["SystemId", option_type(class_type("System.Guid"))], ["ProductionUnitId", option_type(class_type("System.Guid"))]]);
}

export function Tags_MoveToLogicalLocation_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Tags_MoveToLogicalLocation((objectArg = get$.Optional, objectArg.Field("subsystemId", guid)), (objectArg_1 = get$.Optional, objectArg_1.Field("systemId", guid)), (objectArg_2 = get$.Optional, objectArg_2.Field("productionUnitId", guid)));
    }, path_3, v));
}

export function Tags_MoveToLogicalLocation_Encoder_54F1845B(x) {
    return object_1([["subsystemId", option(guid_1)(x.SubsystemId)], ["systemId", option(guid_1)(x.SystemId)], ["productionUnitId", option(guid_1)(x.ProductionUnitId)]]);
}

export class Tags_MoveToPhysicalPosition extends Record {
    constructor(LocationId, AreaId, ModuleId, FacilityId) {
        super();
        this.LocationId = LocationId;
        this.AreaId = AreaId;
        this.ModuleId = ModuleId;
        this.FacilityId = FacilityId;
    }
}

export function Tags_MoveToPhysicalPosition_$reflection() {
    return record_type("Types.Tags.MoveToPhysicalPosition", [], Tags_MoveToPhysicalPosition, () => [["LocationId", option_type(class_type("System.Guid"))], ["AreaId", option_type(class_type("System.Guid"))], ["ModuleId", option_type(class_type("System.Guid"))], ["FacilityId", option_type(class_type("System.Guid"))]]);
}

export function Tags_MoveToPhysicalPosition_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3;
        return new Tags_MoveToPhysicalPosition((objectArg = get$.Optional, objectArg.Field("locationId", guid)), (objectArg_1 = get$.Optional, objectArg_1.Field("areaId", guid)), (objectArg_2 = get$.Optional, objectArg_2.Field("moduleId", guid)), (objectArg_3 = get$.Optional, objectArg_3.Field("facilityId", guid)));
    }, path_4, v));
}

export function Tags_MoveToPhysicalPosition_Encoder_57EECAC9(x) {
    return object_1([["locationId", option(guid_1)(x.LocationId)], ["areaId", option(guid_1)(x.AreaId)], ["moduleId", option(guid_1)(x.ModuleId)], ["facilityId", option(guid_1)(x.FacilityId)]]);
}

export class Tags_AssignCriticality extends Record {
    constructor(Criticality) {
        super();
        this.Criticality = Criticality;
    }
}

export function Tags_AssignCriticality_$reflection() {
    return record_type("Types.Tags.AssignCriticality", [], Tags_AssignCriticality, () => [["Criticality", Criticality_$reflection()]]);
}

export function Tags_AssignCriticality_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg;
        return new Tags_AssignCriticality((arg_1 = EPM_Domain_Events_Criticality__Criticality_get_Decoder_Static(), (objectArg = get$.Required, objectArg.Field("criticality", uncurry2(arg_1)))));
    }, path, v));
}

export function Tags_AssignCriticality_Encoder_676A2961(x) {
    return object_1([["criticality", EPM_Domain_Events_Criticality__Criticality_Encoder_Static_Z13E6B6DD(x.Criticality)]]);
}

export class Tags_AssignCondition extends Record {
    constructor(Condition) {
        super();
        this.Condition = Condition;
    }
}

export function Tags_AssignCondition_$reflection() {
    return record_type("Types.Tags.AssignCondition", [], Tags_AssignCondition, () => [["Condition", Condition_$reflection()]]);
}

export function Tags_AssignCondition_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg;
        return new Tags_AssignCondition((arg_1 = EPM_Domain_Events_Condition__Condition_get_Decoder_Static(), (objectArg = get$.Required, objectArg.Field("condition", uncurry2(arg_1)))));
    }, path, v));
}

export function Tags_AssignCondition_Encoder_390FCD5D(x) {
    return object_1([["condition", EPM_Domain_Events_Condition__Condition_Encoder_Static_3780F71F(x.Condition)]]);
}

export class Tags_AssignStatus extends Record {
    constructor(Status) {
        super();
        this.Status = Status;
    }
}

export function Tags_AssignStatus_$reflection() {
    return record_type("Types.Tags.AssignStatus", [], Tags_AssignStatus, () => [["Status", Status_$reflection()]]);
}

export function Tags_AssignStatus_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg;
        return new Tags_AssignStatus((arg_1 = EPM_Domain_Events_Status__Status_get_Decoder_Static(), (objectArg = get$.Required, objectArg.Field("status", uncurry2(arg_1)))));
    }, path, v));
}

export function Tags_AssignStatus_Encoder_4F7D8E9A(x) {
    return object_1([["status", EPM_Domain_Events_Status__Status_Encoder_Static_Z1C716168(x.Status)]]);
}

export class Tags_UpdateTagDetails extends Record {
    constructor(Name, Detail) {
        super();
        this.Name = Name;
        this.Detail = Detail;
    }
}

export function Tags_UpdateTagDetails_$reflection() {
    return record_type("Types.Tags.UpdateTagDetails", [], Tags_UpdateTagDetails, () => [["Name", string_type], ["Detail", string_type]]);
}

export function Tags_UpdateTagDetails_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Tags_UpdateTagDetails((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)));
    }, path_2, v));
}

export function Tags_UpdateTagDetails_Encoder_Z6EE3A1D2(x) {
    return object_1([["name", x.Name], ["detail", x.Detail]]);
}

export class Tags_CreateTag extends Record {
    constructor(Name, Detail, EquipmentTypeId, SubsystemId, LocationId, Condition, Criticality, Status, Labels) {
        super();
        this.Name = Name;
        this.Detail = Detail;
        this.EquipmentTypeId = EquipmentTypeId;
        this.SubsystemId = SubsystemId;
        this.LocationId = LocationId;
        this.Condition = Condition;
        this.Criticality = Criticality;
        this.Status = Status;
        this.Labels = Labels;
    }
}

export function Tags_CreateTag_$reflection() {
    return record_type("Types.Tags.CreateTag", [], Tags_CreateTag, () => [["Name", string_type], ["Detail", string_type], ["EquipmentTypeId", option_type(class_type("System.Guid"))], ["SubsystemId", option_type(class_type("System.Guid"))], ["LocationId", option_type(class_type("System.Guid"))], ["Condition", option_type(Condition_$reflection())], ["Criticality", option_type(Criticality_$reflection())], ["Status", option_type(Status_$reflection())], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])]]);
}

export function Tags_CreateTag_get_Decoder() {
    return (path_5) => ((v) => object((get$) => {
        let arg_13, objectArg_6, arg_15, objectArg_7, objectArg_8;
        let Name;
        const objectArg = get$.Required;
        Name = objectArg.Field("name", string);
        let Detail;
        const objectArg_1 = get$.Required;
        Detail = objectArg_1.Field("detail", string);
        let EquipmentTypeId;
        const objectArg_2 = get$.Optional;
        EquipmentTypeId = objectArg_2.Field("equipmentTypeId", guid);
        let SubsystemId;
        const objectArg_3 = get$.Optional;
        SubsystemId = objectArg_3.Field("subsystemId", guid);
        let LocationId;
        const objectArg_4 = get$.Optional;
        LocationId = objectArg_4.Field("locationId", guid);
        let Criticality;
        const arg_11 = EPM_Domain_Events_Criticality__Criticality_get_Decoder_Static();
        const objectArg_5 = get$.Optional;
        Criticality = objectArg_5.Field("criticality", uncurry2(arg_11));
        return new Tags_CreateTag(Name, Detail, EquipmentTypeId, SubsystemId, LocationId, (arg_13 = EPM_Domain_Events_Condition__Condition_get_Decoder_Static(), (objectArg_6 = get$.Optional, objectArg_6.Field("condition", uncurry2(arg_13)))), Criticality, (arg_15 = EPM_Domain_Events_Status__Status_get_Decoder_Static(), (objectArg_7 = get$.Optional, objectArg_7.Field("status", uncurry2(arg_15)))), (objectArg_8 = get$.Required, objectArg_8.Field("labels", uncurry2(labelDecoder))));
    }, path_5, v));
}

export function Tags_CreateTag_Encoder_Z4E2CBE07(x) {
    return object_1([["name", x.Name], ["detail", x.Detail], ["locationId", option(guid_1)(x.LocationId)], ["subsystemId", option(guid_1)(x.SubsystemId)], ["equipmentTypeId", option(guid_1)(x.EquipmentTypeId)], ["criticality", option(EPM_Domain_Events_Criticality__Criticality_Encoder_Static_Z13E6B6DD)(x.Criticality)], ["condition", option(EPM_Domain_Events_Condition__Condition_Encoder_Static_3780F71F)(x.Condition)], ["status", option(EPM_Domain_Events_Status__Status_Encoder_Static_Z1C716168)(x.Status)], ["labels", labelEncoder(x.Labels)]]);
}

const Documents_referenceDecoder = (() => {
    const d = dict((path_1, value_1) => list_4(guid, path_1, value_1));
    return (path_2) => ((value_2) => map((m) => ofSeq(choose((kv) => {
        const matchValue = fromString(uncurry2(EPM_Domain_Events_DomainEntities__DomainEntities_get_Decoder_Static()), kv[0]);
        if (matchValue.tag === 1) {
            return undefined;
        }
        else {
            return [matchValue.fields[0], ofList(kv[1], {
                Compare: comparePrimitives,
            })];
        }
    }, m), {
        Compare: compare,
    }), uncurry2(d), path_2, value_2));
})();

export function EPM_Domain_Events_Document_DirectUploadRevision__DirectUploadRevision_get_Decoder_Static() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Document_DirectUploadRevision((objectArg = get$.Required, objectArg.Field("fileName", string)), (objectArg_1 = get$.Required, objectArg_1.Field("fileType", string)));
    }, path_2, v));
}

export function EPM_Domain_Events_Document_DirectUploadRevision__DirectUploadRevision_Encoder_Static_5B3E530(x) {
    return object_1([["fileName", x.FileName], ["fileType", x.FileType]]);
}

export class Documents_Revision extends Record {
    constructor(RevisionId, Data, ExternalSourceUrl, Revision, Reason, UploadedOn, UploadedBy) {
        super();
        this.RevisionId = RevisionId;
        this.Data = Data;
        this.ExternalSourceUrl = ExternalSourceUrl;
        this.Revision = (Revision | 0);
        this.Reason = Reason;
        this.UploadedOn = UploadedOn;
        this.UploadedBy = UploadedBy;
    }
}

export function Documents_Revision_$reflection() {
    return record_type("Types.Documents.Revision", [], Documents_Revision, () => [["RevisionId", class_type("System.Guid")], ["Data", option_type(Document_DirectUploadRevision_$reflection())], ["ExternalSourceUrl", option_type(string_type)], ["Revision", int32_type], ["Reason", option_type(string_type)], ["UploadedOn", class_type("System.DateTimeOffset")], ["UploadedBy", By_$reflection()]]);
}

export function Documents_Revision_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg, arg_3, objectArg_1, objectArg_2, objectArg_3, objectArg_4, objectArg_5, arg_13, objectArg_6;
        return new Documents_Revision((objectArg = get$.Required, objectArg.Field("revisionId", guid)), (arg_3 = EPM_Domain_Events_Document_DirectUploadRevision__DirectUploadRevision_get_Decoder_Static(), (objectArg_1 = get$.Optional, objectArg_1.Field("data", uncurry2(arg_3)))), (objectArg_2 = get$.Optional, objectArg_2.Field("externalSourceUrl", string)), (objectArg_3 = get$.Required, objectArg_3.Field("revision", uncurry2(int))), (objectArg_4 = get$.Optional, objectArg_4.Field("reason", string)), (objectArg_5 = get$.Required, objectArg_5.Field("uploadedOn", datetimeOffset)), (arg_13 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_6 = get$.Required, objectArg_6.Field("uploadedBy", uncurry2(arg_13)))));
    }, path_4, v));
}

export function Documents_Revision_Encoder_5FB391E1(x) {
    return object_1([["revisionId", guid_1(x.RevisionId)], ["data", option(EPM_Domain_Events_Document_DirectUploadRevision__DirectUploadRevision_Encoder_Static_5B3E530)(x.Data)], ["externalSourceUrl", option((value) => value)(x.ExternalSourceUrl)], ["revision", x.Revision], ["Reason", option((value_3) => value_3)(x.Reason)], ["uploadedOn", datetimeOffset_1(x.UploadedOn)], ["uploadedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.UploadedBy)]]);
}

export class Documents_Document extends Record {
    constructor(Id, Name, Detail, Labels, References, PreviousRevisions, CurrentRevision, LastModified, LastModifiedBy, LastEventId, DeletedOn, CreatedDate, Reason) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Detail = Detail;
        this.Labels = Labels;
        this.References = References;
        this.PreviousRevisions = PreviousRevisions;
        this.CurrentRevision = CurrentRevision;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
        this.DeletedOn = DeletedOn;
        this.CreatedDate = CreatedDate;
        this.Reason = Reason;
    }
}

export function Documents_Document_$reflection() {
    return record_type("Types.Documents.Document", [], Documents_Document, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Detail", option_type(string_type)], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["References", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [DomainEntities_$reflection(), class_type("Microsoft.FSharp.Collections.FSharpSet`1", [class_type("System.Guid")])])], ["PreviousRevisions", list_type(Documents_Revision_$reflection())], ["CurrentRevision", Documents_Revision_$reflection()], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["CreatedDate", option_type(class_type("System.DateTimeOffset"))], ["Reason", option_type(string_type)]]);
}

export function Documents_Document_get_Decoder() {
    return (path_9) => ((v) => object((get$) => {
        let objectArg_10, arg_23, objectArg_11, objectArg_12;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let Detail;
        const objectArg_2 = get$.Optional;
        Detail = objectArg_2.Field("detail", string);
        let Reason;
        const objectArg_3 = get$.Optional;
        Reason = objectArg_3.Field("reason", string);
        let Labels;
        const objectArg_4 = get$.Required;
        Labels = objectArg_4.Field("labels", uncurry2(labelDecoder));
        let References;
        const objectArg_5 = get$.Required;
        References = objectArg_5.Field("references", uncurry2(Documents_referenceDecoder));
        let PreviousRevisions;
        let arg_13;
        const decoder = Documents_Revision_get_Decoder();
        arg_13 = ((path_4) => ((value_4) => list_4(uncurry2(decoder), path_4, value_4)));
        const objectArg_6 = get$.Required;
        PreviousRevisions = objectArg_6.Field("previousRevisions", uncurry2(arg_13));
        let CurrentRevision;
        const arg_15 = Documents_Revision_get_Decoder();
        const objectArg_7 = get$.Required;
        CurrentRevision = objectArg_7.Field("currentRevision", uncurry2(arg_15));
        let DeletedOn;
        const objectArg_8 = get$.Optional;
        DeletedOn = objectArg_8.Field("deletedOn", datetimeOffset);
        let CreatedDate;
        const objectArg_9 = get$.Optional;
        CreatedDate = objectArg_9.Field("createdDate", datetimeOffset);
        return new Documents_Document(Id, Name, Detail, Labels, References, PreviousRevisions, CurrentRevision, (objectArg_10 = get$.Required, objectArg_10.Field("lastModified", datetimeOffset)), (arg_23 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_11 = get$.Required, objectArg_11.Field("lastModifiedBy", uncurry2(arg_23)))), (objectArg_12 = get$.Required, objectArg_12.Field("lastEventId", guid)), DeletedOn, CreatedDate, Reason);
    }, path_9, v));
}

export function Documents_Document_Encoder_479734FD(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["detail", option((value_1) => value_1)(x.Detail)], ["reason", option((value_3) => value_3)(x.Reason)], ["labels", labelEncoder(x.Labels)], ["references", dict_1(ofSeq(map_2((keyValue) => [toString(4, EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(keyValue[0])), seq(map_2(guid_1, keyValue[1]))], x.References), {
        Compare: comparePrimitives,
    }))], ["previousRevisions", list_5(map_3(Documents_Revision_Encoder_5FB391E1, x.PreviousRevisions))], ["currentRevision", Documents_Revision_Encoder_5FB391E1(x.CurrentRevision)], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["createdDate", option(datetimeOffset_1)(x.CreatedDate)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(9, []))]]);
}

export class Documents_CreateDocument extends Record {
    constructor(Name, Detail, Labels, References, ExternalSourceUrl) {
        super();
        this.Name = Name;
        this.Detail = Detail;
        this.Labels = Labels;
        this.References = References;
        this.ExternalSourceUrl = ExternalSourceUrl;
    }
}

export function Documents_CreateDocument_$reflection() {
    return record_type("Types.Documents.CreateDocument", [], Documents_CreateDocument, () => [["Name", string_type], ["Detail", option_type(string_type)], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["References", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [DomainEntities_$reflection(), class_type("Microsoft.FSharp.Collections.FSharpSet`1", [class_type("System.Guid")])])], ["ExternalSourceUrl", option_type(string_type)]]);
}

export function Documents_CreateDocument_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, objectArg_4;
        return new Documents_CreateDocument((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Optional, objectArg_1.Field("detail", string)), (objectArg_2 = get$.Required, objectArg_2.Field("labels", uncurry2(labelDecoder))), (objectArg_3 = get$.Required, objectArg_3.Field("references", uncurry2(Documents_referenceDecoder))), (objectArg_4 = get$.Optional, objectArg_4.Field("externalSourceUrl", string)));
    }, path_3, v));
}

export function Documents_CreateDocument_Encoder_6A14F819(x) {
    return object_1([["name", x.Name], ["detail", option((value_1) => value_1)(x.Detail)], ["labels", labelEncoder(x.Labels)], ["externalSourceUrl", option((value_3) => value_3)(x.ExternalSourceUrl)], ["references", dict_1(ofSeq(map_2((keyValue) => [toString(4, EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(keyValue[0])), seq(map_2(guid_1, keyValue[1]))], x.References), {
        Compare: comparePrimitives,
    }))]]);
}

export class Documents_UpdateDocument extends Record {
    constructor(Name, Detail) {
        super();
        this.Name = Name;
        this.Detail = Detail;
    }
}

export function Documents_UpdateDocument_$reflection() {
    return record_type("Types.Documents.UpdateDocument", [], Documents_UpdateDocument, () => [["Name", string_type], ["Detail", string_type]]);
}

export function Documents_UpdateDocument_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Documents_UpdateDocument((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)));
    }, path_2, v));
}

export function Documents_UpdateDocument_Encoder_Z222AFD54(x) {
    return object_1([["name", x.Name], ["detail", x.Detail]]);
}

export class Documents_ChangeReferences extends Record {
    constructor(References) {
        super();
        this.References = References;
    }
}

export function Documents_ChangeReferences_$reflection() {
    return record_type("Types.Documents.ChangeReferences", [], Documents_ChangeReferences, () => [["References", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [DomainEntities_$reflection(), class_type("Microsoft.FSharp.Collections.FSharpSet`1", [class_type("System.Guid")])])]]);
}

export function Documents_ChangeReferences_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let objectArg;
        return new Documents_ChangeReferences((objectArg = get$.Required, objectArg.Field("references", uncurry2(Documents_referenceDecoder))));
    }, path, v));
}

export function Documents_ChangeReferences_Encoder_36D9B48C(x) {
    return object_1([["references", dict_1(ofSeq(map_2((keyValue) => [toString(4, EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(keyValue[0])), seq(map_2(guid_1, keyValue[1]))], x.References), {
        Compare: comparePrimitives,
    }))]]);
}

export class ActionTypes_ActionType extends Record {
    constructor(Id, Name, Detail, DeletedOn, LastModified, LastModifiedBy, LastEventId) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Detail = Detail;
        this.DeletedOn = DeletedOn;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
    }
}

export function ActionTypes_ActionType_$reflection() {
    return record_type("Types.ActionTypes.ActionType", [], ActionTypes_ActionType, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Detail", string_type], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")]]);
}

export function ActionTypes_ActionType_get_Decoder() {
    return (path_6) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, objectArg_4, arg_11, objectArg_5, objectArg_6;
        return new ActionTypes_ActionType((objectArg = get$.Required, objectArg.Field("id", guid)), (objectArg_1 = get$.Required, objectArg_1.Field("name", string)), (objectArg_2 = get$.Required, objectArg_2.Field("detail", string)), (objectArg_3 = get$.Optional, objectArg_3.Field("deletedOn", datetimeOffset)), (objectArg_4 = get$.Required, objectArg_4.Field("lastModified", datetimeOffset)), (arg_11 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_5 = get$.Required, objectArg_5.Field("lastModifiedBy", uncurry2(arg_11)))), (objectArg_6 = get$.Required, objectArg_6.Field("lastEventId", guid)));
    }, path_6, v));
}

export function ActionTypes_ActionType_Encoder_Z5A262403(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["detail", x.Detail], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(12, []))]]);
}

export class ActionTypes_CreateActionType extends Record {
    constructor(Name, Detail) {
        super();
        this.Name = Name;
        this.Detail = Detail;
    }
}

export function ActionTypes_CreateActionType_$reflection() {
    return record_type("Types.ActionTypes.CreateActionType", [], ActionTypes_CreateActionType, () => [["Name", string_type], ["Detail", string_type]]);
}

export function ActionTypes_CreateActionType_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new ActionTypes_CreateActionType((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)));
    }, path_2, v));
}

export function ActionTypes_CreateActionType_Encoder_65190D59(x) {
    return object_1([["name", x.Name], ["detail", x.Detail]]);
}

export class ActionTypes_UpdateActionType extends Record {
    constructor(Name, Detail) {
        super();
        this.Name = Name;
        this.Detail = Detail;
    }
}

export function ActionTypes_UpdateActionType_$reflection() {
    return record_type("Types.ActionTypes.UpdateActionType", [], ActionTypes_UpdateActionType, () => [["Name", string_type], ["Detail", string_type]]);
}

export function ActionTypes_UpdateActionType_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new ActionTypes_UpdateActionType((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)));
    }, path_2, v));
}

export function ActionTypes_UpdateActionType_Encoder_5BB3E0AC(x) {
    return object_1([["name", x.Name], ["detail", x.Detail]]);
}

export function EPM_Domain_Events_Action_Category__Category_get_Decoder_Static() {
    return (path_2) => ((value_1) => andThen(uncurry3((s) => {
        switch (s) {
            case "Activity":
                return (arg10$0040) => ((arg20$0040) => succeed(new Action_Category(0, []), arg10$0040, arg20$0040));
            case "Certification":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Action_Category(1, []), arg10$0040_1, arg20$0040_1));
            case "PunchList":
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Action_Category(2, []), arg10$0040_2, arg20$0040_2));
            case "Document":
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Action_Category(3, []), arg10$0040_3, arg20$0040_3));
            case "Preservation":
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Action_Category(4, []), arg10$0040_4, arg20$0040_4));
            case "TechnicalQuery":
                return (arg10$0040_5) => ((arg20$0040_5) => succeed(new Action_Category(5, []), arg10$0040_5, arg20$0040_5));
            case "NonConformanceReport":
                return (arg10$0040_6) => ((arg20$0040_6) => succeed(new Action_Category(6, []), arg10$0040_6, arg20$0040_6));
            default:
                return (path_1) => ((arg20$0040_7) => fail("Unrecognised Category", path_1, arg20$0040_7));
        }
    }), string, path_2, value_1));
}

export function EPM_Domain_Events_Action_Category__Category_Encoder_Static_43D4D52C(x) {
    switch (x.tag) {
        case 1:
            return "Certification";
        case 2:
            return "PunchList";
        case 3:
            return "Document";
        case 4:
            return "Preservation";
        case 5:
            return "TechnicalQuery";
        case 6:
            return "NonConformanceReport";
        default:
            return "Activity";
    }
}

export function EPM_Domain_Events_Action_TargetBy__TargetBy_get_Decoder_Static() {
    return (path_2) => ((v) => object((get$) => {
        let arg_1, objectArg, objectArg_1;
        return new Action_TargetBy((arg_1 = EPM_Domain_Events_DomainEntities__DomainEntities_get_Decoder_Static(), (objectArg = get$.Required, objectArg.Field("byType", uncurry2(arg_1)))), (objectArg_1 = get$.Required, objectArg_1.Field("ids", (path_1, value_1) => list_4(guid, path_1, value_1))));
    }, path_2, v));
}

export function EPM_Domain_Events_Action_TargetBy__TargetBy_Encoder_Static_Z18B81CCA(x) {
    return object_1([["byType", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(x.ByType)], ["ids", list_5(map_3(guid_1, x.Ids))]]);
}

export function EPM_Domain_Events_Action_TargetingMethod__TargetingMethod_get_Decoder_Static() {
    let decoder_1;
    const decoders = ofArray([(path_2) => ((value_1) => andThen(uncurry3((s) => {
        if (s === "All") {
            return (arg10$0040) => ((arg20$0040) => succeed(new Action_TargetingMethod(0, []), arg10$0040, arg20$0040));
        }
        else {
            return (path_1) => ((arg20$0040_1) => fail("Not a recognised target method", path_1, arg20$0040_1));
        }
    }), string, path_2, value_1)), (decoder_1 = EPM_Domain_Events_Action_TargetBy__TargetBy_get_Decoder_Static(), (path_3) => ((value_2) => andThen((arg, arg10$0040_1, arg20$0040_2) => succeed(new Action_TargetingMethod(1, [arg]), arg10$0040_1, arg20$0040_2), uncurry2(decoder_1), path_3, value_2)))]);
    return (path_4) => ((value_3) => oneOf(decoders, path_4, value_3));
}

export function EPM_Domain_Events_Action_TargetingMethod__TargetingMethod_Encoder_Static_439B98F2(x) {
    if (x.tag === 1) {
        return EPM_Domain_Events_Action_TargetBy__TargetBy_Encoder_Static_Z18B81CCA(x.fields[0]);
    }
    else {
        return "All";
    }
}

export function EPM_Domain_Events_Action_Target__Target_get_Decoder_Static() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg, arg_3, objectArg_1;
        return new Action_Target((arg_1 = EPM_Domain_Events_DomainEntities__DomainEntities_get_Decoder_Static(), (objectArg = get$.Required, objectArg.Field("targetType", uncurry2(arg_1)))), (arg_3 = EPM_Domain_Events_Action_TargetingMethod__TargetingMethod_get_Decoder_Static(), (objectArg_1 = get$.Required, objectArg_1.Field("method", uncurry2(arg_3)))));
    }, path, v));
}

export function EPM_Domain_Events_Action_Target__Target_Encoder_Static_4208C38D(x) {
    return object_1([["targetType", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(x.TargetType)], ["method", EPM_Domain_Events_Action_TargetingMethod__TargetingMethod_Encoder_Static_439B98F2(x.Method)]]);
}

export function EPM_Domain_Events_Action_TargetLimits__TargetLimits_get_Decoder_Static() {
    return (path_7) => ((v) => object((get$) => {
        let objectArg, arg_3, decoder, objectArg_1, arg_5, decoder_1, objectArg_2;
        return new Action_TargetLimits((objectArg = get$.Optional, objectArg.Field("disciplineId", guid)), (arg_3 = ((decoder = tuple2(string, string), (path_3) => ((value_3) => list_4(uncurry2(decoder), path_3, value_3)))), (objectArg_1 = get$.Required, objectArg_1.Field("requiredLabels", uncurry2(arg_3)))), (arg_5 = ((decoder_1 = tuple2(string, string), (path_6) => ((value_6) => list_4(uncurry2(decoder_1), path_6, value_6)))), (objectArg_2 = get$.Required, objectArg_2.Field("excludedLabels", uncurry2(arg_5)))));
    }, path_7, v));
}

export function EPM_Domain_Events_Action_TargetLimits__TargetLimits_Encoder_Static_2A80EFCB(x) {
    return object_1([["disciplineId", option(guid_1)(x.DisciplineId)], ["requiredLabels", list_5(map_3((tupledArg) => tuple2_1((value_1) => value_1, (value_3) => value_3, tupledArg[0], tupledArg[1]), x.RequiredLabels))], ["excludedLabels", list_5(map_3((tupledArg_1) => tuple2_1((value_5) => value_5, (value_7) => value_7, tupledArg_1[0], tupledArg_1[1]), x.ExcludedLabels))]]);
}

export function EPM_Domain_Events_Action_ActivityLimits__ActivityLimits_get_Decoder_Static() {
    return (path_6) => ((v) => object((get$) => {
        let arg_1, decoder, objectArg, arg_3, decoder_1, objectArg_1;
        return new Action_ActivityLimits((arg_1 = ((decoder = tuple2(string, string), (path_2) => ((value_2) => list_4(uncurry2(decoder), path_2, value_2)))), (objectArg = get$.Required, objectArg.Field("requiredLabels", uncurry2(arg_1)))), (arg_3 = ((decoder_1 = tuple2(string, string), (path_5) => ((value_5) => list_4(uncurry2(decoder_1), path_5, value_5)))), (objectArg_1 = get$.Required, objectArg_1.Field("excludedLabels", uncurry2(arg_3)))));
    }, path_6, v));
}

export function EPM_Domain_Events_Action_ActivityLimits__ActivityLimits_Encoder_Static_5527D5D7(x) {
    return object_1([["requiredLabels", list_5(map_3((tupledArg) => tuple2_1((value) => value, (value_2) => value_2, tupledArg[0], tupledArg[1]), x.RequiredLabels))], ["excludedLabels", list_5(map_3((tupledArg_1) => tuple2_1((value_4) => value_4, (value_6) => value_6, tupledArg_1[0], tupledArg_1[1]), x.ExcludedLabels))]]);
}

export function EPM_Domain_Events_Action_Scope__Scope_get_Decoder_Static() {
    return (path_2) => ((value_1) => andThen(uncurry3((s) => {
        switch (s) {
            case "ActivityTarget":
                return (arg10$0040) => ((arg20$0040) => succeed(new Action_Scope(1, []), arg10$0040, arg20$0040));
            case "ActivityTargetChildren":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Action_Scope(0, []), arg10$0040_1, arg20$0040_1));
            default:
                return (path_1) => ((arg20$0040_2) => fail("Unrecognised Scope", path_1, arg20$0040_2));
        }
    }), string, path_2, value_1));
}

export function EPM_Domain_Events_Action_Scope__Scope_Encoder_Static_4FA66976(x) {
    if (x.tag === 0) {
        return "ActivityTargetChildren";
    }
    else {
        return "ActivityTarget";
    }
}

export function EPM_Domain_Events_Action_ActionDependenciesSet__ActionDependenciesSet_get_Decoder_Static() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, arg_3, objectArg_1, arg_5, objectArg_2, arg_7, objectArg_3;
        return new Action_ActionDependenciesSet((objectArg = get$.Required, objectArg.Field("actionIds", (path_1, value_1) => list_4(guid, path_1, value_1))), (arg_3 = EPM_Domain_Events_Action_Scope__Scope_get_Decoder_Static(), (objectArg_1 = get$.Required, objectArg_1.Field("scope", uncurry2(arg_3)))), (arg_5 = EPM_Domain_Events_Action_TargetLimits__TargetLimits_get_Decoder_Static(), (objectArg_2 = get$.Optional, objectArg_2.Field("targetLimits", uncurry2(arg_5)))), (arg_7 = EPM_Domain_Events_Action_ActivityLimits__ActivityLimits_get_Decoder_Static(), (objectArg_3 = get$.Optional, objectArg_3.Field("activityLimits", uncurry2(arg_7)))));
    }, path_2, v));
}

export function EPM_Domain_Events_Action_ActionDependenciesSet__ActionDependenciesSet_Encoder_Static_Z15462B57(x) {
    return object_1([["actionIds", list_5(map_3(guid_1, x.ActionIds))], ["scope", EPM_Domain_Events_Action_Scope__Scope_Encoder_Static_4FA66976(x.Scope)], ["targetLimits", option(EPM_Domain_Events_Action_TargetLimits__TargetLimits_Encoder_Static_2A80EFCB)(x.TargetLimits)], ["activityLimits", option(EPM_Domain_Events_Action_ActivityLimits__ActivityLimits_Encoder_Static_5527D5D7)(x.ActivityLimits)]]);
}

export function EPM_Domain_Events_Action_Fulfillment__Fulfillment_get_Decoder_Static() {
    return (path_2) => ((value_1) => andThen(uncurry3((s) => {
        switch (s) {
            case "SignOff":
                return (arg10$0040) => ((arg20$0040) => succeed(new Action_Fulfillment(0, []), arg10$0040, arg20$0040));
            case "Documents":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Action_Fulfillment(1, []), arg10$0040_1, arg20$0040_1));
            case "Comment":
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Action_Fulfillment(2, []), arg10$0040_2, arg20$0040_2));
            case "Number":
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Action_Fulfillment(3, []), arg10$0040_3, arg20$0040_3));
            case "Images":
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Action_Fulfillment(4, []), arg10$0040_4, arg20$0040_4));
            case "Videos":
                return (arg10$0040_5) => ((arg20$0040_5) => succeed(new Action_Fulfillment(5, []), arg10$0040_5, arg20$0040_5));
            default:
                return (path_1) => ((arg20$0040_6) => fail("Unrecognised Fulfillment", path_1, arg20$0040_6));
        }
    }), string, path_2, value_1));
}

export function EPM_Domain_Events_Action_Fulfillment__Fulfillment_Encoder_Static_4AB7965E(x) {
    switch (x.tag) {
        case 1:
            return "Documents";
        case 2:
            return "Comment";
        case 3:
            return "Number";
        case 4:
            return "Images";
        case 5:
            return "Videos";
        default:
            return "SignOff";
    }
}

export class Actions_Step extends Record {
    constructor(Id, Name, Sequence, Detail, Fulfillment, Required, RemovedOn, RemovedBy) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Sequence = (Sequence | 0);
        this.Detail = Detail;
        this.Fulfillment = Fulfillment;
        this.Required = Required;
        this.RemovedOn = RemovedOn;
        this.RemovedBy = RemovedBy;
    }
}

export function Actions_Step_$reflection() {
    return record_type("Types.Actions.Step", [], Actions_Step, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Sequence", int32_type], ["Detail", string_type], ["Fulfillment", Action_Fulfillment_$reflection()], ["Required", bool_type], ["RemovedOn", option_type(class_type("System.DateTimeOffset"))], ["RemovedBy", option_type(class_type("System.Guid"))]]);
}

export function Actions_Step_get_Decoder() {
    return (path_6) => ((v) => object((get$) => {
        let objectArg_3, arg_9, objectArg_4, objectArg_5, objectArg_6, objectArg_7;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let Detail;
        const objectArg_2 = get$.Required;
        Detail = objectArg_2.Field("detail", string);
        return new Actions_Step(Id, Name, (objectArg_3 = get$.Required, objectArg_3.Field("sequence", uncurry2(int))), Detail, (arg_9 = EPM_Domain_Events_Action_Fulfillment__Fulfillment_get_Decoder_Static(), (objectArg_4 = get$.Required, objectArg_4.Field("fulfillment", uncurry2(arg_9)))), (objectArg_5 = get$.Required, objectArg_5.Field("required", bool)), (objectArg_6 = get$.Optional, objectArg_6.Field("removedOn", datetimeOffset)), (objectArg_7 = get$.Optional, objectArg_7.Field("removedBy", guid)));
    }, path_6, v));
}

export function Actions_Step_Encoder_Z726DC8F(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["detail", x.Detail], ["sequence", x.Sequence], ["fulfillment", EPM_Domain_Events_Action_Fulfillment__Fulfillment_Encoder_Static_4AB7965E(x.Fulfillment)], ["required", x.Required], ["removedOn", option(datetimeOffset_1)(x.RemovedOn)], ["removedBy", option(guid_1)(x.RemovedBy)]]);
}

export class Actions_Action extends Record {
    constructor(Id, Detail, Name, Caption, Labels, EstimatedCompletionTime, Maturity, Category, Target, Steps, ActionTypeId, LastModified, LastModifiedBy, LastEventId, DeletedOn, ActionDependencies) {
        super();
        this.Id = Id;
        this.Detail = Detail;
        this.Name = Name;
        this.Caption = Caption;
        this.Labels = Labels;
        this.EstimatedCompletionTime = EstimatedCompletionTime;
        this.Maturity = Maturity;
        this.Category = Category;
        this.Target = Target;
        this.Steps = Steps;
        this.ActionTypeId = ActionTypeId;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
        this.DeletedOn = DeletedOn;
        this.ActionDependencies = ActionDependencies;
    }
}

export function Actions_Action_$reflection() {
    return record_type("Types.Actions.Action", [], Actions_Action, () => [["Id", class_type("System.Guid")], ["Detail", string_type], ["Name", string_type], ["Caption", string_type], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["EstimatedCompletionTime", option_type(class_type("System.TimeSpan"))], ["Maturity", Maturity_$reflection()], ["Category", Action_Category_$reflection()], ["Target", option_type(Action_Target_$reflection())], ["Steps", list_type(Actions_Step_$reflection())], ["ActionTypeId", option_type(class_type("System.Guid"))], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["ActionDependencies", option_type(Action_ActionDependenciesSet_$reflection())]]);
}

export function Actions_Action_get_Decoder() {
    return (path_10) => ((v) => object((get$) => {
        let objectArg_12, arg_27, objectArg_13, objectArg_14, arg_31, objectArg_15;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Name;
        const objectArg_1 = get$.Required;
        Name = objectArg_1.Field("name", string);
        let Detail;
        const objectArg_2 = get$.Required;
        Detail = objectArg_2.Field("detail", string);
        let Caption;
        const objectArg_3 = get$.Required;
        Caption = objectArg_3.Field("caption", string);
        let Labels;
        const objectArg_4 = get$.Required;
        Labels = objectArg_4.Field("labels", uncurry2(labelDecoder));
        let EstimatedCompletionTime;
        const objectArg_5 = get$.Optional;
        EstimatedCompletionTime = objectArg_5.Field("estimatedCompletionTime", timespan);
        let Maturity;
        const arg_13 = EPM_Domain_Events_Maturity__Maturity_get_Decoder_Static();
        const objectArg_6 = get$.Required;
        Maturity = objectArg_6.Field("maturity", uncurry2(arg_13));
        let Category;
        const arg_15 = EPM_Domain_Events_Action_Category__Category_get_Decoder_Static();
        const objectArg_7 = get$.Required;
        Category = objectArg_7.Field("category", uncurry2(arg_15));
        let Target;
        const arg_17 = EPM_Domain_Events_Action_Target__Target_get_Decoder_Static();
        const objectArg_8 = get$.Optional;
        Target = objectArg_8.Field("target", uncurry2(arg_17));
        let Steps;
        let arg_19;
        const decoder = Actions_Step_get_Decoder();
        arg_19 = ((path_5) => ((value_5) => list_4(uncurry2(decoder), path_5, value_5)));
        const objectArg_9 = get$.Required;
        Steps = objectArg_9.Field("steps", uncurry2(arg_19));
        let ActionTypeId;
        const objectArg_10 = get$.Optional;
        ActionTypeId = objectArg_10.Field("actionTypeId", guid);
        let DeletedOn;
        const objectArg_11 = get$.Optional;
        DeletedOn = objectArg_11.Field("deletedOn", datetimeOffset);
        return new Actions_Action(Id, Detail, Name, Caption, Labels, EstimatedCompletionTime, Maturity, Category, Target, Steps, ActionTypeId, (objectArg_12 = get$.Required, objectArg_12.Field("lastModified", datetimeOffset)), (arg_27 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_13 = get$.Required, objectArg_13.Field("lastModifiedBy", uncurry2(arg_27)))), (objectArg_14 = get$.Required, objectArg_14.Field("lastEventId", guid)), DeletedOn, (arg_31 = EPM_Domain_Events_Action_ActionDependenciesSet__ActionDependenciesSet_get_Decoder_Static(), (objectArg_15 = get$.Optional, objectArg_15.Field("actionDependencies", uncurry2(arg_31)))));
    }, path_10, v));
}

export function Actions_Action_Encoder_7C7CF17D(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["detail", x.Detail], ["caption", x.Caption], ["labels", labelEncoder(x.Labels)], ["estimatedCompletionTime", option(timespan_1)(x.EstimatedCompletionTime)], ["maturity", EPM_Domain_Events_Maturity__Maturity_Encoder_Static_4DC9A197(x.Maturity)], ["category", EPM_Domain_Events_Action_Category__Category_Encoder_Static_43D4D52C(x.Category)], ["target", option(EPM_Domain_Events_Action_Target__Target_Encoder_Static_4208C38D)(x.Target)], ["steps", list_5(map_3(Actions_Step_Encoder_Z726DC8F, x.Steps))], ["actionTypeId", option(guid_1)(x.ActionTypeId)], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["actionDependencies", option(EPM_Domain_Events_Action_ActionDependenciesSet__ActionDependenciesSet_Encoder_Static_Z15462B57)(x.ActionDependencies)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(11, []))]]);
}

export class Actions_CreateAction extends Record {
    constructor(Name, Detail, Caption, Category, Target, ActionTypeId, Labels) {
        super();
        this.Name = Name;
        this.Detail = Detail;
        this.Caption = Caption;
        this.Category = Category;
        this.Target = Target;
        this.ActionTypeId = ActionTypeId;
        this.Labels = Labels;
    }
}

export function Actions_CreateAction_$reflection() {
    return record_type("Types.Actions.CreateAction", [], Actions_CreateAction, () => [["Name", string_type], ["Detail", string_type], ["Caption", string_type], ["Category", Action_Category_$reflection()], ["Target", option_type(Action_Target_$reflection())], ["ActionTypeId", option_type(class_type("System.Guid"))], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])]]);
}

export function Actions_CreateAction_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, arg_7, objectArg_3, arg_9, objectArg_4, objectArg_5, objectArg_6;
        return new Actions_CreateAction((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)), (objectArg_2 = get$.Required, objectArg_2.Field("caption", string)), (arg_7 = EPM_Domain_Events_Action_Category__Category_get_Decoder_Static(), (objectArg_3 = get$.Required, objectArg_3.Field("category", uncurry2(arg_7)))), (arg_9 = EPM_Domain_Events_Action_Target__Target_get_Decoder_Static(), (objectArg_4 = get$.Optional, objectArg_4.Field("target", uncurry2(arg_9)))), (objectArg_5 = get$.Optional, objectArg_5.Field("actionTypeId", guid)), (objectArg_6 = get$.Required, objectArg_6.Field("labels", uncurry2(labelDecoder))));
    }, path_4, v));
}

export function Actions_CreateAction_Encoder_Z7860127(x) {
    return object_1([["name", x.Name], ["detail", x.Detail], ["caption", x.Caption], ["category", EPM_Domain_Events_Action_Category__Category_Encoder_Static_43D4D52C(x.Category)], ["target", option(EPM_Domain_Events_Action_Target__Target_Encoder_Static_4208C38D)(x.Target)], ["actionTypeId", option(guid_1)(x.ActionTypeId)], ["labels", labelEncoder(x.Labels)]]);
}

export class Actions_ChangeCategory extends Record {
    constructor(Category) {
        super();
        this.Category = Category;
    }
}

export function Actions_ChangeCategory_$reflection() {
    return record_type("Types.Actions.ChangeCategory", [], Actions_ChangeCategory, () => [["Category", Action_Category_$reflection()]]);
}

export function Actions_ChangeCategory_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg;
        return new Actions_ChangeCategory((arg_1 = EPM_Domain_Events_Action_Category__Category_get_Decoder_Static(), (objectArg = get$.Required, objectArg.Field("category", uncurry2(arg_1)))));
    }, path, v));
}

export function Actions_ChangeCategory_Encoder_Z3DC9DB0B(x) {
    return object_1([["category", EPM_Domain_Events_Action_Category__Category_Encoder_Static_43D4D52C(x.Category)]]);
}

export class Actions_AssignActionHours extends Record {
    constructor(Time) {
        super();
        this.Time = Time;
    }
}

export function Actions_AssignActionHours_$reflection() {
    return record_type("Types.Actions.AssignActionHours", [], Actions_AssignActionHours, () => [["Time", decimal_type]]);
}

export function Actions_AssignActionHours_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Actions_AssignActionHours((objectArg = get$.Required, objectArg.Field("time", decimal)));
    }, path_1, v));
}

export function Actions_AssignActionHours_Encoder_Z11AF16F1(x) {
    return object_1([["time", decimal_1(x.Time)]]);
}

export class Actions_AssignActionType extends Record {
    constructor(ActionTypeId) {
        super();
        this.ActionTypeId = ActionTypeId;
    }
}

export function Actions_AssignActionType_$reflection() {
    return record_type("Types.Actions.AssignActionType", [], Actions_AssignActionType, () => [["ActionTypeId", class_type("System.Guid")]]);
}

export function Actions_AssignActionType_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Actions_AssignActionType((objectArg = get$.Required, objectArg.Field("actionTypeId", guid)));
    }, path_1, v));
}

export function Actions_AssignActionType_Encoder_Z6D2AF33C(x) {
    return object_1([["actionTypeId", guid_1(x.ActionTypeId)]]);
}

export class Actions_UpdateAction extends Record {
    constructor(Name, Detail, Caption) {
        super();
        this.Name = Name;
        this.Detail = Detail;
        this.Caption = Caption;
    }
}

export function Actions_UpdateAction_$reflection() {
    return record_type("Types.Actions.UpdateAction", [], Actions_UpdateAction, () => [["Name", string_type], ["Detail", string_type], ["Caption", string_type]]);
}

export function Actions_UpdateAction_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Actions_UpdateAction((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)), (objectArg_2 = get$.Required, objectArg_2.Field("caption", string)));
    }, path_3, v));
}

export function Actions_UpdateAction_Encoder_Z524332D4(x) {
    return object_1([["name", x.Name], ["detail", x.Detail], ["caption", x.Caption]]);
}

export class Actions_AssignMaturity extends Record {
    constructor(Maturity) {
        super();
        this.Maturity = Maturity;
    }
}

export function Actions_AssignMaturity_$reflection() {
    return record_type("Types.Actions.AssignMaturity", [], Actions_AssignMaturity, () => [["Maturity", Maturity_$reflection()]]);
}

export function Actions_AssignMaturity_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg;
        return new Actions_AssignMaturity((arg_1 = EPM_Domain_Events_Maturity__Maturity_get_Decoder_Static(), (objectArg = get$.Required, objectArg.Field("maturity", uncurry2(arg_1)))));
    }, path, v));
}

export function Actions_AssignMaturity_Encoder_7C2A3F59(x) {
    return object_1([["maturity", EPM_Domain_Events_Maturity__Maturity_Encoder_Static_4DC9A197(x.Maturity)]]);
}

export class Actions_AssignTarget extends Record {
    constructor(Target) {
        super();
        this.Target = Target;
    }
}

export function Actions_AssignTarget_$reflection() {
    return record_type("Types.Actions.AssignTarget", [], Actions_AssignTarget, () => [["Target", Action_Target_$reflection()]]);
}

export function Actions_AssignTarget_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg;
        return new Actions_AssignTarget((arg_1 = EPM_Domain_Events_Action_Target__Target_get_Decoder_Static(), (objectArg = get$.Required, objectArg.Field("target", uncurry2(arg_1)))));
    }, path, v));
}

export function Actions_AssignTarget_Encoder_Z2751B22D(x) {
    return object_1([["target", EPM_Domain_Events_Action_Target__Target_Encoder_Static_4208C38D(x.Target)]]);
}

export class Actions_CreateActionStep extends Record {
    constructor(Name, Detail, Sequence, Fulfillment, Required) {
        super();
        this.Name = Name;
        this.Detail = Detail;
        this.Sequence = (Sequence | 0);
        this.Fulfillment = Fulfillment;
        this.Required = Required;
    }
}

export function Actions_CreateActionStep_$reflection() {
    return record_type("Types.Actions.CreateActionStep", [], Actions_CreateActionStep, () => [["Name", string_type], ["Detail", string_type], ["Sequence", int32_type], ["Fulfillment", Action_Fulfillment_$reflection()], ["Required", bool_type]]);
}

export function Actions_CreateActionStep_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, arg_7, objectArg_3, objectArg_4;
        return new Actions_CreateActionStep((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)), (objectArg_2 = get$.Required, objectArg_2.Field("sequence", uncurry2(int))), (arg_7 = EPM_Domain_Events_Action_Fulfillment__Fulfillment_get_Decoder_Static(), (objectArg_3 = get$.Required, objectArg_3.Field("fulfillment", uncurry2(arg_7)))), (objectArg_4 = get$.Required, objectArg_4.Field("required", bool)));
    }, path_3, v));
}

export function Actions_CreateActionStep_Encoder_Z6F8CD615(x) {
    return object_1([["name", x.Name], ["detail", x.Detail], ["sequence", x.Sequence], ["fulfillment", EPM_Domain_Events_Action_Fulfillment__Fulfillment_Encoder_Static_4AB7965E(x.Fulfillment)], ["required", x.Required]]);
}

export function EPM_Domain_Events_Activity_DocumentEvidence__DocumentEvidence_get_Decoder_Static() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Activity_DocumentEvidence((objectArg = get$.Required, objectArg.Field("documentId", guid)), (objectArg_1 = get$.Required, objectArg_1.Field("revisionId", guid)));
    }, path_2, v));
}

export function EPM_Domain_Events_Activity_DocumentEvidence__DocumentEvidence_Encoder_Static_Z90B892D(x) {
    return object_1([["documentId", guid_1(x.DocumentId)], ["revisionId", guid_1(x.RevisionId)]]);
}

export function EPM_Domain_Events_Activity_AttachmentDetails__AttachmentDetails_get_Decoder_Static() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Activity_AttachmentDetails((objectArg = get$.Required, objectArg.Field("id", guid)), (objectArg_1 = get$.Required, objectArg_1.Field("detail", string)), (objectArg_2 = get$.Required, objectArg_2.Field("attachmentType", string)));
    }, path_3, v));
}

export function EPM_Domain_Events_Activity_AttachmentDetails__AttachmentDetails_Encoder_Static_Z2EA4F5EC(x) {
    return object_1([["id", guid_1(x.Id)], ["detail", x.Detail], ["attachmentType", x.AttachmentType]]);
}

const Activities_extra = (() => {
    let copyOfStruct, copyOfStruct_1;
    let extra_3;
    const decoder = EPM_Domain_Events_Activity_DocumentEvidence__DocumentEvidence_get_Decoder_Static();
    extra_3 = (new ExtraCoders((copyOfStruct = newGuid(), copyOfStruct), add("EPM.Domain.Events.Activity.DocumentEvidence", [EPM_Domain_Events_Activity_DocumentEvidence__DocumentEvidence_Encoder_Static_Z90B892D, decoder], empty.Coders)));
    const decoder_3 = EPM_Domain_Events_Activity_AttachmentDetails__AttachmentDetails_get_Decoder_Static();
    return new ExtraCoders((copyOfStruct_1 = newGuid(), copyOfStruct_1), add("EPM.Domain.Events.Activity.AttachmentDetails", [EPM_Domain_Events_Activity_AttachmentDetails__AttachmentDetails_Encoder_Static_Z2EA4F5EC, decoder_3], extra_3.Coders));
})();

export function EPM_Domain_Events_Activity_FulfillmentEvidence__FulfillmentEvidence_get_Decoder_Static() {
    return Auto_generateBoxedDecoderCached_Z6670B51(Activity_FulfillmentEvidence_$reflection(), new CaseStrategy(0, []), Activities_extra);
}

export function EPM_Domain_Events_Activity_FulfillmentEvidence__FulfillmentEvidence_Encoder_Static_Z52CF58A2(x) {
    return Auto_generateBoxedEncoderCached_437914C6(Activity_FulfillmentEvidence_$reflection(), new CaseStrategy(0, []), Activities_extra)(x);
}

export class Activities_EvidenceType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SignOff", "Documents", "Comment", "Number", "Images", "Videos"];
    }
}

export function Activities_EvidenceType_$reflection() {
    return union_type("Types.Activities.EvidenceType", [], Activities_EvidenceType, () => [[], [["Item", list_type(Activity_DocumentEvidence_$reflection())]], [["Item", string_type]], [["Item", float64_type]], [], []]);
}

export function Activities_EvidenceType_get_Decoder() {
    return Auto_generateBoxedDecoderCached_Z6670B51(Activities_EvidenceType_$reflection(), new CaseStrategy(0, []), Activities_extra);
}

export function Activities_EvidenceType_Encoder_13AE9E6E(x) {
    return Auto_generateBoxedEncoderCached_437914C6(Activities_EvidenceType_$reflection(), new CaseStrategy(0, []), Activities_extra)(x);
}

export class Activities_Signatory extends Record {
    constructor(SignedBy, SignedOn, DependentActivities) {
        super();
        this.SignedBy = SignedBy;
        this.SignedOn = SignedOn;
        this.DependentActivities = DependentActivities;
    }
}

export function Activities_Signatory_$reflection() {
    return record_type("Types.Activities.Signatory", [], Activities_Signatory, () => [["SignedBy", class_type("System.Guid")], ["SignedOn", class_type("System.DateTimeOffset")], ["DependentActivities", list_type(class_type("System.Guid"))]]);
}

export function Activities_Signatory_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Activities_Signatory((objectArg = get$.Required, objectArg.Field("signedBy", guid)), (objectArg_1 = get$.Required, objectArg_1.Field("signedOn", datetimeOffset)), (objectArg_2 = get$.Required, objectArg_2.Field("dependentActivities", (path_3, value_3) => list_4(guid, path_3, value_3))));
    }, path_4, v));
}

export function Activities_Signatory_Encoder_Z5FBB61D9(x) {
    return object_1([["signedBy", guid_1(x.SignedBy)], ["signedOn", datetimeOffset_1(x.SignedOn)], ["dependentActivities", list_5(map_3(guid_1, x.DependentActivities))]]);
}

export class Activities_ActivityStep extends Record {
    constructor(ActionStepId, CompletedBy, CompletedOn, CompletedWith) {
        super();
        this.ActionStepId = ActionStepId;
        this.CompletedBy = CompletedBy;
        this.CompletedOn = CompletedOn;
        this.CompletedWith = CompletedWith;
    }
}

export function Activities_ActivityStep_$reflection() {
    return record_type("Types.Activities.ActivityStep", [], Activities_ActivityStep, () => [["ActionStepId", class_type("System.Guid")], ["CompletedBy", option_type(class_type("System.Guid"))], ["CompletedOn", option_type(class_type("System.DateTimeOffset"))], ["CompletedWith", option_type(Activity_FulfillmentEvidence_$reflection())]]);
}

export function Activities_ActivityStep_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, arg_7, objectArg_3;
        return new Activities_ActivityStep((objectArg = get$.Required, objectArg.Field("actionStepId", guid)), (objectArg_1 = get$.Optional, objectArg_1.Field("completedBy", guid)), (objectArg_2 = get$.Optional, objectArg_2.Field("completedOn", datetimeOffset)), (arg_7 = EPM_Domain_Events_Activity_FulfillmentEvidence__FulfillmentEvidence_get_Decoder_Static(), (objectArg_3 = get$.Optional, objectArg_3.Field("completedWith", uncurry2(arg_7)))));
    }, path_3, v));
}

export function Activities_ActivityStep_Encoder_Z4488ABE6(x) {
    return object_1([["actionStepId", guid_1(x.ActionStepId)], ["completedBy", option(guid_1)(x.CompletedBy)], ["completedOn", option(datetimeOffset_1)(x.CompletedOn)], ["completedWith", option(EPM_Domain_Events_Activity_FulfillmentEvidence__FulfillmentEvidence_Encoder_Static_Z52CF58A2)(x.CompletedWith)]]);
}

export class Activities_Attachment extends Record {
    constructor(Id, Detail, AttachmentType, UploadedBy, UploadedOn) {
        super();
        this.Id = Id;
        this.Detail = Detail;
        this.AttachmentType = AttachmentType;
        this.UploadedBy = UploadedBy;
        this.UploadedOn = UploadedOn;
    }
}

export function Activities_Attachment_$reflection() {
    return record_type("Types.Activities.Attachment", [], Activities_Attachment, () => [["Id", class_type("System.Guid")], ["Detail", string_type], ["AttachmentType", string_type], ["UploadedBy", By_$reflection()], ["UploadedOn", class_type("System.DateTimeOffset")]]);
}

export function Activities_Attachment_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let arg_9, objectArg_4;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Detail;
        const objectArg_1 = get$.Required;
        Detail = objectArg_1.Field("detail", string);
        let AttachmentType;
        const objectArg_2 = get$.Required;
        AttachmentType = objectArg_2.Field("attachmentType", string);
        let UploadedOn;
        const objectArg_3 = get$.Required;
        UploadedOn = objectArg_3.Field("uploadedOn", datetimeOffset);
        return new Activities_Attachment(Id, Detail, AttachmentType, (arg_9 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_4 = get$.Required, objectArg_4.Field("uploadedBy", uncurry2(arg_9)))), UploadedOn);
    }, path_4, v));
}

export function Activities_Attachment_Encoder_6D74A8BC(x) {
    return object_1([["id", guid_1(x.Id)], ["detail", x.Detail], ["attachmentType", x.AttachmentType], ["uploadedOn", datetimeOffset_1(x.UploadedOn)], ["uploadedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.UploadedBy)]]);
}

export class Activities_CommentHistory extends Record {
    constructor(Text$, PostedBy, PostedOn) {
        super();
        this.Text = Text$;
        this.PostedBy = PostedBy;
        this.PostedOn = PostedOn;
    }
}

export function Activities_CommentHistory_$reflection() {
    return record_type("Types.Activities.CommentHistory", [], Activities_CommentHistory, () => [["Text", string_type], ["PostedBy", By_$reflection()], ["PostedOn", class_type("System.DateTimeOffset")]]);
}

export function Activities_CommentHistory_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let arg_5, objectArg_2;
        let Text$;
        const objectArg = get$.Required;
        Text$ = objectArg.Field("text", string);
        let PostedOn;
        const objectArg_1 = get$.Required;
        PostedOn = objectArg_1.Field("postedOn", datetimeOffset);
        return new Activities_CommentHistory(Text$, (arg_5 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_2 = get$.Required, objectArg_2.Field("postedBy", uncurry2(arg_5)))), PostedOn);
    }, path_2, v));
}

export function Activities_CommentHistory_Encoder_Z18CEE0CC(x) {
    return object_1([["text", x.Text], ["postedOn", datetimeOffset_1(x.PostedOn)], ["postedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.PostedBy)]]);
}

export class Activities_Comment extends Record {
    constructor(Id, Text$, History, PostedBy, PostedOn, LastModifiedOn, LastModifiedBy) {
        super();
        this.Id = Id;
        this.Text = Text$;
        this.History = History;
        this.PostedBy = PostedBy;
        this.PostedOn = PostedOn;
        this.LastModifiedOn = LastModifiedOn;
        this.LastModifiedBy = LastModifiedBy;
    }
}

export function Activities_Comment_$reflection() {
    return record_type("Types.Activities.Comment", [], Activities_Comment, () => [["Id", class_type("System.Guid")], ["Text", string_type], ["History", list_type(Activities_CommentHistory_$reflection())], ["PostedBy", By_$reflection()], ["PostedOn", class_type("System.DateTimeOffset")], ["LastModifiedOn", option_type(class_type("System.DateTimeOffset"))], ["LastModifiedBy", option_type(By_$reflection())]]);
}

export function Activities_Comment_get_Decoder() {
    return (path_5) => ((v) => object((get$) => {
        let arg_9, objectArg_4, objectArg_5, arg_13, objectArg_6;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let Text$;
        const objectArg_1 = get$.Required;
        Text$ = objectArg_1.Field("text", string);
        let History;
        let arg_5;
        const decoder = Activities_CommentHistory_get_Decoder();
        arg_5 = ((path_2) => ((value_2) => list_4(uncurry2(decoder), path_2, value_2)));
        const objectArg_2 = get$.Required;
        History = objectArg_2.Field("history", uncurry2(arg_5));
        let PostedOn;
        const objectArg_3 = get$.Required;
        PostedOn = objectArg_3.Field("postedOn", datetimeOffset);
        return new Activities_Comment(Id, Text$, History, (arg_9 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_4 = get$.Required, objectArg_4.Field("postedBy", uncurry2(arg_9)))), PostedOn, (objectArg_5 = get$.Optional, objectArg_5.Field("lastModifiedOn", datetimeOffset)), (arg_13 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_6 = get$.Optional, objectArg_6.Field("lastModifiedBy", uncurry2(arg_13)))));
    }, path_5, v));
}

export function Activities_Comment_Encoder_3331EE16(x) {
    return object_1([["id", guid_1(x.Id)], ["text", x.Text], ["history", list_5(map_3(Activities_CommentHistory_Encoder_Z18CEE0CC, x.History))], ["postedOn", datetimeOffset_1(x.PostedOn)], ["postedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.PostedBy)], ["lastModifiedOn", option(datetimeOffset_1)(x.LastModifiedOn)], ["lastModifiedBy", option(EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9)(x.LastModifiedBy)]]);
}

export class Activities_TargetEntity extends Record {
    constructor(EntityId, EntityType) {
        super();
        this.EntityId = EntityId;
        this.EntityType = EntityType;
    }
}

export function Activities_TargetEntity_$reflection() {
    return record_type("Types.Activities.TargetEntity", [], Activities_TargetEntity, () => [["EntityId", class_type("System.Guid")], ["EntityType", DomainEntities_$reflection()]]);
}

export function Activities_TargetEntity_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg, arg_3, objectArg_1;
        return new Activities_TargetEntity((objectArg = get$.Required, objectArg.Field("entityId", guid)), (arg_3 = EPM_Domain_Events_DomainEntities__DomainEntities_get_Decoder_Static(), (objectArg_1 = get$.Required, objectArg_1.Field("entityType", uncurry2(arg_3)))));
    }, path_1, v));
}

export function Activities_TargetEntity_Encoder_7C9CFE2F(x) {
    return object_1([["entityId", guid_1(x.EntityId)], ["entityType", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(x.EntityType)]]);
}

export class Activities_Activity extends Record {
    constructor(Id, ActionId, TargetEntity, Signatories, Name, Detail, Category, Maturity, Steps, LastModified, LastModifiedBy, LastEventId, DeletedOn, Labels, Attributes, ExpectedCompletionDate, CompletedOn, EstimatedCompletionTime, ActualCompletionTime, Attachments, Comments, AssignedToUserId, IsAutoGenerated, CreatedDate) {
        super();
        this.Id = Id;
        this.ActionId = ActionId;
        this.TargetEntity = TargetEntity;
        this.Signatories = Signatories;
        this.Name = Name;
        this.Detail = Detail;
        this.Category = Category;
        this.Maturity = Maturity;
        this.Steps = Steps;
        this.LastModified = LastModified;
        this.LastModifiedBy = LastModifiedBy;
        this.LastEventId = LastEventId;
        this.DeletedOn = DeletedOn;
        this.Labels = Labels;
        this.Attributes = Attributes;
        this.ExpectedCompletionDate = ExpectedCompletionDate;
        this.CompletedOn = CompletedOn;
        this.EstimatedCompletionTime = EstimatedCompletionTime;
        this.ActualCompletionTime = ActualCompletionTime;
        this.Attachments = Attachments;
        this.Comments = Comments;
        this.AssignedToUserId = AssignedToUserId;
        this.IsAutoGenerated = IsAutoGenerated;
        this.CreatedDate = CreatedDate;
    }
}

export function Activities_Activity_$reflection() {
    return record_type("Types.Activities.Activity", [], Activities_Activity, () => [["Id", class_type("System.Guid")], ["ActionId", option_type(class_type("System.Guid"))], ["TargetEntity", option_type(Activities_TargetEntity_$reflection())], ["Signatories", list_type(Activities_Signatory_$reflection())], ["Name", option_type(string_type)], ["Detail", option_type(string_type)], ["Category", option_type(Action_Category_$reflection())], ["Maturity", option_type(Maturity_$reflection())], ["Steps", list_type(Activities_ActivityStep_$reflection())], ["LastModified", class_type("System.DateTimeOffset")], ["LastModifiedBy", By_$reflection()], ["LastEventId", class_type("System.Guid")], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["Attributes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Attribute_$reflection()])], ["ExpectedCompletionDate", option_type(class_type("System.DateTimeOffset"))], ["CompletedOn", option_type(class_type("System.DateTimeOffset"))], ["EstimatedCompletionTime", option_type(class_type("System.TimeSpan"))], ["ActualCompletionTime", option_type(class_type("System.TimeSpan"))], ["Attachments", list_type(Activities_Attachment_$reflection())], ["Comments", list_type(Activities_Comment_$reflection())], ["AssignedToUserId", option_type(class_type("System.Guid"))], ["IsAutoGenerated", bool_type], ["CreatedDate", option_type(class_type("System.DateTimeOffset"))]]);
}

export function Activities_Activity_get_Decoder() {
    return (path_18) => ((v) => object((get$) => {
        let objectArg, objectArg_1, arg_5, objectArg_2, arg_7, decoder, objectArg_3, objectArg_4, objectArg_5, arg_13, objectArg_6, arg_15, objectArg_7, arg_17, decoder_1, objectArg_8, objectArg_9, arg_21, objectArg_10, objectArg_11, objectArg_12, objectArg_13, arg_29, objectArg_14, objectArg_15, objectArg_16, objectArg_17, objectArg_18, arg_39, decoder_2, objectArg_19, arg_41, decoder_3, objectArg_20, objectArg_21, objectArg_22, objectArg_23;
        return new Activities_Activity((objectArg = get$.Required, objectArg.Field("id", guid)), (objectArg_1 = get$.Optional, objectArg_1.Field("actionId", guid)), (arg_5 = Activities_TargetEntity_get_Decoder(), (objectArg_2 = get$.Optional, objectArg_2.Field("targetEntity", uncurry2(arg_5)))), (arg_7 = ((decoder = Activities_Signatory_get_Decoder(), (path_2) => ((value_2) => list_4(uncurry2(decoder), path_2, value_2)))), (objectArg_3 = get$.Required, objectArg_3.Field("signatories", uncurry2(arg_7)))), (objectArg_4 = get$.Optional, objectArg_4.Field("name", string)), (objectArg_5 = get$.Optional, objectArg_5.Field("detail", string)), (arg_13 = EPM_Domain_Events_Action_Category__Category_get_Decoder_Static(), (objectArg_6 = get$.Optional, objectArg_6.Field("category", uncurry2(arg_13)))), (arg_15 = EPM_Domain_Events_Maturity__Maturity_get_Decoder_Static(), (objectArg_7 = get$.Optional, objectArg_7.Field("maturity", uncurry2(arg_15)))), (arg_17 = ((decoder_1 = Activities_ActivityStep_get_Decoder(), (path_5) => ((value_5) => list_4(uncurry2(decoder_1), path_5, value_5)))), (objectArg_8 = get$.Required, objectArg_8.Field("steps", uncurry2(arg_17)))), (objectArg_9 = get$.Required, objectArg_9.Field("lastModified", datetimeOffset)), (arg_21 = EPM_Domain_Events_By__By_get_Decoder_Static(), (objectArg_10 = get$.Required, objectArg_10.Field("lastModifiedBy", uncurry2(arg_21)))), (objectArg_11 = get$.Required, objectArg_11.Field("lastEventId", guid)), (objectArg_12 = get$.Optional, objectArg_12.Field("deletedOn", datetimeOffset)), (objectArg_13 = get$.Required, objectArg_13.Field("labels", uncurry2(labelDecoder))), (arg_29 = dict(uncurry2(EPM_Domain_Events_Attribute__Attribute_get_Decoder_Static())), (objectArg_14 = get$.Required, objectArg_14.Field("attributes", uncurry2(arg_29)))), (objectArg_15 = get$.Optional, objectArg_15.Field("expectedCompletionDate", datetimeOffset)), (objectArg_16 = get$.Optional, objectArg_16.Field("completedOn", datetimeOffset)), (objectArg_17 = get$.Optional, objectArg_17.Field("estimatedCompletionTime", timespan)), (objectArg_18 = get$.Optional, objectArg_18.Field("actualCompletionTime", timespan)), (arg_39 = ((decoder_2 = Activities_Attachment_get_Decoder(), (path_13) => ((value_13) => list_4(uncurry2(decoder_2), path_13, value_13)))), (objectArg_19 = get$.Required, objectArg_19.Field("attachments", uncurry2(arg_39)))), (arg_41 = ((decoder_3 = Activities_Comment_get_Decoder(), (path_14) => ((value_14) => list_4(uncurry2(decoder_3), path_14, value_14)))), (objectArg_20 = get$.Required, objectArg_20.Field("comments", uncurry2(arg_41)))), (objectArg_21 = get$.Optional, objectArg_21.Field("assignedToUserId", guid)), (objectArg_22 = get$.Required, objectArg_22.Field("isAutoGenerated", bool)), (objectArg_23 = get$.Optional, objectArg_23.Field("createdDate", datetimeOffset)));
    }, path_18, v));
}

export function Activities_Activity_Encoder_6FD26CE8(x) {
    return object_1([["id", guid_1(x.Id)], ["actionId", option(guid_1)(x.ActionId)], ["targetEntity", option(Activities_TargetEntity_Encoder_7C9CFE2F)(x.TargetEntity)], ["signatories", list_5(map_3(Activities_Signatory_Encoder_Z5FBB61D9, x.Signatories))], ["name", option((value_1) => value_1)(x.Name)], ["detail", option((value_3) => value_3)(x.Detail)], ["category", option(EPM_Domain_Events_Action_Category__Category_Encoder_Static_43D4D52C)(x.Category)], ["maturity", option(EPM_Domain_Events_Maturity__Maturity_Encoder_Static_4DC9A197)(x.Maturity)], ["steps", list_5(map_3(Activities_ActivityStep_Encoder_Z4488ABE6, x.Steps))], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastModifiedBy", EPM_Domain_Events_By__By_Encoder_Static_Z7AE4FDC9(x.LastModifiedBy)], ["lastEventId", guid_1(x.LastEventId)], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["labels", labelEncoder(x.Labels)], ["attributes", attributeEncoder(x.Attributes)], ["expectedCompletionDate", option(datetimeOffset_1)(x.ExpectedCompletionDate)], ["completedOn", option(datetimeOffset_1)(x.CompletedOn)], ["estimatedCompletionTime", option(timespan_1)(x.EstimatedCompletionTime)], ["actualCompletionTime", option(timespan_1)(x.ActualCompletionTime)], ["attachments", list_5(map_3(Activities_Attachment_Encoder_6D74A8BC, x.Attachments))], ["comments", list_5(map_3(Activities_Comment_Encoder_3331EE16, x.Comments))], ["assignedToUserId", option(guid_1)(x.AssignedToUserId)], ["isAutoGenerated", x.IsAutoGenerated], ["createdDate", option(datetimeOffset_1)(x.CreatedDate)], ["type", EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F(new DomainEntities(5, []))]]);
}

export class Activities_CompleteActivityStep extends Record {
    constructor(ActionStepId, Signatory, On, With, Time) {
        super();
        this.ActionStepId = ActionStepId;
        this.Signatory = Signatory;
        this.On = On;
        this.With = With;
        this.Time = Time;
    }
}

export function Activities_CompleteActivityStep_$reflection() {
    return record_type("Types.Activities.CompleteActivityStep", [], Activities_CompleteActivityStep, () => [["ActionStepId", class_type("System.Guid")], ["Signatory", option_type(class_type("System.Guid"))], ["On", option_type(class_type("System.DateTimeOffset"))], ["With", Activities_EvidenceType_$reflection()], ["Time", option_type(class_type("System.TimeSpan"))]]);
}

export function Activities_CompleteActivityStep_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, arg_7, objectArg_3, objectArg_4;
        return new Activities_CompleteActivityStep((objectArg = get$.Required, objectArg.Field("actionStepId", guid)), (objectArg_1 = get$.Optional, objectArg_1.Field("signatory", guid)), (objectArg_2 = get$.Optional, objectArg_2.Field("on", datetimeOffset)), (arg_7 = Activities_EvidenceType_get_Decoder(), (objectArg_3 = get$.Required, objectArg_3.Field("with", uncurry2(arg_7)))), (objectArg_4 = get$.Optional, objectArg_4.Field("time", timespan)));
    }, path_4, v));
}

export function Activities_CompleteActivityStep_Encoder_61DAD773(x) {
    return object_1([["actionStepId", guid_1(x.ActionStepId)], ["signatory", option(guid_1)(x.Signatory)], ["on", option(datetimeOffset_1)(x.On)], ["with", Activities_EvidenceType_Encoder_13AE9E6E(x.With)], ["time", option(timespan_1)(x.Time)]]);
}

export class Activities_RevertActivityStep extends Record {
    constructor(ActionStepId, Signatory, On) {
        super();
        this.ActionStepId = ActionStepId;
        this.Signatory = Signatory;
        this.On = On;
    }
}

export function Activities_RevertActivityStep_$reflection() {
    return record_type("Types.Activities.RevertActivityStep", [], Activities_RevertActivityStep, () => [["ActionStepId", class_type("System.Guid")], ["Signatory", option_type(class_type("System.Guid"))], ["On", option_type(class_type("System.DateTimeOffset"))]]);
}

export function Activities_RevertActivityStep_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Activities_RevertActivityStep((objectArg = get$.Required, objectArg.Field("actionStepId", guid)), (objectArg_1 = get$.Optional, objectArg_1.Field("signatory", guid)), (objectArg_2 = get$.Optional, objectArg_2.Field("on", datetimeOffset)));
    }, path_3, v));
}

export function Activities_RevertActivityStep_Encoder_ZCEE4488(x) {
    return object_1([["actionStepId", guid_1(x.ActionStepId)], ["signatory", option(guid_1)(x.Signatory)], ["on", option(datetimeOffset_1)(x.On)]]);
}

export class Activities_AssignUser extends Record {
    constructor(UserId) {
        super();
        this.UserId = UserId;
    }
}

export function Activities_AssignUser_$reflection() {
    return record_type("Types.Activities.AssignUser", [], Activities_AssignUser, () => [["UserId", class_type("System.Guid")]]);
}

export function Activities_AssignUser_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Activities_AssignUser((objectArg = get$.Required, objectArg.Field("userId", guid)));
    }, path_1, v));
}

export function Activities_AssignUser_Encoder_Z6B5756B(x) {
    return object_1([["userId", guid_1(x.UserId)]]);
}

export class Activities_Signed extends Record {
    constructor(On, Signatory) {
        super();
        this.On = On;
        this.Signatory = Signatory;
    }
}

export function Activities_Signed_$reflection() {
    return record_type("Types.Activities.Signed", [], Activities_Signed, () => [["On", class_type("System.DateTimeOffset")], ["Signatory", option_type(class_type("System.Guid"))]]);
}

export function Activities_Signed_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg_1;
        let Signatory;
        const objectArg = get$.Optional;
        Signatory = objectArg.Field("signatory", guid);
        return new Activities_Signed((objectArg_1 = get$.Required, objectArg_1.Field("on", datetimeOffset)), Signatory);
    }, path_2, v));
}

export function Activities_Signed_Encoder_65168837(x) {
    return object_1([["signatory", option(guid_1)(x.Signatory)], ["on", datetimeOffset_1(x.On)]]);
}

export class Activities_UnSigned extends Record {
    constructor(On, Signatory, Reason) {
        super();
        this.On = On;
        this.Signatory = Signatory;
        this.Reason = Reason;
    }
}

export function Activities_UnSigned_$reflection() {
    return record_type("Types.Activities.UnSigned", [], Activities_UnSigned, () => [["On", class_type("System.DateTimeOffset")], ["Signatory", option_type(class_type("System.Guid"))], ["Reason", option_type(string_type)]]);
}

export function Activities_UnSigned_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg_1, objectArg_2;
        let Signatory;
        const objectArg = get$.Optional;
        Signatory = objectArg.Field("signatory", guid);
        return new Activities_UnSigned((objectArg_1 = get$.Required, objectArg_1.Field("on", datetimeOffset)), Signatory, (objectArg_2 = get$.Optional, objectArg_2.Field("reason", string)));
    }, path_3, v));
}

export function Activities_UnSigned_Encoder_17F4EB6C(x) {
    return object_1([["signatory", option(guid_1)(x.Signatory)], ["on", datetimeOffset_1(x.On)], ["reason", option((value_1) => value_1)(x.Reason)]]);
}

export class Activities_AddComment extends Record {
    constructor(Text$) {
        super();
        this.Text = Text$;
    }
}

export function Activities_AddComment_$reflection() {
    return record_type("Types.Activities.AddComment", [], Activities_AddComment, () => [["Text", string_type]]);
}

export function Activities_AddComment_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Activities_AddComment((objectArg = get$.Required, objectArg.Field("text", string)));
    }, path_1, v));
}

export function Activities_AddComment_Encoder_5C43A757(x) {
    return object_1([["text", x.Text]]);
}

export class Activities_RemoveComment extends Record {
    constructor(CommentId, Reason) {
        super();
        this.CommentId = CommentId;
        this.Reason = Reason;
    }
}

export function Activities_RemoveComment_$reflection() {
    return record_type("Types.Activities.RemoveComment", [], Activities_RemoveComment, () => [["CommentId", class_type("System.Guid")], ["Reason", option_type(string_type)]]);
}

export function Activities_RemoveComment_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Activities_RemoveComment((objectArg = get$.Required, objectArg.Field("commentId", guid)), (objectArg_1 = get$.Optional, objectArg_1.Field("reason", string)));
    }, path_2, v));
}

export function Activities_RemoveComment_Encoder_49E176D0(x) {
    return object_1([["commentId", guid_1(x.CommentId)], ["reason", option((value) => value)(x.Reason)]]);
}

export class Activities_ExpectedCompletionDate extends Record {
    constructor(ExpectedCompletionDate) {
        super();
        this.ExpectedCompletionDate = ExpectedCompletionDate;
    }
}

export function Activities_ExpectedCompletionDate_$reflection() {
    return record_type("Types.Activities.ExpectedCompletionDate", [], Activities_ExpectedCompletionDate, () => [["ExpectedCompletionDate", class_type("System.DateTimeOffset")]]);
}

export function Activities_ExpectedCompletionDate_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Activities_ExpectedCompletionDate((objectArg = get$.Required, objectArg.Field("expectedCompletionDate", datetimeOffset)));
    }, path_1, v));
}

export function Activities_ExpectedCompletionDate_Encoder_9F781CB(x) {
    return object_1([["expectedCompletionDate", datetimeOffset_1(x.ExpectedCompletionDate)]]);
}

export class Activities_CreatedDate extends Record {
    constructor(CreatedDate) {
        super();
        this.CreatedDate = CreatedDate;
    }
}

export function Activities_CreatedDate_$reflection() {
    return record_type("Types.Activities.CreatedDate", [], Activities_CreatedDate, () => [["CreatedDate", class_type("System.DateTimeOffset")]]);
}

export function Activities_CreatedDate_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Activities_CreatedDate((objectArg = get$.Required, objectArg.Field("createdDate", datetimeOffset)));
    }, path_1, v));
}

export function Activities_CreatedDate_Encoder_6AE54871(x) {
    return object_1([["createdDate", datetimeOffset_1(x.CreatedDate)]]);
}

export class Activities_StartActivity extends Record {
    constructor(ActionId, Target, Name, Detail, Comment$, Category, Maturity, Labels) {
        super();
        this.ActionId = ActionId;
        this.Target = Target;
        this.Name = Name;
        this.Detail = Detail;
        this.Comment = Comment$;
        this.Category = Category;
        this.Maturity = Maturity;
        this.Labels = Labels;
    }
}

export function Activities_StartActivity_$reflection() {
    return record_type("Types.Activities.StartActivity", [], Activities_StartActivity, () => [["ActionId", option_type(class_type("System.Guid"))], ["Target", option_type(Activities_TargetEntity_$reflection())], ["Name", option_type(string_type)], ["Detail", option_type(string_type)], ["Comment", option_type(string_type)], ["Category", option_type(Action_Category_$reflection())], ["Maturity", option_type(Maturity_$reflection())], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])]]);
}

export function Activities_StartActivity_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg_5, objectArg_6, objectArg_7;
        let ActionId;
        const objectArg = get$.Optional;
        ActionId = objectArg.Field("actionId", guid);
        let Target;
        const arg_3 = Activities_TargetEntity_get_Decoder();
        const objectArg_1 = get$.Optional;
        Target = objectArg_1.Field("target", uncurry2(arg_3));
        let Name;
        const objectArg_2 = get$.Optional;
        Name = objectArg_2.Field("name", string);
        let Category;
        const arg_7 = EPM_Domain_Events_Action_Category__Category_get_Decoder_Static();
        const objectArg_3 = get$.Optional;
        Category = objectArg_3.Field("category", uncurry2(arg_7));
        let Maturity;
        const arg_9 = EPM_Domain_Events_Maturity__Maturity_get_Decoder_Static();
        const objectArg_4 = get$.Optional;
        Maturity = objectArg_4.Field("maturity", uncurry2(arg_9));
        return new Activities_StartActivity(ActionId, Target, Name, (objectArg_5 = get$.Optional, objectArg_5.Field("detail", string)), (objectArg_6 = get$.Optional, objectArg_6.Field("comment", string)), Category, Maturity, (objectArg_7 = get$.Required, objectArg_7.Field("labels", uncurry2(labelDecoder))));
    }, path_4, v));
}

export function Activities_StartActivity_Encoder_Z38CE16B8(x) {
    return object_1([["actionId", option(guid_1)(x.ActionId)], ["target", option(Activities_TargetEntity_Encoder_7C9CFE2F)(x.Target)], ["name", option((value_1) => value_1)(x.Name)], ["category", option(EPM_Domain_Events_Action_Category__Category_Encoder_Static_43D4D52C)(x.Category)], ["maturity", option(EPM_Domain_Events_Maturity__Maturity_Encoder_Static_4DC9A197)(x.Maturity)], ["detail", option((value_3) => value_3)(x.Detail)], ["comment", option((value_5) => value_5)(x.Comment)], ["labels", labelEncoder(x.Labels)]]);
}

export class Activities_ChangeAction extends Record {
    constructor(ActionId) {
        super();
        this.ActionId = ActionId;
    }
}

export function Activities_ChangeAction_$reflection() {
    return record_type("Types.Activities.ChangeAction", [], Activities_ChangeAction, () => [["ActionId", option_type(class_type("System.Guid"))]]);
}

export function Activities_ChangeAction_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Activities_ChangeAction((objectArg = get$.Optional, objectArg.Field("actionId", guid)));
    }, path_1, v));
}

export function Activities_ChangeAction_Encoder_Z600ABFE3(x) {
    return object_1([["actionId", option(guid_1)(x.ActionId)]]);
}

export class Activities_ChangeCategory extends Record {
    constructor(Category) {
        super();
        this.Category = Category;
    }
}

export function Activities_ChangeCategory_$reflection() {
    return record_type("Types.Activities.ChangeCategory", [], Activities_ChangeCategory, () => [["Category", option_type(Action_Category_$reflection())]]);
}

export function Activities_ChangeCategory_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg;
        return new Activities_ChangeCategory((arg_1 = EPM_Domain_Events_Action_Category__Category_get_Decoder_Static(), (objectArg = get$.Optional, objectArg.Field("category", uncurry2(arg_1)))));
    }, path, v));
}

export function Activities_ChangeCategory_Encoder_Z7D90A1ED(x) {
    return object_1([["category", option(EPM_Domain_Events_Action_Category__Category_Encoder_Static_43D4D52C)(x.Category)]]);
}

export class Activities_ChangeMaturity extends Record {
    constructor(Maturity) {
        super();
        this.Maturity = Maturity;
    }
}

export function Activities_ChangeMaturity_$reflection() {
    return record_type("Types.Activities.ChangeMaturity", [], Activities_ChangeMaturity, () => [["Maturity", option_type(Maturity_$reflection())]]);
}

export function Activities_ChangeMaturity_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let arg_1, objectArg;
        return new Activities_ChangeMaturity((arg_1 = EPM_Domain_Events_Maturity__Maturity_get_Decoder_Static(), (objectArg = get$.Optional, objectArg.Field("maturity", uncurry2(arg_1)))));
    }, path, v));
}

export function Activities_ChangeMaturity_Encoder_Z1F03C1C8(x) {
    return object_1([["maturity", option(EPM_Domain_Events_Maturity__Maturity_Encoder_Static_4DC9A197)(x.Maturity)]]);
}

export class Activities_UpdateActivity extends Record {
    constructor(Name, Detail) {
        super();
        this.Name = Name;
        this.Detail = Detail;
    }
}

export function Activities_UpdateActivity_$reflection() {
    return record_type("Types.Activities.UpdateActivity", [], Activities_UpdateActivity, () => [["Name", string_type], ["Detail", option_type(string_type)]]);
}

export function Activities_UpdateActivity_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Activities_UpdateActivity((objectArg = get$.Required, objectArg.Field("name", string)), (objectArg_1 = get$.Optional, objectArg_1.Field("detail", string)));
    }, path_2, v));
}

export function Activities_UpdateActivity_Encoder_8851E39(x) {
    return object_1([["name", x.Name], ["detail", option((value_1) => value_1)(x.Detail)]]);
}

export class Activities_CompletionTime extends Record {
    constructor(Time) {
        super();
        this.Time = Time;
    }
}

export function Activities_CompletionTime_$reflection() {
    return record_type("Types.Activities.CompletionTime", [], Activities_CompletionTime, () => [["Time", class_type("System.TimeSpan")]]);
}

export function Activities_CompletionTime_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Activities_CompletionTime((objectArg = get$.Required, objectArg.Field("time", timespan)));
    }, path_1, v));
}

export function Activities_CompletionTime_Encoder_2D0E73B4(x) {
    return object_1([["time", timespan_1(x.Time)]]);
}

export class Activities_ActivityExport extends Record {
    constructor(Id, ActionId, ActionName, ActionDetail, ActivityName, ActivityDetail, Category, ActivityCategory, Maturity, ActivityMaturity, EntityId, EntityType, EntityName, EntityDetail, DeletedOn, Labels, Attributes, ExpectedCompletionDate, CompletedOn, EstimatedCompletionTime, ActualCompletionTime, AssignedToUserId, IsAutoGenerated, EquipmentTypeId, EquipmentTypeName, DisciplineId, DisciplineName, SourceDocumentId, SourceDocumentName, ProductionUnitTypeId, ProdductionUnitTypeName, ProductionUnitId, ProductionUnitName, SystemId, SystemName, SystemDetail, SubsystemId, SubsystemName, SubsystemDetail, FacilityId, FacilityName, ModuleId, ModuleName, AreaId, AreaName, LocationId, LocationName, CreatedDate) {
        super();
        this.Id = Id;
        this.ActionId = ActionId;
        this.ActionName = ActionName;
        this.ActionDetail = ActionDetail;
        this.ActivityName = ActivityName;
        this.ActivityDetail = ActivityDetail;
        this.Category = Category;
        this.ActivityCategory = ActivityCategory;
        this.Maturity = Maturity;
        this.ActivityMaturity = ActivityMaturity;
        this.EntityId = EntityId;
        this.EntityType = EntityType;
        this.EntityName = EntityName;
        this.EntityDetail = EntityDetail;
        this.DeletedOn = DeletedOn;
        this.Labels = Labels;
        this.Attributes = Attributes;
        this.ExpectedCompletionDate = ExpectedCompletionDate;
        this.CompletedOn = CompletedOn;
        this.EstimatedCompletionTime = EstimatedCompletionTime;
        this.ActualCompletionTime = ActualCompletionTime;
        this.AssignedToUserId = AssignedToUserId;
        this.IsAutoGenerated = IsAutoGenerated;
        this.EquipmentTypeId = EquipmentTypeId;
        this.EquipmentTypeName = EquipmentTypeName;
        this.DisciplineId = DisciplineId;
        this.DisciplineName = DisciplineName;
        this.SourceDocumentId = SourceDocumentId;
        this.SourceDocumentName = SourceDocumentName;
        this.ProductionUnitTypeId = ProductionUnitTypeId;
        this.ProdductionUnitTypeName = ProdductionUnitTypeName;
        this.ProductionUnitId = ProductionUnitId;
        this.ProductionUnitName = ProductionUnitName;
        this.SystemId = SystemId;
        this.SystemName = SystemName;
        this.SystemDetail = SystemDetail;
        this.SubsystemId = SubsystemId;
        this.SubsystemName = SubsystemName;
        this.SubsystemDetail = SubsystemDetail;
        this.FacilityId = FacilityId;
        this.FacilityName = FacilityName;
        this.ModuleId = ModuleId;
        this.ModuleName = ModuleName;
        this.AreaId = AreaId;
        this.AreaName = AreaName;
        this.LocationId = LocationId;
        this.LocationName = LocationName;
        this.CreatedDate = CreatedDate;
    }
}

export function Activities_ActivityExport_$reflection() {
    return record_type("Types.Activities.ActivityExport", [], Activities_ActivityExport, () => [["Id", class_type("System.Guid")], ["ActionId", option_type(class_type("System.Guid"))], ["ActionName", option_type(string_type)], ["ActionDetail", option_type(string_type)], ["ActivityName", option_type(string_type)], ["ActivityDetail", option_type(string_type)], ["Category", option_type(Action_Category_$reflection())], ["ActivityCategory", option_type(Action_Category_$reflection())], ["Maturity", option_type(Maturity_$reflection())], ["ActivityMaturity", option_type(Maturity_$reflection())], ["EntityId", option_type(class_type("System.Guid"))], ["EntityType", option_type(DomainEntities_$reflection())], ["EntityName", option_type(string_type)], ["EntityDetail", option_type(string_type)], ["DeletedOn", option_type(class_type("System.DateTimeOffset"))], ["Labels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])])], ["Attributes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Attribute_$reflection()])], ["ExpectedCompletionDate", option_type(class_type("System.DateTimeOffset"))], ["CompletedOn", option_type(class_type("System.DateTimeOffset"))], ["EstimatedCompletionTime", option_type(class_type("System.TimeSpan"))], ["ActualCompletionTime", option_type(class_type("System.TimeSpan"))], ["AssignedToUserId", option_type(class_type("System.Guid"))], ["IsAutoGenerated", bool_type], ["EquipmentTypeId", option_type(class_type("System.Guid"))], ["EquipmentTypeName", option_type(string_type)], ["DisciplineId", option_type(class_type("System.Guid"))], ["DisciplineName", option_type(string_type)], ["SourceDocumentId", option_type(class_type("System.Guid"))], ["SourceDocumentName", option_type(string_type)], ["ProductionUnitTypeId", option_type(class_type("System.Guid"))], ["ProdductionUnitTypeName", option_type(string_type)], ["ProductionUnitId", option_type(class_type("System.Guid"))], ["ProductionUnitName", option_type(string_type)], ["SystemId", option_type(class_type("System.Guid"))], ["SystemName", option_type(string_type)], ["SystemDetail", option_type(string_type)], ["SubsystemId", option_type(class_type("System.Guid"))], ["SubsystemName", option_type(string_type)], ["SubsystemDetail", option_type(string_type)], ["FacilityId", option_type(class_type("System.Guid"))], ["FacilityName", option_type(string_type)], ["ModuleId", option_type(class_type("System.Guid"))], ["ModuleName", option_type(string_type)], ["AreaId", option_type(class_type("System.Guid"))], ["AreaName", option_type(string_type)], ["LocationId", option_type(class_type("System.Guid"))], ["LocationName", option_type(string_type)], ["CreatedDate", option_type(class_type("System.DateTimeOffset"))]]);
}

export function Activities_ActivityExport_get_Decoder() {
    return (path_41) => ((v) => object((get$) => {
        let objectArg_19, arg_41, objectArg_20, objectArg_21, objectArg_22, objectArg_23, objectArg_24, objectArg_25, objectArg_26, objectArg_27, objectArg_28, objectArg_29, objectArg_30, objectArg_31, objectArg_32, objectArg_33, objectArg_34, objectArg_35, objectArg_36, objectArg_37, objectArg_38, objectArg_39, objectArg_40, objectArg_41, objectArg_42, objectArg_43, objectArg_44, objectArg_45, objectArg_46, objectArg_47;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("id", guid);
        let ActionId;
        const objectArg_1 = get$.Optional;
        ActionId = objectArg_1.Field("actionId", guid);
        let ActionName;
        const objectArg_2 = get$.Optional;
        ActionName = objectArg_2.Field("actionName", string);
        let ActionDetail;
        const objectArg_3 = get$.Optional;
        ActionDetail = objectArg_3.Field("actionDetail", string);
        let ActivityName;
        const objectArg_4 = get$.Optional;
        ActivityName = objectArg_4.Field("activityName", string);
        let ActivityDetail;
        const objectArg_5 = get$.Optional;
        ActivityDetail = objectArg_5.Field("activityDetail", string);
        let Category;
        const arg_13 = EPM_Domain_Events_Action_Category__Category_get_Decoder_Static();
        const objectArg_6 = get$.Optional;
        Category = objectArg_6.Field("category", uncurry2(arg_13));
        let ActivityCategory;
        const arg_15 = EPM_Domain_Events_Action_Category__Category_get_Decoder_Static();
        const objectArg_7 = get$.Optional;
        ActivityCategory = objectArg_7.Field("activityCategory", uncurry2(arg_15));
        let Maturity;
        const arg_17 = EPM_Domain_Events_Maturity__Maturity_get_Decoder_Static();
        const objectArg_8 = get$.Optional;
        Maturity = objectArg_8.Field("maturity", uncurry2(arg_17));
        let ActivityMaturity;
        const arg_19 = EPM_Domain_Events_Maturity__Maturity_get_Decoder_Static();
        const objectArg_9 = get$.Optional;
        ActivityMaturity = objectArg_9.Field("activityMaturity", uncurry2(arg_19));
        let DeletedOn;
        const objectArg_10 = get$.Optional;
        DeletedOn = objectArg_10.Field("deletedOn", datetimeOffset);
        let Labels;
        const objectArg_11 = get$.Required;
        Labels = objectArg_11.Field("labels", uncurry2(labelDecoder));
        let Attributes;
        const arg_25 = dict(uncurry2(EPM_Domain_Events_Attribute__Attribute_get_Decoder_Static()));
        const objectArg_12 = get$.Required;
        Attributes = objectArg_12.Field("attributes", uncurry2(arg_25));
        let ExpectedCompletionDate;
        const objectArg_13 = get$.Optional;
        ExpectedCompletionDate = objectArg_13.Field("expectedCompletionDate", datetimeOffset);
        let CompletedOn;
        const objectArg_14 = get$.Optional;
        CompletedOn = objectArg_14.Field("completedOn", datetimeOffset);
        let EstimatedCompletionTime;
        const objectArg_15 = get$.Optional;
        EstimatedCompletionTime = objectArg_15.Field("estimatedCompletionTime", timespan);
        let ActualCompletionTime;
        const objectArg_16 = get$.Optional;
        ActualCompletionTime = objectArg_16.Field("actualCompletionTime", timespan);
        let AssignedToUserId;
        const objectArg_17 = get$.Optional;
        AssignedToUserId = objectArg_17.Field("assignedToUserId", guid);
        let IsAutoGenerated;
        const objectArg_18 = get$.Required;
        IsAutoGenerated = objectArg_18.Field("isAutoGenerated", bool);
        return new Activities_ActivityExport(Id, ActionId, ActionName, ActionDetail, ActivityName, ActivityDetail, Category, ActivityCategory, Maturity, ActivityMaturity, (objectArg_19 = get$.Optional, objectArg_19.Field("entityId", guid)), (arg_41 = EPM_Domain_Events_DomainEntities__DomainEntities_get_Decoder_Static(), (objectArg_20 = get$.Optional, objectArg_20.Field("entityType", uncurry2(arg_41)))), (objectArg_21 = get$.Optional, objectArg_21.Field("entityName", string)), (objectArg_22 = get$.Optional, objectArg_22.Field("entityDetail", string)), DeletedOn, Labels, Attributes, ExpectedCompletionDate, CompletedOn, EstimatedCompletionTime, ActualCompletionTime, AssignedToUserId, IsAutoGenerated, (objectArg_23 = get$.Optional, objectArg_23.Field("equipmentTypeId", guid)), (objectArg_24 = get$.Optional, objectArg_24.Field("equipmentTypeName", string)), (objectArg_25 = get$.Optional, objectArg_25.Field("disciplineId", guid)), (objectArg_26 = get$.Optional, objectArg_26.Field("disciplineName", string)), (objectArg_27 = get$.Optional, objectArg_27.Field("sourceDocumentId", guid)), (objectArg_28 = get$.Optional, objectArg_28.Field("sourceDocumentName", string)), (objectArg_29 = get$.Optional, objectArg_29.Field("productionUnitTypeId", guid)), (objectArg_30 = get$.Optional, objectArg_30.Field("prodductionUnitTypeName", string)), (objectArg_31 = get$.Optional, objectArg_31.Field("productionUnitId", guid)), (objectArg_32 = get$.Optional, objectArg_32.Field("productionUnitName", string)), (objectArg_33 = get$.Optional, objectArg_33.Field("systemId", guid)), (objectArg_34 = get$.Optional, objectArg_34.Field("systemName", string)), (objectArg_35 = get$.Optional, objectArg_35.Field("systemDetail", string)), (objectArg_36 = get$.Optional, objectArg_36.Field("subsystemId", guid)), (objectArg_37 = get$.Optional, objectArg_37.Field("subsystemName", string)), (objectArg_38 = get$.Optional, objectArg_38.Field("subsystemDetail", string)), (objectArg_39 = get$.Optional, objectArg_39.Field("facilityId", guid)), (objectArg_40 = get$.Optional, objectArg_40.Field("facilityName", string)), (objectArg_41 = get$.Optional, objectArg_41.Field("moduleId", guid)), (objectArg_42 = get$.Optional, objectArg_42.Field("moduleName", string)), (objectArg_43 = get$.Optional, objectArg_43.Field("areaId", guid)), (objectArg_44 = get$.Optional, objectArg_44.Field("areaName", string)), (objectArg_45 = get$.Optional, objectArg_45.Field("locationId", guid)), (objectArg_46 = get$.Optional, objectArg_46.Field("locationName", string)), (objectArg_47 = get$.Optional, objectArg_47.Field("createdDate", datetimeOffset)));
    }, path_41, v));
}

export function Activities_ActivityExport_Encoder_4E4D026C(x) {
    return object_1([["id", guid_1(x.Id)], ["actionId", option(guid_1)(x.ActionId)], ["actionName", option((value_1) => value_1)(x.ActionName)], ["actionDetail", option((value_3) => value_3)(x.ActionDetail)], ["activityName", option((value_5) => value_5)(x.ActivityName)], ["activityDetail", option((value_7) => value_7)(x.ActivityDetail)], ["category", option(EPM_Domain_Events_Action_Category__Category_Encoder_Static_43D4D52C)(x.Category)], ["activityCategory", option(EPM_Domain_Events_Action_Category__Category_Encoder_Static_43D4D52C)(x.ActivityCategory)], ["maturity", option(EPM_Domain_Events_Maturity__Maturity_Encoder_Static_4DC9A197)(x.Maturity)], ["activityMaturity", option(EPM_Domain_Events_Maturity__Maturity_Encoder_Static_4DC9A197)(x.ActivityMaturity)], ["deletedOn", option(datetimeOffset_1)(x.DeletedOn)], ["labels", labelEncoder(x.Labels)], ["attributes", attributeEncoder(x.Attributes)], ["expectedCompletionDate", option(datetimeOffset_1)(x.ExpectedCompletionDate)], ["completedOn", option(datetimeOffset_1)(x.CompletedOn)], ["estimatedCompletionTime", option(timespan_1)(x.EstimatedCompletionTime)], ["actualCompletionTime", option(timespan_1)(x.ActualCompletionTime)], ["assignedToUserId", option(guid_1)(x.AssignedToUserId)], ["isAutoGenerated", x.IsAutoGenerated], ["entityId", option(guid_1)(x.EntityId)], ["entityType", option(EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F)(x.EntityType)], ["entityName", option((value_17) => value_17)(x.EntityName)], ["entityDetail", option((value_19) => value_19)(x.EntityDetail)], ["equipmentTypeId", option(guid_1)(x.EquipmentTypeId)], ["equipmentTypeName", option((value_22) => value_22)(x.EquipmentTypeName)], ["disciplineId", option(guid_1)(x.DisciplineId)], ["disciplineName", option((value_25) => value_25)(x.DisciplineName)], ["sourceDocumentId", option(guid_1)(x.SourceDocumentId)], ["sourceDocumentName", option((value_28) => value_28)(x.SourceDocumentName)], ["productionUnitTypeId", option(guid_1)(x.ProductionUnitTypeId)], ["prodductionUnitTypeName", option((value_31) => value_31)(x.ProdductionUnitTypeName)], ["productionUnitId", option(guid_1)(x.ProductionUnitId)], ["productionUnitName", option((value_34) => value_34)(x.ProductionUnitName)], ["systemId", option(guid_1)(x.SystemId)], ["systemName", option((value_37) => value_37)(x.SystemName)], ["systemDetail", option((value_39) => value_39)(x.SystemDetail)], ["subsystemId", option(guid_1)(x.SubsystemId)], ["subsystemName", option((value_42) => value_42)(x.SubsystemName)], ["subsystemDetail", option((value_44) => value_44)(x.SubsystemDetail)], ["facilityId", option(guid_1)(x.FacilityId)], ["facilityName", option((value_47) => value_47)(x.FacilityName)], ["moduleId", option(guid_1)(x.ModuleId)], ["moduleName", option((value_50) => value_50)(x.ModuleName)], ["areaId", option(guid_1)(x.AreaId)], ["areaName", option((value_53) => value_53)(x.AreaName)], ["locationId", option(guid_1)(x.LocationId)], ["locationName", option((value_56) => value_56)(x.LocationName)], ["createdDate", option(datetimeOffset_1)(x.CreatedDate)]]);
}

export class Users_Project extends Record {
    constructor(Permissions) {
        super();
        this.Permissions = Permissions;
    }
}

export function Users_Project_$reflection() {
    return record_type("Types.Users.Project", [], Users_Project, () => [["Permissions", list_type(Scope_$reflection())]]);
}

export function Users_Project_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let arg_1, decoder, objectArg;
        return new Users_Project((arg_1 = ((decoder = Scope_get_Decoder(), (path) => ((value) => list_4(uncurry2(decoder), path, value)))), (objectArg = get$.Required, objectArg.Field("permissions", uncurry2(arg_1)))));
    }, path_1, v));
}

export function Users_Project_Encoder_59C520F9(x) {
    return object_1([["permissions", list_5(map_3(Scope_Encoder_Z5895E356, x.Permissions))]]);
}

export const Users_projectsDecoder = (() => {
    const d = dict(uncurry2(Users_Project_get_Decoder()));
    return (path) => ((value) => map((m) => ofSeq(choose((kv) => {
        let matchValue;
        let outArg = "00000000-0000-0000-0000-000000000000";
        matchValue = [tryParse(kv[0], new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        if (matchValue[0]) {
            return [matchValue[1], kv[1]];
        }
        else {
            return undefined;
        }
    }, m), {
        Compare: comparePrimitives,
    }), uncurry2(d), path, value));
})();

export class Users_User extends Record {
    constructor(Id, Name, Email, Projects, GlobalPermissions, LastModified, LastEventId) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Email = Email;
        this.Projects = Projects;
        this.GlobalPermissions = GlobalPermissions;
        this.LastModified = LastModified;
        this.LastEventId = LastEventId;
    }
}

export function Users_User_$reflection() {
    return record_type("Types.Users.User", [], Users_User, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Email", string_type], ["Projects", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [class_type("System.Guid"), Users_Project_$reflection()])], ["GlobalPermissions", list_type(Scope_$reflection())], ["LastModified", class_type("System.DateTimeOffset")], ["LastEventId", class_type("System.Guid")]]);
}

export function Users_User_get_Decoder() {
    return (path_6) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, arg_9, decoder, objectArg_4, objectArg_5, objectArg_6;
        return new Users_User((objectArg = get$.Required, objectArg.Field("id", guid)), (objectArg_1 = get$.Required, objectArg_1.Field("name", string)), (objectArg_2 = get$.Required, objectArg_2.Field("email", string)), (objectArg_3 = get$.Required, objectArg_3.Field("projects", uncurry2(Users_projectsDecoder))), (arg_9 = ((decoder = Scope_get_Decoder(), (path_3) => ((value_3) => list_4(uncurry2(decoder), path_3, value_3)))), (objectArg_4 = get$.Required, objectArg_4.Field("globalPermissions", uncurry2(arg_9)))), (objectArg_5 = get$.Required, objectArg_5.Field("lastModified", datetimeOffset)), (objectArg_6 = get$.Required, objectArg_6.Field("lastEventId", guid)));
    }, path_6, v));
}

export function Users_User_Encoder_Z7AC2EF83(x) {
    return object_1([["id", guid_1(x.Id)], ["name", x.Name], ["email", x.Email], ["projects", dict_1(ofSeq(map_2((keyValue) => [toString(4, guid_1(keyValue[0])), Users_Project_Encoder_59C520F9(keyValue[1])], x.Projects), {
        Compare: comparePrimitives,
    }))], ["globalPermissions", list_5(map_3(Scope_Encoder_Z5895E356, x.GlobalPermissions))], ["lastModified", datetimeOffset_1(x.LastModified)], ["lastEventId", guid_1(x.LastEventId)]]);
}

export class Users_SetUserPermissions extends Record {
    constructor(Email, Name, Permissions) {
        super();
        this.Email = Email;
        this.Name = Name;
        this.Permissions = Permissions;
    }
}

export function Users_SetUserPermissions_$reflection() {
    return record_type("Types.Users.SetUserPermissions", [], Users_SetUserPermissions, () => [["Email", string_type], ["Name", string_type], ["Permissions", list_type(Scope_$reflection())]]);
}

export function Users_SetUserPermissions_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg_1, arg_5, decoder, objectArg_2;
        let Name;
        const objectArg = get$.Required;
        Name = objectArg.Field("name", string);
        return new Users_SetUserPermissions((objectArg_1 = get$.Required, objectArg_1.Field("email", string)), Name, (arg_5 = ((decoder = Scope_get_Decoder(), (path_2) => ((value_2) => list_4(uncurry2(decoder), path_2, value_2)))), (objectArg_2 = get$.Required, objectArg_2.Field("permissions", uncurry2(arg_5)))));
    }, path_3, v));
}

export function Users_SetUserPermissions_Encoder_6972A767(x) {
    return object_1([["name", x.Name], ["email", x.Email], ["permissions", list_5(map_3(Scope_Encoder_Z5895E356, x.Permissions))]]);
}

export class Jobs_Job extends Record {
    constructor(JobId, By, CompletedTime, Errors, Success, Processed, Warnings, Tasks, Type, StartedTime) {
        super();
        this.JobId = JobId;
        this.By = By;
        this.CompletedTime = CompletedTime;
        this.Errors = (Errors | 0);
        this.Success = (Success | 0);
        this.Processed = (Processed | 0);
        this.Warnings = (Warnings | 0);
        this.Tasks = (Tasks | 0);
        this.Type = Type;
        this.StartedTime = StartedTime;
    }
}

export function Jobs_Job_$reflection() {
    return record_type("Types.Jobs.Job", [], Jobs_Job, () => [["JobId", class_type("System.Guid")], ["By", class_type("System.Guid")], ["CompletedTime", option_type(class_type("System.DateTimeOffset"))], ["Errors", int32_type], ["Success", int32_type], ["Processed", int32_type], ["Warnings", int32_type], ["Tasks", int32_type], ["Type", string_type], ["StartedTime", class_type("System.DateTimeOffset")]]);
}

export function Jobs_Job_get_Decoder() {
    return (path_5) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, objectArg_4, objectArg_5, objectArg_6, objectArg_7, objectArg_8, objectArg_9;
        return new Jobs_Job((objectArg = get$.Required, objectArg.Field("jobId", guid)), (objectArg_1 = get$.Required, objectArg_1.Field("by", guid)), (objectArg_2 = get$.Optional, objectArg_2.Field("completedTime", datetimeOffset)), (objectArg_3 = get$.Required, objectArg_3.Field("errors", uncurry2(int))), (objectArg_4 = get$.Required, objectArg_4.Field("success", uncurry2(int))), (objectArg_5 = get$.Required, objectArg_5.Field("processed", uncurry2(int))), (objectArg_6 = get$.Required, objectArg_6.Field("warnings", uncurry2(int))), (objectArg_7 = get$.Required, objectArg_7.Field("tasks", uncurry2(int))), (objectArg_8 = get$.Required, objectArg_8.Field("type", string)), (objectArg_9 = get$.Required, objectArg_9.Field("startedTime", datetimeOffset)));
    }, path_5, v));
}

export function Jobs_Job_Encoder_Z2D8D4EC3(x) {
    return object_1([["jobId", guid_1(x.JobId)], ["by", guid_1(x.By)], ["completedTime", option(datetimeOffset_1)(x.CompletedTime)], ["errors", x.Errors], ["success", x.Success], ["processed", x.Processed], ["warnings", x.Warnings], ["tasks", x.Tasks], ["type", x.Type], ["startedTime", datetimeOffset_1(x.StartedTime)]]);
}

export class Jobs_CreateJob extends Record {
    constructor(Type) {
        super();
        this.Type = Type;
    }
}

export function Jobs_CreateJob_$reflection() {
    return record_type("Types.Jobs.CreateJob", [], Jobs_CreateJob, () => [["Type", string_type]]);
}

export function Jobs_CreateJob_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let objectArg;
        return new Jobs_CreateJob((objectArg = get$.Required, objectArg.Field("type", string)));
    }, path_1, v));
}

export function Jobs_CreateJob_Encoder_Z5F727367(x) {
    return object_1([["type", x.Type]]);
}

export class Dashboard_ProjectBreakdown_AttributeCount extends Record {
    constructor(Total, Completed, Behind) {
        super();
        this.Total = Total;
        this.Completed = Completed;
        this.Behind = Behind;
    }
}

export function Dashboard_ProjectBreakdown_AttributeCount_$reflection() {
    return record_type("Types.Dashboard.ProjectBreakdown.AttributeCount", [], Dashboard_ProjectBreakdown_AttributeCount, () => [["Total", float64_type], ["Completed", float64_type], ["Behind", float64_type]]);
}

export function Dashboard_ProjectBreakdown_AttributeCount_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Dashboard_ProjectBreakdown_AttributeCount((objectArg = get$.Required, objectArg.Field("total", float)), (objectArg_1 = get$.Required, objectArg_1.Field("completed", float)), (objectArg_2 = get$.Required, objectArg_2.Field("behind", float)));
    }, path_3, v));
}

export function Dashboard_ProjectBreakdown_AttributeCount_Encoder_2182F423(x) {
    return object_1([["total", x.Total], ["completed", x.Completed], ["behind", x.Behind]]);
}

export const Dashboard_ProjectBreakdown_attributeDecoder = (() => {
    const d = dict(uncurry2(Dashboard_ProjectBreakdown_AttributeCount_get_Decoder()));
    return (path) => ((value) => map((table) => map_1((_arg, v) => v, table), uncurry2(d), path, value));
})();

export function Dashboard_ProjectBreakdown_attributeEncoder(x) {
    return dict_1(map_1((_arg, value) => Dashboard_ProjectBreakdown_AttributeCount_Encoder_2182F423(value), x));
}

export class Dashboard_ProjectBreakdown_AttributeCountDateFree extends Record {
    constructor(Total, Completed) {
        super();
        this.Total = Total;
        this.Completed = Completed;
    }
}

export function Dashboard_ProjectBreakdown_AttributeCountDateFree_$reflection() {
    return record_type("Types.Dashboard.ProjectBreakdown.AttributeCountDateFree", [], Dashboard_ProjectBreakdown_AttributeCountDateFree, () => [["Total", float64_type], ["Completed", float64_type]]);
}

export function Dashboard_ProjectBreakdown_AttributeCountDateFree_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1;
        return new Dashboard_ProjectBreakdown_AttributeCountDateFree((objectArg = get$.Required, objectArg.Field("total", float)), (objectArg_1 = get$.Required, objectArg_1.Field("completed", float)));
    }, path_2, v));
}

export function Dashboard_ProjectBreakdown_AttributeCountDateFree_Encoder_1EB02383(x) {
    return object_1([["total", x.Total], ["completed", x.Completed]]);
}

export const Dashboard_ProjectBreakdown_attributeDateFreeDecoder = (() => {
    const d = dict(uncurry2(Dashboard_ProjectBreakdown_AttributeCountDateFree_get_Decoder()));
    return (path) => ((value) => map((table) => map_1((_arg, v) => v, table), uncurry2(d), path, value));
})();

export function Dashboard_ProjectBreakdown_attributeDateFreeEncoder(x) {
    return dict_1(map_1((_arg, value) => Dashboard_ProjectBreakdown_AttributeCountDateFree_Encoder_1EB02383(value), x));
}

export class Dashboard_ProjectBreakdown_ProjectByEntityBreakdown extends Record {
    constructor(EntityId, EntityName, EntityDetail, PlannedDate, Completed, Planned, Unplanned, Total, Behind, EstimatedCompletionTime, ActualCompletionTime, OverageTime) {
        super();
        this.EntityId = EntityId;
        this.EntityName = EntityName;
        this.EntityDetail = EntityDetail;
        this.PlannedDate = PlannedDate;
        this.Completed = (Completed | 0);
        this.Planned = (Planned | 0);
        this.Unplanned = (Unplanned | 0);
        this.Total = (Total | 0);
        this.Behind = (Behind | 0);
        this.EstimatedCompletionTime = EstimatedCompletionTime;
        this.ActualCompletionTime = ActualCompletionTime;
        this.OverageTime = OverageTime;
    }
}

export function Dashboard_ProjectBreakdown_ProjectByEntityBreakdown_$reflection() {
    return record_type("Types.Dashboard.ProjectBreakdown.ProjectByEntityBreakdown", [], Dashboard_ProjectBreakdown_ProjectByEntityBreakdown, () => [["EntityId", class_type("System.Guid")], ["EntityName", string_type], ["EntityDetail", option_type(string_type)], ["PlannedDate", option_type(class_type("System.DateTimeOffset"))], ["Completed", int32_type], ["Planned", int32_type], ["Unplanned", int32_type], ["Total", int32_type], ["Behind", int32_type], ["EstimatedCompletionTime", class_type("System.TimeSpan")], ["ActualCompletionTime", class_type("System.TimeSpan")], ["OverageTime", class_type("System.TimeSpan")]]);
}

export function Dashboard_ProjectBreakdown_ProjectByEntityBreakdown_get_Decoder() {
    return (path_7) => ((v) => object((get$) => {
        let objectArg_7, objectArg_8, objectArg_9, objectArg_10, objectArg_11;
        let Total;
        const objectArg = get$.Required;
        Total = objectArg.Field("total", uncurry2(int));
        let Completed;
        const objectArg_1 = get$.Required;
        Completed = objectArg_1.Field("completed", uncurry2(int));
        let EntityId;
        const objectArg_2 = get$.Required;
        EntityId = objectArg_2.Field("entityId", guid);
        let EntityName;
        const objectArg_3 = get$.Required;
        EntityName = objectArg_3.Field("entityName", string);
        let EntityDetail;
        const objectArg_4 = get$.Optional;
        EntityDetail = objectArg_4.Field("entityDetail", string);
        let Planned;
        const objectArg_5 = get$.Required;
        Planned = objectArg_5.Field("planned", uncurry2(int));
        let Unplanned;
        const objectArg_6 = get$.Required;
        Unplanned = objectArg_6.Field("unplanned", uncurry2(int));
        return new Dashboard_ProjectBreakdown_ProjectByEntityBreakdown(EntityId, EntityName, EntityDetail, (objectArg_7 = get$.Optional, objectArg_7.Field("plannedDate", datetimeOffset)), Completed, Planned, Unplanned, Total, (objectArg_8 = get$.Required, objectArg_8.Field("behind", uncurry2(int))), (objectArg_9 = get$.Required, objectArg_9.Field("estimatedCompletionTime", timespan)), (objectArg_10 = get$.Required, objectArg_10.Field("actualCompletionTime", timespan)), (objectArg_11 = get$.Required, objectArg_11.Field("overageTime", timespan)));
    }, path_7, v));
}

export function Dashboard_ProjectBreakdown_ProjectByEntityBreakdown_Encoder_60E02C24(x) {
    return object_1([["total", x.Total], ["completed", x.Completed], ["estimatedCompletionTime", timespan_1(x.EstimatedCompletionTime)], ["actualCompletionTime", timespan_1(x.ActualCompletionTime)], ["overageTime", timespan_1(x.OverageTime)], ["entityId", guid_1(x.EntityId)], ["entityName", x.EntityName], ["entityDetail", option((value_3) => value_3)(x.EntityDetail)], ["behind", x.Behind], ["planned", x.Planned], ["unplanned", x.Unplanned], ["plannedDate", option(datetimeOffset_1)(x.PlannedDate)]]);
}

export class Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown extends Record {
    constructor(Completed, Planned, Unplanned, Total, EstimatedCompletionTime, ActualCompletionTime, Behind, OverageTime, AttributeCount) {
        super();
        this.Completed = (Completed | 0);
        this.Planned = (Planned | 0);
        this.Unplanned = (Unplanned | 0);
        this.Total = (Total | 0);
        this.EstimatedCompletionTime = EstimatedCompletionTime;
        this.ActualCompletionTime = ActualCompletionTime;
        this.Behind = (Behind | 0);
        this.OverageTime = OverageTime;
        this.AttributeCount = AttributeCount;
    }
}

export function Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown_$reflection() {
    return record_type("Types.Dashboard.ProjectBreakdown.GlobalStats.ProjectBreakdown", [], Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown, () => [["Completed", int32_type], ["Planned", int32_type], ["Unplanned", int32_type], ["Total", int32_type], ["EstimatedCompletionTime", class_type("System.TimeSpan")], ["ActualCompletionTime", class_type("System.TimeSpan")], ["Behind", int32_type], ["OverageTime", class_type("System.TimeSpan")], ["AttributeCount", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Dashboard_ProjectBreakdown_AttributeCount_$reflection()])]]);
}

export function Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown_get_Decoder() {
    return (path_3) => ((v) => object((get$) => {
        let objectArg_8;
        let Total;
        const objectArg = get$.Required;
        Total = objectArg.Field("total", uncurry2(int));
        let Completed;
        const objectArg_1 = get$.Required;
        Completed = objectArg_1.Field("completed", uncurry2(int));
        let EstimatedCompletionTime;
        const objectArg_2 = get$.Required;
        EstimatedCompletionTime = objectArg_2.Field("estimatedCompletionTime", timespan);
        let ActualCompletionTime;
        const objectArg_3 = get$.Required;
        ActualCompletionTime = objectArg_3.Field("actualCompletionTime", timespan);
        let OverageTime;
        const objectArg_4 = get$.Required;
        OverageTime = objectArg_4.Field("overageTime", timespan);
        let Planned;
        const objectArg_5 = get$.Required;
        Planned = objectArg_5.Field("planned", uncurry2(int));
        let Unplanned;
        const objectArg_6 = get$.Required;
        Unplanned = objectArg_6.Field("unplanned", uncurry2(int));
        let AttributeCount;
        const objectArg_7 = get$.Required;
        AttributeCount = objectArg_7.Field("attributeCount", uncurry2(Dashboard_ProjectBreakdown_attributeDecoder));
        return new Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown(Completed, Planned, Unplanned, Total, EstimatedCompletionTime, ActualCompletionTime, (objectArg_8 = get$.Required, objectArg_8.Field("behind", uncurry2(int))), OverageTime, AttributeCount);
    }, path_3, v));
}

export function Dashboard_ProjectBreakdown_GlobalStats_ProjectBreakdown_Encoder_1ADD6580(x) {
    return object_1([["total", x.Total], ["completed", x.Completed], ["estimatedCompletionTime", timespan_1(x.EstimatedCompletionTime)], ["actualCompletionTime", timespan_1(x.ActualCompletionTime)], ["overageTime", timespan_1(x.OverageTime)], ["planned", x.Planned], ["unplanned", x.Unplanned], ["attributeCount", Dashboard_ProjectBreakdown_attributeEncoder(x.AttributeCount)], ["behind", x.Behind]]);
}

export class Dashboard_ProjectBreakdown_GlobalStats_SubsystemProgess extends Record {
    constructor(Total, Planned, Completed) {
        super();
        this.Total = (Total | 0);
        this.Planned = (Planned | 0);
        this.Completed = (Completed | 0);
    }
}

export function Dashboard_ProjectBreakdown_GlobalStats_SubsystemProgess_$reflection() {
    return record_type("Types.Dashboard.ProjectBreakdown.GlobalStats.SubsystemProgess", [], Dashboard_ProjectBreakdown_GlobalStats_SubsystemProgess, () => [["Total", int32_type], ["Planned", int32_type], ["Completed", int32_type]]);
}

export function Dashboard_ProjectBreakdown_GlobalStats_SubsystemProgess_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Dashboard_ProjectBreakdown_GlobalStats_SubsystemProgess((objectArg = get$.Required, objectArg.Field("total", uncurry2(int))), (objectArg_1 = get$.Required, objectArg_1.Field("planned", uncurry2(int))), (objectArg_2 = get$.Required, objectArg_2.Field("completed", uncurry2(int))));
    }, path, v));
}

export function Dashboard_ProjectBreakdown_GlobalStats_SubsystemProgess_Encoder_Z83A300A(x) {
    return object_1([["total", x.Total], ["planned", x.Planned], ["completed", x.Completed]]);
}

export class Dashboard_ProjectBreakdown_ByDate_ProjectByDateBreakdown extends Record {
    constructor(Date$, Completed, Planned, EstimatedCompletionTime, ActualCompletionTime, OverageTime, AttributeCount) {
        super();
        this.Date = Date$;
        this.Completed = (Completed | 0);
        this.Planned = (Planned | 0);
        this.EstimatedCompletionTime = EstimatedCompletionTime;
        this.ActualCompletionTime = ActualCompletionTime;
        this.OverageTime = OverageTime;
        this.AttributeCount = AttributeCount;
    }
}

export function Dashboard_ProjectBreakdown_ByDate_ProjectByDateBreakdown_$reflection() {
    return record_type("Types.Dashboard.ProjectBreakdown.ByDate.ProjectByDateBreakdown", [], Dashboard_ProjectBreakdown_ByDate_ProjectByDateBreakdown, () => [["Date", class_type("System.DateTimeOffset")], ["Completed", int32_type], ["Planned", int32_type], ["EstimatedCompletionTime", class_type("System.TimeSpan")], ["ActualCompletionTime", class_type("System.TimeSpan")], ["OverageTime", class_type("System.TimeSpan")], ["AttributeCount", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Dashboard_ProjectBreakdown_AttributeCountDateFree_$reflection()])]]);
}

export function Dashboard_ProjectBreakdown_ByDate_ProjectByDateBreakdown_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg_5, objectArg_6;
        let Completed;
        const objectArg = get$.Required;
        Completed = objectArg.Field("completed", uncurry2(int));
        let EstimatedCompletionTime;
        const objectArg_1 = get$.Required;
        EstimatedCompletionTime = objectArg_1.Field("estimatedCompletionTime", timespan);
        let ActualCompletionTime;
        const objectArg_2 = get$.Required;
        ActualCompletionTime = objectArg_2.Field("actualCompletionTime", timespan);
        let Date$;
        const objectArg_3 = get$.Required;
        Date$ = objectArg_3.Field("date", datetimeOffset);
        let OverageTime;
        const objectArg_4 = get$.Required;
        OverageTime = objectArg_4.Field("overageTime", timespan);
        return new Dashboard_ProjectBreakdown_ByDate_ProjectByDateBreakdown(Date$, Completed, (objectArg_5 = get$.Required, objectArg_5.Field("planned", uncurry2(int))), EstimatedCompletionTime, ActualCompletionTime, OverageTime, (objectArg_6 = get$.Required, objectArg_6.Field("attributeCount", uncurry2(Dashboard_ProjectBreakdown_attributeDateFreeDecoder))));
    }, path_4, v));
}

export function Dashboard_ProjectBreakdown_ByDate_ProjectByDateBreakdown_Encoder_Z7EA00D56(x) {
    return object_1([["completed", x.Completed], ["estimatedCompletionTime", timespan_1(x.EstimatedCompletionTime)], ["actualCompletionTime", timespan_1(x.ActualCompletionTime)], ["date", datetimeOffset_1(x.Date)], ["overageTime", timespan_1(x.OverageTime)], ["planned", x.Planned], ["attributeCount", Dashboard_ProjectBreakdown_attributeDateFreeEncoder(x.AttributeCount)]]);
}

export class Dashboard_ProjectBreakdown_ByLabel_ProjectByLabelBreakdown extends Record {
    constructor(LabelValue, Completed, Planned, PlannedDate, Total, Behind, EstimatedCompletionTime, ActualCompletionTime, OverageTime) {
        super();
        this.LabelValue = LabelValue;
        this.Completed = (Completed | 0);
        this.Planned = (Planned | 0);
        this.PlannedDate = PlannedDate;
        this.Total = (Total | 0);
        this.Behind = (Behind | 0);
        this.EstimatedCompletionTime = EstimatedCompletionTime;
        this.ActualCompletionTime = ActualCompletionTime;
        this.OverageTime = OverageTime;
    }
}

export function Dashboard_ProjectBreakdown_ByLabel_ProjectByLabelBreakdown_$reflection() {
    return record_type("Types.Dashboard.ProjectBreakdown.ByLabel.ProjectByLabelBreakdown", [], Dashboard_ProjectBreakdown_ByLabel_ProjectByLabelBreakdown, () => [["LabelValue", string_type], ["Completed", int32_type], ["Planned", int32_type], ["PlannedDate", option_type(class_type("System.DateTimeOffset"))], ["Total", int32_type], ["Behind", int32_type], ["EstimatedCompletionTime", class_type("System.TimeSpan")], ["ActualCompletionTime", class_type("System.TimeSpan")], ["OverageTime", class_type("System.TimeSpan")]]);
}

export function Dashboard_ProjectBreakdown_ByLabel_ProjectByLabelBreakdown_get_Decoder() {
    return (path_5) => ((v) => object((get$) => {
        let objectArg_2, objectArg_3, objectArg_4, objectArg_5, objectArg_6, objectArg_7, objectArg_8;
        let Total;
        const objectArg = get$.Required;
        Total = objectArg.Field("total", uncurry2(int));
        let Completed;
        const objectArg_1 = get$.Required;
        Completed = objectArg_1.Field("completed", uncurry2(int));
        return new Dashboard_ProjectBreakdown_ByLabel_ProjectByLabelBreakdown((objectArg_2 = get$.Required, objectArg_2.Field("labelValue", string)), Completed, (objectArg_3 = get$.Required, objectArg_3.Field("planned", uncurry2(int))), (objectArg_4 = get$.Optional, objectArg_4.Field("plannedDate", datetimeOffset)), Total, (objectArg_5 = get$.Required, objectArg_5.Field("behind", uncurry2(int))), (objectArg_6 = get$.Required, objectArg_6.Field("estimatedCompletionTime", timespan)), (objectArg_7 = get$.Required, objectArg_7.Field("actualCompletionTime", timespan)), (objectArg_8 = get$.Required, objectArg_8.Field("overageTime", timespan)));
    }, path_5, v));
}

export function Dashboard_ProjectBreakdown_ByLabel_ProjectByLabelBreakdown_Encoder_Z6D739416(x) {
    return object_1([["total", x.Total], ["completed", x.Completed], ["estimatedCompletionTime", timespan_1(x.EstimatedCompletionTime)], ["actualCompletionTime", timespan_1(x.ActualCompletionTime)], ["overageTime", timespan_1(x.OverageTime)], ["labelValue", x.LabelValue], ["behind", x.Behind], ["planned", x.Planned], ["plannedDate", option(datetimeOffset_1)(x.PlannedDate)]]);
}

export class Dashboard_Handover_Total extends Record {
    constructor(Completed, Behind, Total) {
        super();
        this.Completed = (Completed | 0);
        this.Behind = (Behind | 0);
        this.Total = (Total | 0);
    }
}

export function Dashboard_Handover_Total_$reflection() {
    return record_type("Types.Dashboard.Handover.Total", [], Dashboard_Handover_Total, () => [["Completed", int32_type], ["Behind", int32_type], ["Total", int32_type]]);
}

export function Dashboard_Handover_Total_get_Decoder() {
    return (path) => ((v) => object((get$) => {
        let objectArg_1, objectArg_2;
        let Total;
        const objectArg = get$.Required;
        Total = objectArg.Field("total", uncurry2(int));
        return new Dashboard_Handover_Total((objectArg_1 = get$.Required, objectArg_1.Field("completed", uncurry2(int))), (objectArg_2 = get$.Required, objectArg_2.Field("behind", uncurry2(int))), Total);
    }, path, v));
}

export function Dashboard_Handover_Total_Encoder_Z106FFC95(x) {
    return object_1([["total", x.Total], ["completed", x.Completed], ["behind", x.Behind]]);
}

export class Dashboard_Handover_Discipline extends Record {
    constructor(DisciplineId, DisciplineName) {
        super();
        this.DisciplineId = DisciplineId;
        this.DisciplineName = DisciplineName;
    }
}

export function Dashboard_Handover_Discipline_$reflection() {
    return record_type("Types.Dashboard.Handover.Discipline", [], Dashboard_Handover_Discipline, () => [["DisciplineId", class_type("System.Guid")], ["DisciplineName", string_type]]);
}

export function Dashboard_Handover_Discipline_get_Decoder() {
    return (path_3) => ((value_1) => andThen(uncurry3((s) => {
        const split = ofArray(split_1(s, [":"], 2, 0));
        let matchResult, id, name;
        if (!isEmpty(split)) {
            if (!isEmpty(tail(split))) {
                if (isEmpty(tail(tail(split)))) {
                    matchResult = 0;
                    id = head(split);
                    name = head(tail(split));
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                let matchValue;
                let outArg = "00000000-0000-0000-0000-000000000000";
                matchValue = [tryParse(id, new FSharpRef(() => outArg, (v) => {
                    outArg = v;
                })), outArg];
                if (matchValue[0]) {
                    const output = new Dashboard_Handover_Discipline(matchValue[1], name);
                    return (arg10$0040) => ((arg20$0040) => succeed(output, arg10$0040, arg20$0040));
                }
                else {
                    return (path_1) => ((arg20$0040_1) => fail("Discipline id is not a guid", path_1, arg20$0040_1));
                }
            }
            default:
                return (path_2) => ((arg20$0040_2) => fail("Missing parts of the discipline id", path_2, arg20$0040_2));
        }
    }), string, path_3, value_1));
}

export function Dashboard_Handover_Discipline_Encoder_70137EE3(x) {
    return `${x.DisciplineId}:${x.DisciplineName}`;
}

const Dashboard_Handover_disciplineDecoder = (() => {
    const d = dict(uncurry2(Dashboard_Handover_Total_get_Decoder()));
    return (path) => ((value) => map((m) => ofSeq(choose((kv) => {
        const matchValue = fromString(uncurry2(Dashboard_Handover_Discipline_get_Decoder()), kv[0]);
        if (matchValue.tag === 1) {
            return undefined;
        }
        else {
            return [matchValue.fields[0], kv[1]];
        }
    }, m), {
        Compare: compare,
    }), uncurry2(d), path, value));
})();

export class Dashboard_Handover_SubsystemByDiscipline extends Record {
    constructor(SubsystemId, SystemId, SystemName, SubsystemName, SubsystemDetail, PlannedDate, Total, Breakdown) {
        super();
        this.SubsystemId = SubsystemId;
        this.SystemId = SystemId;
        this.SystemName = SystemName;
        this.SubsystemName = SubsystemName;
        this.SubsystemDetail = SubsystemDetail;
        this.PlannedDate = PlannedDate;
        this.Total = Total;
        this.Breakdown = Breakdown;
    }
}

export function Dashboard_Handover_SubsystemByDiscipline_$reflection() {
    return record_type("Types.Dashboard.Handover.SubsystemByDiscipline", [], Dashboard_Handover_SubsystemByDiscipline, () => [["SubsystemId", class_type("System.Guid")], ["SystemId", class_type("System.Guid")], ["SystemName", string_type], ["SubsystemName", string_type], ["SubsystemDetail", string_type], ["PlannedDate", option_type(class_type("System.DateTimeOffset"))], ["Total", Dashboard_Handover_Total_$reflection()], ["Breakdown", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Dashboard_Handover_Discipline_$reflection(), Dashboard_Handover_Total_$reflection()])]]);
}

export function Dashboard_Handover_SubsystemByDiscipline_get_Decoder() {
    return (path_6) => ((v) => object((get$) => {
        let objectArg_4, objectArg_5, arg_13, objectArg_6, objectArg_7;
        let SubsystemId;
        const objectArg = get$.Required;
        SubsystemId = objectArg.Field("subsystemId", guid);
        let SystemName;
        const objectArg_1 = get$.Required;
        SystemName = objectArg_1.Field("systemName", string);
        let SubsystemName;
        const objectArg_2 = get$.Required;
        SubsystemName = objectArg_2.Field("subsystemName", string);
        let SubsystemDetail;
        const objectArg_3 = get$.Required;
        SubsystemDetail = objectArg_3.Field("subsystemDetail", string);
        return new Dashboard_Handover_SubsystemByDiscipline(SubsystemId, (objectArg_4 = get$.Required, objectArg_4.Field("systemId", guid)), SystemName, SubsystemName, SubsystemDetail, (objectArg_5 = get$.Optional, objectArg_5.Field("plannedDate", datetimeOffset)), (arg_13 = Dashboard_Handover_Total_get_Decoder(), (objectArg_6 = get$.Required, objectArg_6.Field("total", uncurry2(arg_13)))), (objectArg_7 = get$.Required, objectArg_7.Field("breakdown", uncurry2(Dashboard_Handover_disciplineDecoder))));
    }, path_6, v));
}

export function Dashboard_Handover_SubsystemByDiscipline_Encoder_74CB2279(x) {
    return object_1([["subsystemId", guid_1(x.SubsystemId)], ["systemId", guid_1(x.SystemId)], ["subsystemName", x.SubsystemName], ["systemName", x.SystemName], ["subsystemDetail", x.SubsystemDetail], ["plannedDate", option(datetimeOffset_1)(x.PlannedDate)], ["total", Dashboard_Handover_Total_Encoder_Z106FFC95(x.Total)], ["breakdown", dict_1(ofSeq(map_2((keyValue) => [toString(4, Dashboard_Handover_Discipline_Encoder_70137EE3(keyValue[0])), Dashboard_Handover_Total_Encoder_Z106FFC95(keyValue[1])], x.Breakdown), {
        Compare: comparePrimitives,
    }))]]);
}

const Dashboard_Handover_maturityDecoder = (() => {
    let decoder;
    const d = dict(uncurry2((decoder = Dashboard_Handover_SubsystemByDiscipline_get_Decoder(), (path) => ((value) => list_4(uncurry2(decoder), path, value)))));
    return (path_1) => ((value_1) => map((m) => ofSeq(choose((kv) => {
        const matchValue = fromString(uncurry2(EPM_Domain_Events_Maturity__Maturity_get_Decoder_Static()), kv[0]);
        if (matchValue.tag === 1) {
            return undefined;
        }
        else {
            return [matchValue.fields[0], kv[1]];
        }
    }, m), {
        Compare: compare,
    }), uncurry2(d), path_1, value_1));
})();

export class Dashboard_Handover_Handover extends Record {
    constructor(Overall, All, Breakdown) {
        super();
        this.Overall = Overall;
        this.All = All;
        this.Breakdown = Breakdown;
    }
}

export function Dashboard_Handover_Handover_$reflection() {
    return record_type("Types.Dashboard.Handover.Handover", [], Dashboard_Handover_Handover, () => [["Overall", Dashboard_Handover_Total_$reflection()], ["All", list_type(Dashboard_Handover_SubsystemByDiscipline_$reflection())], ["Breakdown", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Maturity_$reflection(), list_type(Dashboard_Handover_SubsystemByDiscipline_$reflection())])]]);
}

export function Dashboard_Handover_Handover_get_Decoder() {
    return (path_1) => ((v) => object((get$) => {
        let arg_1, objectArg, arg_3, decoder, objectArg_1, objectArg_2;
        return new Dashboard_Handover_Handover((arg_1 = Dashboard_Handover_Total_get_Decoder(), (objectArg = get$.Required, objectArg.Field("overall", uncurry2(arg_1)))), (arg_3 = ((decoder = Dashboard_Handover_SubsystemByDiscipline_get_Decoder(), (path) => ((value) => list_4(uncurry2(decoder), path, value)))), (objectArg_1 = get$.Required, objectArg_1.Field("all", uncurry2(arg_3)))), (objectArg_2 = get$.Required, objectArg_2.Field("breakdown", uncurry2(Dashboard_Handover_maturityDecoder))));
    }, path_1, v));
}

export function Dashboard_Handover_Handover_Encoder_21C5ACA4(x) {
    return object_1([["overall", Dashboard_Handover_Total_Encoder_Z106FFC95(x.Overall)], ["all", list_5(map_3(Dashboard_Handover_SubsystemByDiscipline_Encoder_74CB2279, x.All))], ["breakdown", dict_1(ofSeq(map_2((keyValue) => [toString(4, EPM_Domain_Events_Maturity__Maturity_Encoder_Static_4DC9A197(keyValue[0])), list_5(map_3(Dashboard_Handover_SubsystemByDiscipline_Encoder_74CB2279, keyValue[1]))], x.Breakdown), {
        Compare: comparePrimitives,
    }))]]);
}

export class Definition_Definition extends Record {
    constructor(Total, EntityId, ParentEntityId, EntityType, EntityName) {
        super();
        this.Total = Total;
        this.EntityId = EntityId;
        this.ParentEntityId = ParentEntityId;
        this.EntityType = EntityType;
        this.EntityName = EntityName;
    }
}

export function Definition_Definition_$reflection() {
    return record_type("Types.Definition.Definition", [], Definition_Definition, () => [["Total", float64_type], ["EntityId", option_type(class_type("System.Guid"))], ["ParentEntityId", option_type(class_type("System.Guid"))], ["EntityType", option_type(DomainEntities_$reflection())], ["EntityName", option_type(string_type)]]);
}

export function Definition_Definition_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2, arg_7, objectArg_3, objectArg_4;
        return new Definition_Definition((objectArg = get$.Required, objectArg.Field("total", float)), (objectArg_1 = get$.Optional, objectArg_1.Field("entityId", guid)), (objectArg_2 = get$.Optional, objectArg_2.Field("parentEntityId", guid)), (arg_7 = EPM_Domain_Events_DomainEntities__DomainEntities_get_Decoder_Static(), (objectArg_3 = get$.Optional, objectArg_3.Field("entityType", uncurry2(arg_7)))), (objectArg_4 = get$.Optional, objectArg_4.Field("name", string)));
    }, path_4, v));
}

export function Definition_Definition_Encoder_Z9CC7072(x) {
    return object_1([["total", x.Total], ["entityId", option(guid_1)(x.EntityId)], ["parentEntityId", option(guid_1)(x.ParentEntityId)], ["entityType", option(EPM_Domain_Events_DomainEntities__DomainEntities_Encoder_Static_Z485ADA6F)(x.EntityType)], ["name", option((value_3) => value_3)(x.EntityName)]]);
}

export class Definition_TagsByEquipmentType extends Record {
    constructor(Total, EquipmentTypeId, EquipmentTypeName) {
        super();
        this.Total = (Total | 0);
        this.EquipmentTypeId = EquipmentTypeId;
        this.EquipmentTypeName = EquipmentTypeName;
    }
}

export function Definition_TagsByEquipmentType_$reflection() {
    return record_type("Types.Definition.TagsByEquipmentType", [], Definition_TagsByEquipmentType, () => [["Total", int32_type], ["EquipmentTypeId", class_type("System.Guid")], ["EquipmentTypeName", string_type]]);
}

export function Definition_TagsByEquipmentType_get_Decoder() {
    return (path_2) => ((v) => object((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Definition_TagsByEquipmentType((objectArg = get$.Required, objectArg.Field("total", uncurry2(int))), (objectArg_1 = get$.Required, objectArg_1.Field("equipmentTypeId", guid)), (objectArg_2 = get$.Required, objectArg_2.Field("equipmentTypeName", string)));
    }, path_2, v));
}

export function Definition_TagsByEquipmentType_Encoder_Z490410AD(x) {
    return object_1([["total", x.Total], ["equipmentTypeId", guid_1(x.EquipmentTypeId)], ["equipmentTypeName", x.EquipmentTypeName]]);
}

